
const sharedVoiceReasons = {
  "not_granted": "Váš účet nemá oprávnenie na hlas.",
  "disabled": "Hlasový režim je vypnutý.",
  "spend_limit": "Bol dosiahnutý mesačný limit výdavkov.",
  "provider_error": "Hlasová služba zlyhala. Skúste to znova.",
};

export const sk = {
  // Browser mirror of src/push/messages.ts; tests/contract/pushCopy.test.ts pins the server copy.
  pushFailure: {"title":"Konverzácia zlyhala","provider":"Chyba poskytovateľa AI","chetty":"Chyba Chettyho"},
  totp: {
    qrTitle: "QR kód",
    title: "Dvojfázové overenie",
    description: "Prihlásenie heslom ochránite šesťmiestnym kódom z overovacej aplikácie. Prihlásenie cez Microsoft sa riadi pravidlami Vašej organizácie.",
    code: "Kód z overovacej aplikácie",
    codeValidFor: "Kód je platný ešte {seconds} s",
    codeSecondsLeft: "{seconds} s",
    verify: "Overiť",
    loginTitle: "Overte prihlásenie",
    lost: "Stratili ste overovaciu aplikáciu? Obráťte sa na iného správcu. Záložné kódy ani obídenie heslom nie sú k dispozícii.",
    invalid: "Kód sa nepodarilo overiť. Počkajte na nový kód alebo začnite prihlásenie znova.",
    expired: "Overenie vypršalo. Začnite znova.",
    enable: "Zapnúť dvojfázové overenie",
    confirm: "Potvrdiť a zapnúť",
    disable: "Vypnúť dvojfázové overenie",
    disabled: "Vypnuté",
    enabled: "Zapnuté",
    enabledAt: "Zapnuté {date}",
    trusted: "Táto relácia je dôveryhodná do {date}.",
    untrusted: "Pri tejto relácii nie je zaznamenané overenie druhým faktorom.",
    trustWarning: "Dôvera platí počas nastavenej doby relácie, nie podľa samostatného nastavenia zariadenia. Kto získa súbor cookie tejto relácie, má prístup k účtu až do vypršania alebo odvolania.",
    adminWarning: "Pred zapnutím zabezpečte ďalšieho správcu alebo funkčné prihlásenie cez Microsoft. Jediný správca, ktorý stratí overovaciu aplikáciu, nemá možnosť obnovy. Záložné kódy, skrytý reset ani obnova cez CLI neexistujú.",
    password: "Súčasné heslo",
    passwordRefused: "Súčasné heslo sa nepodarilo overiť.",
    setup: "Naskenujte QR kód v overovacej aplikácii alebo zadajte nastavovací kľúč ručne.",
    manualKey: "Nastavovací kľúč",
    copyKey: "Kopírovať nastavovací kľúč",
    copied: "Nastavovací kľúč skopírovaný",
    qrAlt: "QR kód pre overovaciu aplikáciu",
    qrFailed: "QR kód sa nepodarilo vytvoriť. Zadajte nastavovací kľúč ručne.",
    expires: "Nastavenie vyprší {date}.",
    pending: "Existuje nedokončené nastavenie, ale jeho kľúč už nemožno zobraziť. Zrušte ho a začnite znova.",
    cancelSetup: "Zrušiť nastavenie",
    disableWarning: "Použite nový, dosiaľ nepoužitý kód. Vypnutie odhlási všetky relácie vrátane tejto. API tokeny a spárované zariadenia zostanú bez zmeny.",
    loadError: "Bezpečnostné údaje sa nepodarilo načítať.",
    actionError: "Akciu sa nepodarilo dokončiť. Pred opakovaním overte aktuálny stav.",
    cleanupUnverified: "Zmena bola uložená, ale uzavretie relácií sa nepodarilo overiť.",
    stale: "Bezpečnostné nastavenie sa zmenilo alebo nastavenie vypršalo. Načítajte aktuálny stav.",
    sessions: "Prihlásené relácie",
    sessionsHint: "Názov vychádza z údajov prehliadača pri prihlásení. Odvolanie relácie krátko znovu pripojí ostatné spojenia tohto účtu v prehliadači.",
    unknownDevice: "Neznáme zariadenie",
    current: "Súčasná relácia",
    started: "Začiatok {date}",
    expiresSession: "Vyprší {date}",
    methodPassword: "Heslo",
    methodTotp: "Heslo a overovacia aplikácia",
    methodSso: "Microsoft",
    revoke: "Odvolať reláciu",
    revokeTitle: "Odvolať túto reláciu?",
    revokeBody: "Táto relácia bude odhlásená. Ostatné spojenia účtu v prehliadači sa krátko znovu pripoja. API tokeny a spárované zariadenia zostanú bez zmeny.",
    emptySessions: "Žiadne prihlasovacie relácie.",
    loadMore: "Načítať ďalšie",
    reset: "Resetovať dvojfázové overenie",
    resetTitle: "Resetovať overenie účtu {name}?",
    resetBody: "Najprv nezávisle overte totožnosť používateľa. Reset vypne jeho overenie a odhlási všetky jeho relácie v prehliadači. Používateľ musí overenie znovu nastaviť. Nejde o samoobslužnú obnovu.",
    proofPassword: "Použiť moje heslo",
    proofSso: "Použiť moje nedávne prihlásenie cez Microsoft",
    proofSsoHint: "Vyžaduje prihlásenie cez Microsoft za posledných päť minút. Inak sa odhláste a znova prihláste cez Microsoft.",
    resetSuccess: "Dvojfázové overenie resetované.",
    resetError: "Reset bol odmietnutý alebo ho nemožno potvrdiť. Pred opakovaním znovu načítajte účet.",
    rateRetry: "Príliš veľa pokusov. Skúste to znova o {seconds} sekúnd.",
  },
  connectionStatus: {
    computerOffline: 'Počítač {computer} je offline; práca zostáva zachovaná',
    unknown: 'Stav pripojenia nie je známy',
    connected: 'Pripojené',
    connecting: 'Pripájanie',
    disconnected: 'Odpojené',
    pending: 'Čaká sa na dokončenie prípravy',
    stale: 'Posledný známy stav; aktuálny stav nie je známy',
    freshnessUnknown: 'Aktuálnosť údaja nie je známa',
    transport: 'Pripojenie',
    model: 'Požiadavka na model',
    waitingForComputer: 'Čaká sa na počítač projektu; práca zostáva zachovaná',
    remoteRetryUnknown: 'Priebeh opakovania na vzdialenej strane nie je známy',
  },
  connectionFailure: {
    startFailed: 'Konverzáciu sa nepodarilo otvoriť',
    policyUnavailable: 'Nastavenia opakovania pripojenia nie sú dostupné',
    streamFailed: 'Pripojenie zlyhalo',
  },
  /** Labels of the closed menu-action vocabulary (`components/ui/menuActions.ts`). */
  menuActions: {
    delete: 'Vymazať',
    remove: 'Odstrániť',
    edit: 'Upraviť',
    replace: 'Nahradiť',
    rename: 'Premenovať',
    duplicate: 'Duplikovať',
    copy: 'Kopírovať',
    enable: 'Zapnúť',
    disable: 'Vypnúť',
    archive: 'Archivovať',
    restore: 'Obnoviť',
    reset: 'Obnoviť predvolené',
    open: 'Otvoriť',
    view: 'Detail',
    move: 'Presunúť',
    pin: 'Pripnúť',
    unpin: 'Odopnúť',
    mute: 'Stlmiť',
    unmute: 'Zrušiť stlmenie',
    download: 'Stiahnuť',
    select: 'Vybrať',
    add: 'Pridať',
    settings: 'Nastavenia',
    update: 'Aktualizovať',
    invite: 'Pozvať',
    leave: 'Opustiť',
    connect: 'Pripojiť',
    disconnect: 'Odpojiť',
  },
  conversationIcon: { title: 'Ikona konverzácie', change: 'Zmeniť ikonu: {title}' },
  identityIcons: {
    Briefcase: 'Aktovka',
    Server: 'Server',
    Database: 'Databáza',
    Heart: 'Srdce',
    Code: 'Kód',
    Home: 'Dom',
    Star: 'Hviezda',
    Folder: 'Priečinok',
    Globe: 'Zemeguľa',
    Book: 'Kniha',
    Cpu: 'Procesor',
    Terminal: 'Terminál',
    Rocket: 'Raketa',
    Lightbulb: 'Žiarovka',
    Target: 'Terč',
    Calendar: 'Kalendár',
    DollarSign: 'Dolár',
    ShoppingCart: 'Nákupný košík',
    Music: 'Hudba',
    Camera: 'Fotoaparát',
    MapPin: 'Miesto na mape',
    Zap: 'Blesk',
    Flag: 'Vlajka',
    Bookmark: 'Záložka',
    MessageCircle: 'Chatová bublina',
  },
  voice: {
    "settingsSection": "Hlasový režim",
    "accountSection": "Hlas",
    "settingsHint": "Poskytovateľ, modely a dĺžka hovorov.",
    "accountHint": "Váš hlas, jazyk a spätné volanie.",
    "settings": {
      "title": "Hlasový režim",
      "enabled": "Zapnuté",
      "enabledHint": "Hovory a hlasové správy používajú poskytovateľa nastaveného pre túto inštanciu. Každý účet musí mať aj oprávnenie na hlas.",
      "provider": "Poskytovateľ",
      "providerHint": "Podporovaní sú poskytovatelia OpenAI alebo Azure OpenAI s API kľúčom. Azure vyžaduje adresu .../openai/v1 a nasadenie Global Standard s rovnakým názvom ako každý model.",
      "chooseProvider": "Vyberte poskytovateľa",
      "callModel": "Model pre hovory",
      "callModelHint": "Hovory s GPT-Live 1 stoja 0,05 USD za minútu a účtujú sa po sekundách, vrátane čakania. Práca pre konverzáciu sa účtuje samostatne.",
      "transcriptionModel": "Model pre prepis",
      "dictationModel": "Model pre diktovanie",
      "dictationModelHint": "Prepisuje Vašu reč do poľa správy, kým hovoríte. Účtuje sa po minútach zvuku.",
      "speechModel": "Model pre reč",
      "maxCallSeconds": "Maximálna dĺžka hovoru",
      "ringSeconds": "Doba zvonenia",
      "seconds": "{n} s",
      "holdSeconds": "Čakanie na linke",
      "holdSecondsHint": "Ako dlho Chetty čaká na linke na výsledok úlohy. Čakanie je súčasťou plateného hovoru. Po tejto dobe sa rozlúči a po dokončení zavolá späť, ak máte v účte zapnuté spätné volanie. Pri hodnote 0 sa rozlúči hneď.",
      "holdSecondsNever": "Bez čakania",
      "contextMessages": "Správy, ktoré Chetty v hovore pozná",
      "contextMessagesHint": "Koľko posledných písaných správ si Chetty pred hovorom prečíta. Výsledky nástrojov sa nezapočítavajú. Viac správ znamená lepší prehľad bez zmeny sadzby hovoru.",
      "noProvider": "Žiadny vhodný poskytovateľ",
      "noProviderHint": "Pridajte v nastaveniach AI poskytovateľa OpenAI alebo Azure OpenAI s API kľúčom. Azure vyžaduje adresu .../openai/v1 a nasadenie Global Standard s rovnakým názvom ako každý model.",
      "chooseModels": "Pred zapnutím hlasu vyberte podporovaného poskytovateľa a ponúkané modely.",
      "loadError": "Nastavenia hlasu sa nepodarilo načítať."
    },
    "account": {
      "title": "Hlas",
      "voice": "Hlas",
      "voiceHint": "Hlas, ktorým s Vami Chettym hovorí počas hovorov. Ukážku si prehráte ikonou reproduktora.",
      "playSample": "Prehrať ukážku hlasu {voice}",
      "stopSample": "Zastaviť ukážku hlasu {voice}",
      "presentation": {
        "feminine": "Ženský",
        "masculine": "Mužský"
      },
      "accent": {
        "australian": "austrálska angličtina",
        "british": "britská angličtina",
        "irish": "írska angličtina",
        "northAmerican": "americká angličtina",
        "brazilian": "brazílska portugalčina",
        "filipino": "filipínska angličtina",
        "southernUs": "angličtina z juhu USA"
      },
      "language": "Jazyk",
      "languageHint": "Jazyk účtu používa jazyk nastavený vo Vašom účte. Možno zadať aj iný kód jazyka.",
      "accountLanguage": "Jazyk účtu",
      "czech": "Čeština",
      "slovak": "Slovenčina",
      "english": "Angličtina",
      "customLanguage": "Iný jazyk",
      "languageCode": "Kód jazyka",
      "callback": "Zavolať mi späť",
      "callbackHint": "Po hlasovom zadaní Vám Chetty môže zavolať, keď potrebuje odpoveď alebo keď má hotový výsledok.",
      "dictationPause": "Ukončiť diktovanie po pauze",
      "dictationPauseHint": "Keď takto dlho nehovoríte, diktovanie sa samo ukončí a text zostane v poli. Odoslať ho môžete kedykoľvek aj počas diktovania.",
      "dictationPauseNever": "Nikdy",
      "unavailable": "Hlas nie je dostupný",
      "unavailableHint": "Správca musí nastaviť podporovaného poskytovateľa a modely. Jazyk a spätné volanie môžete meniť aj teraz.",
      "loadError": "Hlasové predvoľby sa nepodarilo načítať."
    },
    "permission": {
      "title": "Prístup k hlasu",
      "allow": "Povoliť hlas",
      "hint": "Umožňuje hovory, spätné volanie a hlasové správy. Oprávnenie potrebujú aj správcovia."
    },
    operations: {
      "kind": "Operácia",
      "reason": "Dôvod",
      "status": {
        "submitted": "Odovzdané do konverzácie",
        "started": "Začaté",
        "succeeded": "Dokončené",
        "failed": "Zlyhalo",
        "cancelled": "Zrušené"
      },
      "kinds": {
        "interpretation": "Spracovanie zadania",
        "work": "Práca",
        "answers": "Odpovede",
        "clarify": "Spresnenie",
        "end": "Ukončenie hovoru",
        "callback": "Spätné volanie"
      },
      "reasons": {
        "policy_refusal": "Odmietnuté pre zásady používania poskytovateľa",
        "refusal": "Požiadavka odmietnutá",
        "quota": "Vyčerpaná kvóta",
        "rate_limit": "Dosiahnutý limit požiadaviek",
        "unavailable": "Služba nie je dostupná",
        "timeout": "Vypršal časový limit",
        "tool_error": "Nástroj zlyhal",
        "invalid_response": "Neplatná odpoveď",
        "cancelled": "Zrušené",
        "unknown": "Neznáma chyba"
      }
    },
    "transcript": {
      "title": "Prepis hovoru",
      "call": "Hovor",
      "user": "Vy",
      "assistant": "Chetty",
      "empty": "Prepis nie je k dispozícii"
    },
    actionsGroup: "Hlas",
    dictation: {
      "start": "Diktovať",
      "hint": "Písať hlasom do poľa na správu",
      "stop": "Hotovo",
      "cancel": "Zrušiť diktovanie",
      "recording": "Nahrávam",
      "transcribing": "Prepisujem…",
      "errors": {
        ...sharedVoiceReasons,
        "mic_denied": "Prístup k mikrofónu bol zamietnutý. Povoľte ho a skúste to znova.",
        "dictation_active": "Na Vašom účte už prebieha diktovanie. Pred ďalším spustením ho ukončite na inej karte.",
        "mic_failed": "Mikrofón sa nepodarilo použiť.",
        "network": "Diktovanie stratilo spojenie. Skontrolujte pripojenie a skúste to znova.",
      }
    },
    call: {
      "start": "Hovor",
      "hint": "Zadať úlohu hlasom a počuť výsledok",
      "hangup": "Zavesiť",
      "close": "Zavrieť",
      "states": {
        "connecting": "Pripájanie…",
        "listening": "Počúvanie",
        "speaking": "Chetty hovorí",
        "on_hold": "Chetty pracuje",
        "ending": "Ukončovanie hovoru…"
      },
      "reasons": {
        ...sharedVoiceReasons,
        "unknown_session": "Konverzácia už neexistuje.",
        "call_active": "Už prebieha iný hlasový hovor.",
        "callback_unavailable": "Toto spätné volanie už nie je dostupné.",
        "question_not_pending": "Otázka už nečaká na odpoveď.",
        "voice_unavailable": "Hlasová služba nie je dostupná.",
        "provider_unavailable": "Nie je dostupný vhodný poskytovateľ ani podporovaný model so známou cenou.",
        "mic_denied": "Prístup k mikrofónu bol zamietnutý. Povoľte ho a skúste to znova.",
        "disconnected": "Spojenie bolo prerušené.",
        "daemon_restart": "Služba sa reštartovala.",
        "hangup": "Hovor skončil.",
        "completed": "Vaše zadanie bolo odoslané.",
        "max_duration": "Bola dosiahnutá maximálna dĺžka hovoru.",
        "silence": "Hovor skončil kvôli neaktivite."
      }
    },
    ring: {
      "acceptUnavailable": "Hlasové hovory teraz nie sú dostupné.",
      "title": "Prichádzajúci hovor",
      "doneTitle": "Chetty má výsledok",
      "accept": "Prijať",
      "decline": "Odmietnuť",
      "close": "Zavrieť",
      "loading": "Overovanie hovoru…",
      "stale": "Tento hovor už nie je dostupný.",
      "error": "Hovor sa nepodarilo overiť. Skúste to znova.",
      "declineError": "Hovor sa nepodarilo odmietnuť. Skúste to znova.",
      "timeout": "Platnosť hovoru vypršala.",
      "declined": "Hovor bol odmietnutý.",
      "accepted": "Hovor bol prijatý.",
      "unavailable": "Tento účet už nemôže prijať tento hovor.",
      "settled": "Otázka už bola zodpovedaná.",
      "restart": "Služba sa reštartovala."
    },
  },
  spendLimit: {
    section: "Limit a útrata",
    unlimited: "Bez obmedzenia",
    limit: "Mesačný limit",
    spent: "Výdavky",
    reset: "Obnovenie limitu",
    resetUsage: "Vynulovať limit",
    limitHint: "Po dosiahnutí tejto sumy účet do obnovenia limitu nespustí ďalšiu prácu.",
    resetHint: "Kedy sa mesačný limit obnoví.",
    resetUsageHint: "Výdavky sa do limitu tohto mesiaca začnú počítať znova od nuly, štatistiky a konverzácie zostanú zachované.",
    spentHint: "Koľko sa za tento mesiac na účte spotrebovalo.",
    resetTitle: "Vynulovať mesačný limit?",
    resetDescription: "Mesačný limit účtu {user} bude do konca tohto mesiaca počítať výdavky znova od nuly. Štatistiky, výdavky účtov poskytovateľov a konverzácie zostanú bez zmeny.",
    resetError: "Mesačný limit sa nepodarilo vynulovať.",
    readError: "Výdavky účtu sa nepodarilo načítať.",
    monthlyLimit: "Mesačný limit výdavkov bol dosiahnutý. Obnoví sa {date}.",
    unpricedModel: "Model nemá známu cenu a účet s limitom výdavkov ho nemôže používať. Mesačný limit sa obnoví {date}.",
    accountLimit: "Účet {account} je obmedzený svojím mesačným limitom výdavkov. Obnoví sa {date}.",
  },
  updateStatus: {
    prepareCoreTitle: "Pripraviť spoločnú aktualizáciu?",
    prepareCoreIntro: "Tento plugin potrebuje novšie Chetty. Príprava zahrnie aktualizáciu systému a overí pluginy cieľovou verziou. Nové oprávnenia budete schvaľovať samostatne; doterajšie súhlasy sa nemenia.",
    prepareCore: "Pripraviť systém aj pluginy",
    consentTitle: "Súhlas s pripravenou aktualizáciou",
    consentIntro: "Pluginy vyžadujúce nové oprávnenia zatiaľ neboli aktivované. Ostatné kompatibilné aktualizácie mohli medzitým prebehnúť. Potvrdenie schváli len uvedené balíky a rovno obnoví ich overenú aktualizáciu.",
    reviewConsent: "Zobraziť oprávnenia",
    approveConsent: "Schváliť a pokračovať",
    declineConsent: "Odmietnuť",
    consentError: "Rozhodnutie sa nepodarilo uložiť. Obnovte stav a skontrolujte aktuálnu otázku.",
    consentChanged: "Balík alebo súhlas sa zmenil. Obnovte stav. Ak sa zmenil balík, pred schválením pripravte aktualizáciu znova.",
    consentQueued: "Schválená aktualizácia je vo fronte.",
    consentDeclined: "Aktualizácia bola odmietnutá.",
    noNewGrants: "Bez nových oprávnení",
    notInstalled: "Nenainštalované",
    "updatesHeld": "Vydavateľ pozastavil nové vydania pre túto licenciu. Predtým dostupné verzie možno naďalej inštalovať a opravovať.",
    "title": "Stav aktualizácií",
    "error": "Stav aktualizácií sa nepodarilo načítať.",
    "queued": "Vo fronte",
    "downloading": "Sťahovanie balíka",
    "prepared": "Príprava",
    "quiescing": "Zastavovanie služieb",
    "applying": "Vykonávanie zmien",
    "verifying": "Overovanie spustenia",
    "committing": "Dokončovanie",
    "committed": "Dokončené",
    "rollingBack": "Obnovovanie predchádzajúcej verzie",
    "blocked": "Zablokované pred aktiváciou",
    "rolledBack": "Vrátené na predchádzajúcu verziu",
    "needsOperator": "Vyžaduje zásah správcu",
    "applied": "Vykonané",
    "needsConsent": "Vyžaduje súhlas",
    "notLicensed": "Chýba licencia",
    "superseded": "Zrušené pred spustením",
    "failed": "Nepodarilo sa",
    "skipped": "Preskočené",
    "noUpdate": "Už aktuálne",
    "repair": "Opraviť",
    "repairError": "O opravu sa nepodarilo požiadať.",
    "degraded": "Nenačítané",
  },
  problemReporting: {
    delivery: { idle: "Pripravené", sent: "Doručené", retry: "Opakovanie", credentials: "Neplatná licencia", unavailable: "Server nedostupný", storage: "Chyba úložiska" },
    label: "Hlásenie problémov",
    notice: "Odosielanie varovaní a chýb démona prevádzkovateľovi licenčného servera Chettyho. Hlásenia obsahujú kódy problémov, počty, úroveň varovania či chyby, skutočné názvy všetkých pluginov vrátane súkromných a nelicencovaných, verzie produktu a pluginov a pri každom probléme až tri ukážky textu chybovej správy. Hlásenia oneskorenia démona navyše obsahujú poslednú vzorku prostriedkov hostiteľa: CPU, RAM, kapacitu disku, rýchlosť diskového I/O a siete a čas merania. Pred uložením a odoslaním sa text skráti na 500 znakov a odstránia sa z neho kľúče, tokeny, heslá, cookies, parametre URL, e-mailové adresy, IP adresy, identifikátory a cesty k adresárom. Zvyšný text môže obsahovať názvy poskytovateľov, modelov, častí pluginov, hostiteľov alebo mená osôb. Chybové správy sú diagnostické, nejde o konverzácie ani spomienky a každé hlásenie odosiela redigovaný text správy, ktorú popisuje, vrátane správ, ktoré môžu niesť obsah správ alebo obchodné údaje zákazníkov. Hlásenia identifikujú túto licencovanú inštanciu a uchovávajú sa najviac 14 dní. Vypnutie vymaže neodoslané dávky, ale nemôže odvolať už prijaté údaje.",
    confirmTitle: "Zapnúť hlásenie problémov?",
    confirm: "Potvrdiť a zapnúť",
    loadError: "Stav hlásenia problémov sa nepodarilo načítať.",
  },
  guides: {
    count: { one: '{n} návod', few: '{n} návody', many: '{n} návodov' },
    enlargeImage: 'Zväčšiť obrázok: {alt}',
    aiPending: 'Pripravuje sa odpoveď z návodov…',
    "description": "Praktické postupy na prácu s Chettym.",
    "search": "Hľadať v návodoch",
    "clear": "Vymazať hľadanie",
    "categories": "Kategórie",
    "recommended": "Odporúčané návody",
    "empty": "Žiadne návody sa nenašli",
    "emptyDescription": "Skúste inú otázku alebo si prezrite kategórie.",
    "unavailable": "Návody sa nepodarilo načítať.",
    "notFound": "Tento návod alebo kategória neexistuje.",
    "notTranslated": "Nepreložené · K dispozícii v angličtine",
    "admin": "Pre správcov",
    "advanced": "Pre pokročilých",
    "advancedDescription": "Terminálová aplikácia, API, MCP, Projekty s terminálom a Gitom, sub-agenti a oprávnenia.",
    "adminDescription": "Sprevádzkovanie Chettyho, účty a prístupy, AI modely, pluginy, kanály a prevádzka.",
    "developer": "Pre vývojárov",
    "developerDescription": "Tvorba pluginov: manifest, rozhrania hostiteľa, HTTP cesty, dáta, prepojenie pluginov a vydávanie.",
    "everyday": "Návody na každý deň",
    "moreGuides": "Ďalšie návody",
    "reviewed": "Overené {date}",
    "outline": "Na tejto stránke",
    "copyLink": "Kopírovať odkaz",
    "previous": "Predchádzajúci návod",
    "next": "Ďalší návod",
    "related": "Súvisiace návody",
    "updates": "Súvisiace novinky",
    "updatesError": "Súvisiace novinky sa nepodarilo načítať.",
    "all": "Všetky návody",
    "results": "Nájdené návody: {count}",
    "filter": "Kategória: {category}",
    "aiUnavailable": "Odpovede AI nie sú dostupné. V návodoch môžete ďalej hľadať.",
    "aiDenied": "Váš účet nemá prístup k modelu pre odpovede.",
    "aiLimited": "Bol dosiahnutý limit odpovedí. Skúste to neskôr.",
    "aiFailed": "Odpoveď AI sa nepodarilo načítať.",
    "aiEmpty": "Dokumentácia neobsahuje odpoveď na túto otázku.",
    apiReference: {
      title: 'Endpointy, ktoré môžete volať',
      search: 'Hľadať endpointy',
      clear: 'Vymazať hľadanie',
      count: { one: '{n} endpoint', few: '{n} endpointy', many: '{n} endpointov' },
      results: 'Zobrazených {shown} z {total} nájdených endpointov',
      unavailable: 'Katalóg API sa nepodarilo načítať.',
      searchError: 'Hľadanie endpointov sa nepodarilo dokončiť.',
      empty: 'Žiadne dostupné endpointy',
      emptyDescription: 'Váš účet nemôže na tejto inštancii volať žiadny endpoint.',
      noResults: 'Žiadne zodpovedajúce endpointy',
      noResultsDescription: 'Skúste iné slová alebo hľadanie vymažte a prejdite všetky endpointy.',
      core: 'Jadro Chettyho',
      coreDescription: 'Konverzácie, Projekty, účty, pamäť, nastavenia a zvyšok základnej aplikácie.',
      anyMethod: 'Ľubovoľná metóda',
      detailError: 'Podrobnosti tohto endpointu sa nepodarilo načítať.',
      detailGone: 'Tento endpoint už Váš účet nemôže volať.',
      params: 'Parametre cesty',
      query: 'Parametre dopytu',
      body: 'Telo požiadavky',
      noInput: 'Tento endpoint neprijíma žiadny vstup.',
      noFields: 'Žiadne polia.',
      openSchema: 'Tu sa prijíma ľubovoľný JSON; endpoint svoje polia neuvádza.',
      required: 'Povinné',
      optional: 'Voliteľné',
      truncated: 'Schéma je rozsiahla, preto sú zobrazené len polia najvyššej úrovne.',
      adminOnly: 'Len pre správcov',
      response: { binary: 'Odpoveď so súborom', stream: 'Priebežná odpoveď' },
      noApiToken: 'Nie je dostupné s osobným API tokenom',
      noAgent: 'Nie je dostupné pre agenta',
      coreAdminNote: 'Endpointy jadra si oprávnenia správcu kontrolujú samy, takže tento môže účet bez roly správcu stále odmietnuť.',
      curlExample: 'curl s osobným API tokenom',
      elowenApiExample: 'Volanie nástroja ElowenApi',
      copy: 'Kopírovať',
    },
},
  nav: {
    resizeNavigation: 'Zmeniť šírku navigácie',
    guides: 'Návody',
    workingConversations: 'Prebiehajúce konverzácie',
    pinnedConversations: 'Pripnuté konverzácie',
    hideEntry: 'Skryť',
    moveUp: 'Posunúť nahor',
    moveDown: 'Posunúť nadol',
    showHidden: 'Zobraziť skryté',
    hiddenCount: 'Skryté ({count})',
    collapseShortcut: 'Ctrl / ⌘ + \\',
    sectionWork: 'Práca',
    sectionInstance: 'Inštancia',
    instanceMenu: 'Ponuka inštancie',
    home: 'Domov',
    chat: 'Chat',
    system: 'Systém',
    account: 'Účet',
    dashboard: 'Prehľad',
    settings: 'Nastavenia',
    projects: 'Projekty',
    users: 'Používatelia',
    memory: 'Pamäť',
  },
  page: {
    guides: 'Návody',
    dashboard: 'Prehľad',
    chat: 'Chat',
    settings: 'Nastavenia',
    projects: 'Projekty',
    users: 'Používatelia',
    memory: 'Pamäť',
  },
  stats: {
    cardTotalCost: 'Evidované náklady',
    cardTotalTokens: 'Celkovo tokenov',
    cardCache: 'Tokeny v medzipamäti',
    cardModelsUsed: 'Použité modely',
    emptyTitle: 'Zatiaľ žiadna spotreba',
    emptyDesc: 'Tokeny a náklady sa tu zobrazia, keď začnú bežať agenti.',
    modalTitle: 'Spotreba',
    model: 'Model',
    sectionConversation: 'Táto konverzácia',
    sectionModels: 'Všetky modely',
    contextLabel: 'Kontext',
    sessionTokens: 'Tokeny v tejto relácii',
    inputTokens: 'Vstupné tokeny',
    outputTokens: 'Výstupné tokeny',
    cacheHit: 'Podiel načítaný z medzipamäte',
    speed: 'Efektívna rýchlosť',
    arrowHint: '← → prepínanie sekcií',
    sectionContext: 'Kontext',
    contextWindow: 'Kontextové okno',
    contextReported: 'Hlásené poskytovateľom',
    contextBreakdown: 'Čo ho zapĺňa',
    contextEstimateNote: 'Rozdelenie je orientačné. Poskytovateľ počíta tokeny vlastným spôsobom.',
    contextEmptyTitle: 'Nie je čo merať',
    contextEmptyDesc: 'Otvorte konverzáciu a napíšte správu. Potom sa zobrazí jej aktuálny kontext.',
    contextCategory: {
      system: 'Systémový prompt',
      tools: 'Schémy nástrojov',
      user: 'Vaše správy',
      assistant: 'Odpovede',
      toolResults: 'Výstupy nástrojov',
      other: 'Ostatné',
    },
    contextCategoryFree: 'Voľné miesto',
    compactsAt: 'Skrátenie kontextu pri',
    heaviestTools: 'Nástroje s najväčším výstupom',
    toolColumnsHint: 'Schéma · volanie · výstup.',
  },
  reasoning: {
    modalTitle: 'Uvažovanie',
    effortLabel: 'Úsilie',
    thoughtRows: 'Riadky úvah',
    noLevelsTitle: 'Žiadne úrovne',
    noLevelsDesc: 'Tento model úroveň uvažovania neponúka.',
  },
  helpModal: {
    filterPlaceholder: 'Filtrovať príkazy',
    shortcutFilterPlaceholder: 'Filtrovať skratky',
    shortcutCapturePlaceholder: 'Stlačte…',
    emptyTitle: 'Žiadny zodpovedajúci príkaz',
    emptyDesc: 'Skúste iné slovo, alebo filter vymažte a zobrazte všetky príkazy.',
  },
  tasksModal: {
    statusPending: 'Čaká',
    statusInProgress: 'Prebieha',
    statusCompleted: 'Dokončené',
    taskActions: 'Akcie úlohy',
  },
  aiElements: {
    waterfall: {
      title: 'Priebeh',
      milliseconds: '{value} ms',
      timing: '{status}, začiatok v {start} ms, trvanie {duration} ms',
      status: { running: 'prebieha', completed: 'dokončené', failed: 'zlyhalo' },
    },
    progressLabel: 'Priebeh dotazníka',
    progress: 'Otázka {current} z {total}',
    answerRequired: 'Vyberte alebo zadajte odpoveď.',
    previous: 'Späť',
    skip: 'Preskočiť',
    next: 'Ďalej',
    submit: 'Odoslať',
  },
  common: {
    codeDigit: 'Číslica {index} z {count}',
    copyFailed: 'Kopírovanie zlyhalo',
    copiedToast: 'Skopírované.',
    actionFailed: 'Akciu sa nepodarilo dokončiť.',
    daemonReconnecting: 'Prebieha reštartovanie služieb, počkajte, prosím.',
    saveUnconfirmed: 'Spojenie bolo prerušené. Pred opakovaním overte zmenu.',
    savedToast: 'Zmeny boli uložené.',
    daemon: 'Služba na pozadí',
    daemonUnreachable: 'Služba Chetty nie je dostupná',
    toggleSidebar: 'Prepnúť menu',
    cancel: 'Zrušiť',
    save: 'Uložiť',
    delete: 'Vymazať',
    retry: 'Skúsiť znova',
    close: 'Zavrieť',
    back: 'Späť',
    forward: 'Vpred',
    scrollLeft: 'Posunúť doľava',
    scrollRight: 'Posunúť doprava',
    saving: 'Ukladá sa…',
    saved: 'Uložené',
    activationPending: 'Uložené, čaká sa na aktiváciu',
    saveFailed: 'Nepodarilo sa uložiť',
    saveConflict: 'Nastavenia sa medzitým zmenili',
    reloadChanges: 'Načítať aktuálne nastavenia',
    keepMyChanges: 'Ponechať vlastné zmeny',
    done: 'Hotovo',
    searchCommands: 'Hľadať príkazy…',
    searchSite: 'Hľadať…',
    searchNoResults: 'Nič nenájdené',
    searchSuggestions: 'Návrhy',
    searchAskAi: 'Opýtať sa umelej inteligencie na „{query}“',
    searchAskInChat: 'Opýtať sa v chate',
    searchAiAnswer: 'Odpoveď AI',
    imageViewerTitle: 'Náhľad obrázka',
    imageGone: 'Obrázok v plnej veľkosti sa nepodarilo načítať',
    documentPreviewFailed: 'Náhľad sa nepodarilo načítať',
    dismiss: 'Zavrieť',
    notification: 'Oznámenie',
    loading: 'Načítava sa…',
    help: 'Pomocník',
    actions: 'Akcie',
    error: 'Chyba',
    requiredField: 'Povinné',
    primaryNav: 'Hlavné',
    collapseNav: 'Zbaliť navigáciu na ikony',
    expandNav: 'Rozbaliť navigáciu',
    openCommandPalette: 'Otvoriť paletu príkazov',
    skin: 'Vzhľad',
    skinCycle: 'Kliknutím zmeniť',
    skinNames: {
      studioLight: 'Svetlý',
      studioOled: 'Tmavý',
      umberNight: 'Umbrová noc',
      studioGraphite: 'Grafit',
    },
    logout: 'Odhlásiť sa',
    language: 'Jazyk',
    rangeLabel: 'Obdobie',
    rangeLastHour: 'Posledná hodina',
    rangeLast6Hours: 'Posledných 6 hodín',
    rangeLast24Hours: 'Posledných 24 hodín',
    rangeIncomplete: 'Vyplňte začiatok aj koniec obdobia.',
    rangeInvalidInstant: 'Zadajte platný dátum a čas. Tento miestny čas nemusí existovať pri zmene času.',
    rangeInvalidOrder: 'Začiatok obdobia musí predchádzať koncu.',
    rangeOutsideBounds: 'Obdobie je mimo povolených časových medzí.',
    rangeToday: 'Dnes',
    rangeLast7: 'Posledných 7 dní',
    rangeLast30: 'Posledných 30 dní',
    rangeLast90: 'Posledných 90 dní',
    rangeAll: 'Všetko',
    rangeCustom: 'Vlastné',
    rangeFrom: 'Od',
    rangeTo: 'Do',
    filterAllProjects: 'Všetky projekty',
    filterProjectsAria: 'Filter projektov',
    filters: 'Filtre',
    filtersWithCount: 'Filtre, aktívnych: {count}',
    filterOptions: 'Možnosti',
    filterOptionsWithCount: 'Možnosti, aktívnych filtrov: {count}',
    filtersActive: 'Aktívne filtre',
    filtersClear: 'Zrušiť filtre',
    filterRemove: 'Odobrať filter {name}',
  },
  pagination: {
    label: 'Stránkovanie',
    previous: 'Predchádzajúca',
    next: 'Ďalšia',
    previousPage: 'Predchádzajúca strana',
    nextPage: 'Ďalšia strana',
    range: '{from}–{to} z {total}',
    pageLabel: 'Strana {page} z {pages}',
    perPage: 'Na stránku',
  },
  operationDock: {
    history: 'Otvoriť históriu',
    "region": "Operácie na pozadí",
    "more": "+{count}",
    "started": "{action}: začaté",
    "done": "{action}: hotovo",
    "failed": "{action}: zlyhalo",
    "dismiss": "Odstrániť",
    "ackFailed": "Operáciu sa nepodarilo odstrániť. Skúste to znovu.",
    "updateCore": "Aktualizácia Chetty",
    "updatePlugin": "Aktualizácia {name}",
    "installPlugin": "Inštalácia {name}",
    "repairPlugin": "Oprava {name}",
    "captioned": "{action}: {caption}"
  },
  terminalSurface: {
    pasteFailed: 'Prehliadač nemohol prečítať schránku. Použite prosím príkaz Prilepiť v prehliadači.',
    errors: {
      TERMINAL_REFUSED: 'Požiadavka na terminál bola odmietnutá. Overte prístup k tomuto projektu.',
      TERMINAL_UNSUPPORTED: 'Tento cieľ nepodporuje interaktívny terminál.',
      TERMINAL_LIMIT: 'Bol dosiahnutý maximálny počet terminálov.',
      TERMINAL_UNKNOWN_SESSION: 'Táto relácia terminálu už neexistuje.',
      TERMINAL_RUNNING: 'Terminál stále beží. Pred odstránením ho zatvorte.',
      TERMINAL_UNAVAILABLE: 'Terminál je momentálne nedostupný.',
      TERMINAL_FAILED: 'Terminál zlyhal. Otvorte novú reláciu.',
    },
    region: 'Terminál',
    ended: 'Relácia sa skončila.',
    endedWithCode: 'Relácia sa skončila (návratový kód {code}).',
    openedElsewhere: 'Terminál je otvorený v inej karte.',
    takeOver: 'Prevziať',
    refused: 'Terminál sa nepodarilo otvoriť.',
  },
  richTextEditor: {
    toolbar: 'Formátovanie',
    bold: 'Tučné',
    italic: 'Kurzíva',
    link: 'Odkaz',
    bulletList: 'Zoznam s odrážkami',
    orderedList: 'Číslovaný zoznam',
    linkAddress: 'Adresa odkazu',
    linkInvalid: 'Zadajte webovú alebo e-mailovú adresu.',
    applyLink: 'Použiť',
    removeLink: 'Odstrániť odkaz',
  },
  operationProgress: {
    errors: {
      admin_required: 'Táto akcia vyžaduje oprávnenie administrátora inštancie.',
      invalid_network: 'Zadajte platný sieťový režim a porty od 1 do 65535.',
      network_port_conflict: 'Port hostiteľa je už obsadený. Zvoľte iný port alebo ho pred spustením prostredia uvoľnite.',
      network_port_check_failed: 'Dostupnosť portov hostiteľa sa nepodarilo overiť. Prostredie nebolo spustené.',
    },
    progressLabel: 'Priebeh operácie',
    stepOf: 'Krok {current} z {total}',
    indeterminate: 'Prebieha',
    preparing: 'Príprava…',
    succeeded: 'Hotovo',
    failed: 'Operácia zlyhala',
    minimize: 'Minimalizovať',
    retry: 'Skúsiť znovu',
    showLog: 'Zobraziť protokol',
    hideLog: 'Skryť protokol',
    logLabel: 'Protokol prostredia',
    reopen: 'Zobraziť priebeh',
    steps: {
      image: 'Príprava základného obrazu',
      storage: 'Príprava úložiska',
      container: 'Vytváranie kontajnera',
      boot: 'Spúšťanie kontajnera',
      ready: 'Čakanie na spustenie systému',
      initialize: 'Inicializácia projektu',
      quiesce: 'Dokončovanie prebiehajúcej práce',
      stop: 'Zastavovanie kontajnera',
      remove: 'Odstraňovanie starého kontajnera',
      capture: 'Zhotovovanie snímky',
      record: 'Zaznamenávanie snímky',
      import: 'Obnovujem dáta',
      switch: 'Prepínam na novú verziu',
      cleanup: 'Upratujem',
      apply: 'Aplikujem limity',
      containers: 'Odstraňujem kontajnery',
      records: 'Odstraňujem záznamy',
      discard: 'Odstraňujem dáta snímky',
    },
    actions: {
      start: 'Spúšťanie prostredia',
      stop: 'Zastavovanie prostredia',
      restart: 'Reštartovanie prostredia',
      recreate: 'Opätovné vytváranie prostredia',
      delete: 'Mazanie projektu',
      snapshot: 'Vytváranie snímky',
      restore: 'Obnovovanie zo snímky',
      deleteSnapshot: 'Mazanie snímky',
      limits: 'Nastavovanie limitov zdrojov',
      network: 'Nastavovanie siete',
      rename: 'Presun adresára projektu',
    },
  },
  auth: {
    loginFailed: 'Prihlásenie sa nepodarilo. Skontrolujte prihlasovacie údaje.',
    loginRateLimited: 'Príliš veľa pokusov o prihlásenie. Skúste to, prosím, neskôr.',
    signIn: 'Prihlásiť sa',
    signInDescription: 'Prihláste sa do svojho účtu Chetty.',
    orContinueWith: 'Alebo pokračujte cez',
    microsoft: 'Microsoft',
    usernamePlaceholder: 'Používateľské meno',
    passwordPlaceholder: 'Heslo',
    ssoErrors: {
      no_account: 'Účet Chetty pre tento účet Microsoft zatiaľ neexistuje. Požiadajte administrátora o jeho vytvorenie.',
      denied: 'Prihlásenie cez Microsoft bolo zamietnuté. Obráťte sa na administrátora.',
      already_linked: 'Tento účet Microsoft je už prepojený s iným účtom Chettym.',
      directory_unavailable: 'Nepodarilo sa overiť vaše oprávnenie v adresári Microsoftu. Skúste to prosím znova neskôr.',
      tenant_mismatch: 'Tento účet Microsoft nepatrí do organizácie nastavenej pre túto inštanciu.',
      state_expired: 'Platnosť prihlásenia vypršala. Skúste to prosím znova.',
      not_setup: 'Nastavenie ešte nie je dokončené. Prihláste sa používateľským menom a heslom.',
      sso_failed: 'Prihlásenie cez Microsoft zlyhalo.',
    },
    setupPendingTitle: 'Nastavenie nie je dokončené',
    setupPendingBody: 'Na tomto serveri zatiaľ nie je žiadny účet. Dokončite inštaláciu v termináli a potom stránku znova načítajte.',
    setupPendingHint: "Príkaz spustite na stroji, kde je nainštalovaný produkt Chetty.",
  },
  licence: {
    starterTitle: 'Štartovacie pluginy',
    starterDescription: 'Nainštalujte pluginy zo štartovacej sady pre všetkých používateľov.',
    starterAction: 'Zobraziť štartovacie pluginy',
    starterInstall: 'Nainštalovať pluginy',
    starterLater: 'Teraz nie',
    starterInstalling: 'Inštaluje sa…',
    starterGrants: 'Balíky sa najprv overia. Prípadné nové oprávnenia schválite v pripravenej aktualizácii.',
    pageTitle: 'Vyžaduje sa licencia',
    reasonMissing: 'Na tomto serveri nie je nainštalovaná žiadna licencia.',
    reasonExpired: 'Licencia na tomto serveri vypršala.',
    reasonOffline: 'Licenčný server je príliš dlho nedostupný.',
    reasonRefused: 'Licenčný server túto inštaláciu odmietol.',
    reasonWrongInstance: 'Táto licencia bola vydaná pre iný server.',
    reasonInvalid: 'Licencia na tomto serveri nie je platná.',
    instanceId: 'ID inštancie',
    instanceIdHint: 'Identifikuje tento server, licencia je viazaná práve naň.',
    copyInstanceId: 'Kopírovať ID inštancie',
    licenceId: 'ID licencie',
    licenceIdHint: 'Uveďte ho pri komunikácii s podporou.',
    copyLicenceId: 'Kopírovať ID licencie',
    serverTime: 'Čas servera',
    localTime: 'Miestny čas',
    support: 'Potrebujete pomoc? Napíšte na {url}.',
    keyLabel: 'Aktivačný kľúč',
    keyPlaceholder: 'Zadajte aktivačný kľúč',
    activate: 'Aktivovať',
    activating: 'Aktivuje sa…',
    errorBadKey: 'Tento kľúč nevyzerá správne. Skontrolujte ho a skúste to znova.',
    errorForbidden: 'Licenčný server tento kľúč odmietol.',
    errorConflict: 'Tento kľúč je už aktívny na inom serveri.',
    errorServer: 'Licenčný server je momentálne nedostupný. Skúste to neskôr.',
    restarting: 'Reštartuje sa…',
    cardTitle: 'Licencia',
    state: 'Stav',
    stateLocked: 'Zamknuté',
    statusHint: 'Server si platnosť licencie overuje na licenčnom serveri automaticky.',
    customer: 'Zákazník',
    expires: 'Platnosť do',
    expiresHint: 'Po tomto dátume sa služba zastaví, kým licenciu nepredĺžite.',
    pluginCount: 'Pluginy',
    lastContact: 'Posledný kontakt so serverom',
    lastContactHint: 'Kedy tento server naposledy overil licenciu na licenčnom serveri.',
    neverContacted: 'Nikdy',
    staleWarning: 'Licenčný server je dlhší čas nedostupný. Inštalácia pobeží do {date}.',
    checkNow: 'Skontrolovať teraz',
    checking: 'Kontroluje sa…',
    replaceKey: 'Nahradiť aktivačný kľúč',
    replaceTitle: 'Nahradiť aktivačný kľúč',
    replaceDesc: 'Zadajte nový kľúč. Po aktivácii sa služba reštartuje.',
  },
  advisor: {
    dockTop: 'Ukotviť hore',
    dockBottom: 'Ukotviť dole',
    dockPosition: 'Pozícia panela',
    title: 'Asistent',
    close: 'Zavrieť',
    dockLeft: 'Ukotviť vľavo',
    dockRight: 'Ukotviť vpravo',
    chatsCount: 'Chaty: {count}',
  },
  conversationList: {
    archived: 'Archivované',
    relatedItems: 'Súvisiace položky',
    relatedItemsToggle: 'Súvisiace položky konverzácie {title}',
    relatedItemsError: 'Súvisiace položky sa nepodarilo načítať',
    usage: 'Spotreba',
    mine: 'Moje',
    new: 'Nová',
    groups: {
      unread: 'Nové odpovede',
      pinned: 'Pripnuté',
      today: 'Dnes',
      yesterday: 'Včera',
      thisWeek: 'Tento týždeň',
      older: 'Staršie',
      results: 'Výsledky',
    },
    filters: {
      project: 'Projekt',
      status: 'Stav',
      model: 'Model',
      type: 'Typ',
      owner: 'Vlastník',
      noProject: 'Bez projektu',
      unavailableProject: 'Nedostupný projekt',
      unreadScope: 'Neprečítané sa vzťahuje iba na Vaše vlastné konverzácie.',
      clearOne: 'Zrušiť filter {filter}',
      scope: 'Rozsah',
      selectedValues: '{filter}: vybrané {count}',
      working: 'Pracuje',
      waiting: 'Čaká na odpoveď',
      unread: 'Neprečítané',
      error: 'Chyba',
      webCli: 'Web / CLI',
      scheduled: 'Naplánovaná aktivita',
    },
    sort: {
      label: 'Radenie',
      direction: 'Smer',
      newest: 'Najnovšie',
      tokens: 'Tokeny',
      name: 'Názov',
      state: 'Stav',
      model: 'Model',
      owner: 'Vlastník',
      ascending: 'Vzostupne',
      descending: 'Zostupne',
    },
    selectMode: 'Vybrať',
    selectPage: 'Vybrať konverzácie na tejto stránke',
    contextAncestor: 'Zobrazené pre kontext',
    hostedBy: 'Hostiteľský účet: {name}',
    lastWriter: 'Posledný autor: {name}',
    waitingForResponse: 'Čaká na odpoveď',
    runningAgents: 'Agenti: {count}',
    runningAgentsAtLeast: 'Agenti: {count}+',
    newReply: 'Nová odpoveď',
    exportSelected: 'Exportovať vybrané',
    exportSeparateFiles: 'Každá konverzácia sa stiahne ako samostatný súbor. Prehliadač môže požiadať o povolenie viacerých sťahovaní.',
    exportPartial: 'Začaté sťahovania: {started}. Neúspešné požiadavky: {failed}.',
    projectLoadError: 'Projekty sa nepodarilo načítať',
    listLoadError: 'Konverzácie sa nepodarilo načítať',
    personalLoadError: 'Údaje Vašich konverzácií sa nepodarilo načítať',
    searchLoading: 'Prehľadáva sa história konverzácií',
    searchBounded: 'Vyhľadávanie v prepisoch vracia obmedzený počet najnovších zhôd.',
    resultCount: 'Zodpovedajúce konverzácie: {count}',
    deleteAllScope: 'Trvalo sa vymažú všetky spravované konverzácie všetkých účtov vrátane kanálov a delegovaných konverzácií bez ohľadu na aktuálne hľadanie či filtre. Túto akciu nemožno vrátiť.',
  },
  sessionsPanel: {
    searchLabel: 'Hľadať',
    noMatches: 'Filtru nezodpovedá žiadna konverzácia',
    untitled: 'Bez názvu',
    tok: 'tok',
    openInChat: 'Otvoriť v chate',
    viewInChat: 'Zobraziť históriu chatu',
    deleteAll: 'Vymazať všetko',
    confirmDeleteAllTitle: 'Vymazať všetky relácie?',
    subAgents: 'Sub-agenti',
  },
  subagentBranch: {
    unavailable: 'Prepis už nie je k dispozícii',
    truncated: 'Viac riadkov, než sa dá zobraziť',
    error: 'Sub-agentov sa nepodarilo načítať',
  },
  dashboard: {
    greetingMorning: 'Dobré ráno',
    greetingAfternoon: 'Dobré popoludnie',
    greetingEvening: 'Dobrý večer',
    heroAsk: 'S čím Vám môžem pomôcť?',
    stripLabel: 'Dnešný prehľad',
    quickActions: 'Rýchle akcie',
    pillSummary: 'Zhrnúť dnešné dianie',
    pillSummaryPrompt: 'Zhrňte prosím, čo sa dnes v tíme dialo.',
    pillPlan: 'Naplánovať úlohu',
    pillPlanPrompt: 'Naplánujte prosím túto úlohu: ',
    pillCosts: 'Skontrolovať náklady',
    pillAgent: 'Spustiť agenta',
    pillAgentPrompt: 'Spustite prosím agenta na túto úlohu: ',
    pillFind: 'Nájsť v projekte',
    pillFindPrompt: 'Nájdite prosím v projekte: ',
    pillCapabilities: 'Čo všetko dokážete?',
    pillCapabilitiesPrompt: 'Čo všetko dokážete?',
    showFeed: 'Zobraziť dianie',
    showPulse: 'Zobraziť Pulz tímu',
    showMetrics: 'Zobraziť metriky',
    closePanel: 'Zavrieť',
    metricsTitle: 'Metriky',
    metricsMonthCost: 'Vaše náklady tento mesiac',
    metricsTodayCost: 'Vaše náklady dnes',
    metricsMonthTokens: 'Tokeny za 30 dní',
    composerPlaceholder: 'Čo pre vás môžem urobiť?',
    composerAction: 'Odoslať do nového chatu s asistentom Chetty',
    recap: {
      label: 'Včerajšia práca a návrhy',
      fallback: 'Včera sa pracovalo na: {sessions}.',
      continueTitle: 'Pokračovať: {title}',
      rotation: 'Varianty rekapitulácie',
      prev: 'Predchádzajúca rekapitulácia',
      next: 'Ďalšia rekapitulácia',
      pause: 'Pozastaviť striedanie rekapitulácií',
      resume: 'Pokračovať v striedaní rekapitulácií',
    },
    last30d: 'Posledných 30 dní',
    presence: {
      offline: 'Offline',
    },
    live: 'naživo',
    eventStream: 'Dianie',
    eventStreamEmpty: 'Zatiaľ žiadne udalosti.',
    workingNow: 'Práve pracujú',
    pulse: 'Pulz tímu',
    pulseNobody: 'Zatiaľ tu nikto nebol',
    pulseSeen: 'naposledy aktívny',
    pulseUnpriced: 'bez ceny',
    pulseSpendOff: 'spotreba nedostupná',
    pulseTodayLabel: 'dnes',
    pulseActivePeople: 'Aktívni používatelia',
    pulseRunningAgents: 'Bežiace agenty',
    pulseMemoryHits: 'Pripomenuté spomienky',
    pulseCacheHit: 'Priemerný podiel načítaný z vyrovnávacej pamäte',
    pulseVsYesterday: 'v porovnaní so včerajškom',
    pulseNoBaseline: 'včera bez aktivity',
    pulseFlat: 'bez zmeny v porovnaní so včerajškom',
    pulseAgentsBusy: 'Sub-agenti pracujú',
    pulseAgentsIdle: 'Žiadna delegovaná práca',
    pulseMemoryFoot: 'dnešné pripomenutia z pamäte',
    pulseCacheFoot: 'podiel kontextu načítaný z vyrovnávacej pamäte',
    pulseColChannel: 'Kanál',
    pulseColDoing: 'Čo robí',
    pulseColCost: 'Náklady',
    pulseTeamCost: 'Náklady tímu',
    pulseColTokens: 'Tokeny',
    pulseColHits: 'Pamäte',
    pulseColTurns: 'Ťahy',
    pulseRingPeople: 'Ľudia',
    pulseRingChannels: 'Kanály',
    pulseRingContext: 'Kontext',
    pulseRingCost: 'Náklady',
    pulseRingChannelsUnit: 'kanálov',
    pulseRingContextUnit: 'načítaných tokenov',
    pulseRingCostUnit: 'za 30 dní',
    pulseRingEmpty: 'Zatiaľ žiadne dáta',
    pulseContext: {
      cacheRead: 'Načítané z vyrovnávacej pamäte',
      input: 'Nový vstup',
      cacheWrite: 'Uloženie do vyrovnávacej pamäte',
      output: 'Výstup',
    },
    pulseContextHint: {
      cacheRead: 'Časť kontextu sa načítala z vyrovnávacej pamäte, takže stála menej ako nový vstup.',
      input: 'Kontext odoslaný prvýkrát za plnú cenu vstupu.',
      cacheWrite: 'Cena za uloženie kontextu do vyrovnávacej pamäte pre ďalšie odpovede.',
      output: 'Odpoveď modelu. Najdrahšie a zároveň najmenej početné tokeny.',
    },
    pulseColCache: 'Vyrovnávacia pamäť',
    surfaces: { api: 'API token', subagent: 'Sub-agent', web: 'web', cli: 'terminál', cron: 'plán', internal: 'Interné', unknown: 'neznámy klient' },
    surfaceHint: { internal: 'Ťahy bez konkrétnej požiadavky: plánované úlohy, obnova po reštarte a interná práca démona. Ťahy sub-agentov sem už nepatria, ich náklady sa účtujú tomu, kto ich zadal.' },
    ev: {
      turn: 'pracuje',
      someone: 'Niekto',
      message: 'Správa',
      decision: 'Rozhodnutie',
      signedIn: 'Prihlásenie',
      accountLinked: 'Účet prepojený',
      accountProvisioned: 'Účet vytvorený',
      signInDenied: 'Prihlásenie odmietnuté',
      activity: 'Aktivita',
    },
    finishSetup: {
      cta: 'Pripojiť poskytovateľa',
    },
  },
  settings: {
    updateRequestError: 'Aktualizáciu sa nepodarilo spustiť.',
    updateStarted: 'Aktualizácia sa spustila. Chetty sa počas nej na chvíľu reštartuje a celé to môže trvať niekoľko minút. Priebeh uvidíte vpravo dole.',
    restartRequested: 'Požiadavka na reštart bola prijatá.',
    restartRequestError: 'Reštart sa nepodarilo vyžiadať.',
    brainModelsLink: 'Dostupné modely nájdete v sekcii Modely →',
    models: 'Modely',
    plugins: 'Pluginy',
    availablePlugins: 'Dostupné pluginy',
    brain: 'Chetty AI',
    data: 'Údaje',
    navigationLabel: 'Kategórie nastavení',
    navigationSearch: 'Hľadať v nastaveniach',
    navigationNoMatches: 'Tomuto vyhľadávaniu nezodpovedá žiadne nastavenie.',
    modelsSectionHint: 'Určte, ktorý model bude plniť jednotlivé úlohy tejto inštancie a ktoré modely budú dostupné.',
    brainSectionHint: 'Nastavte asistenta, pripojené účty, poskytovateľov a limity behu.',
    // Settings → Models → Model roles: every instance-level answer to "which model does what", in one
    // group above the catalog that says which models exist at all.
    modelCatalog: 'Katalóg modelov',
    modelCatalogRefresh: 'Obnoviť katalóg',
    modelCatalogRefreshing: 'Obnovujem katalóg…',
    modelCatalogRefreshError: 'Obnovenie katalógu sa nepodarilo aspoň u jedného poskytovateľa: {error}',
    modelCatalogRequestError: 'Katalóg modelov sa nepodarilo obnoviť.',
    modelCatalogHint: 'Ktoré modely nastavení poskytovatelia ponúkajú a s akými limitmi kontextu a výstupu.',
    modelRoles: {
      title: 'Roly modelov',
      hint: 'Ktorý model plní ktorú úlohu tejto inštancie.',
      instanceDefault: 'Predvolený model konverzácie',
      instanceDefaultHelp: 'Vyberte model pre konverzácie používateľov, ktorí nemajú vlastnú voľbu. Osobné nastavenia a oprávnenia používateľov zostávajú zachované.',
      defaultSaveError: 'Predvolený model konverzácie sa nepodarilo uložiť.',
      defaultUnavailable: 'Nedostupné: {model}',
      providersLink: 'Poskytovatelia',
      utility: 'Pomocný model',
      utilityHelp: 'Píše názvy konverzácií, spracúva dlhodobé spomienky asistenta Chetty a triedi ich do kategórií.',
      utilityOff: 'Žiadny model: tieto úlohy sú vypnuté',
      digest: 'Model denného prehľadu',
      digestHelp: 'Model vytvára denné zhrnutie na nástenke. Ak chcete použiť pomocný model, ponechajte možnosť dedenia.',
      digestSaveError: 'Model denného prehľadu sa nepodarilo uložiť.',
      promptSuggestion: 'Model návrhov ďalšej správy',
      promptSuggestionSameModel: 'Rovnaký model s cache',
      promptSuggestionHelp: 'Rovnaký model s cache poskytuje najpresnejšie návrhy, ale stojí jeden krok agenta navyše. Lacnejší model vidí iba posledných 10 správ. Ak chcete použiť pomocný model, zvoľte dedenie.',
      promptSuggestionSaveError: 'Model návrhov sa nepodarilo uložiť.',
      recapLink: 'Nastavenia rekapitulácie',
      inherit: 'Prevziať nastavenie: {model}',
      inheritUnset: 'Prevziať nastavenie, pomocný model nie je nastavený',
      inherited: 'Zdedené',
      embeddingConstraint: 'Vyhľadávanie podľa významu vyžaduje poskytovateľa s kľúčom API. Účty Claude a ChatGPT túto možnosť neponúkajú.',
      personal: 'Vaše osobné modely',
      personalHelp: 'Modely pre chat, obrázky a skrátenie kontextu svojho účtu nastavíte v sekcii Účet → Modely.',
      openAccount: 'Otvoriť účet',
    },
    dashboard: 'Rekapitulácia',
    dashboardSectionHint: 'Nastavte denný prehľad, pozdrav a rýchle akcie asistenta.',
    dashboardSection: {
      title: 'Rekapitulácia',
      recap: 'Personalizovaný prehľad',
      recapDesc: 'Pod poľom správy zobrazte každému používateľovi jeho posledné konverzácie a včerajšie udalosti.',
      digest: 'AI prehľad',
      digestDesc: 'Model napíše krátke zhrnutie včerajška a doterajšieho dneška a navrhne ďalšie kroky.',
      greeting: 'Pozdrav písaný asistentom',
      greetingDesc: 'Asistent napíše nadpis nástenky aj otázku pod ním v jazyku používateľa.',
      pills: 'Rýchle akcie asistenta',
      pillsDesc: 'Asistent navrhuje rýchle akcie podľa skutočnej aktivity každého používateľa.',
      continue: 'Pokračovanie konverzácií',
      continueDesc: 'Ponúknuť každému používateľovi jeho posledné konverzácie na opätovné otvorenie.',
      perDay: 'Koľkokrát denne',
      perDayDesc: 'Najvyšší počet prehľadov, ktoré môže jeden používateľ za deň vytvoriť. Deň sa rozdelí na rovnako dlhé obdobia a prehľad sa obnoví pri prvej návšteve v každom novom období.',
      perDayOption: '{n}\u00d7 denne',
      variants: 'Počet variantov pri jednom vytvorení',
      variantsDesc: 'Koľko rôznych zhrnutí včerajška a dneška vznikne pri jednom vytvorení prehľadu. Nástenka ich strieda. Pri hodnote 1 sa zobrazí stále rovnaké zhrnutie.',
      variantsOption: '{n} na dávku',
      countsNote: 'Zmena sa prejaví pri ďalšom vytvorení prehľadu. Prehľad sa obnoví aj počas dňa, keď pribudne nová aktivita, najviac však toľkokrát, koľko dovoľuje nastavený denný limit.',
      providerInherit: 'Rovnaký ako pomocný model',
      model: 'Model prehľadu',
      modelDesc: 'Model pre denný prehľad. Jeho rolu nastavíte v sekcii Nastavenia → Modely vedľa rolí, z ktorých preberá nastavenie.',
      modelLink: 'Roly modelov',
      regenerate: 'Vygenerovať znova',
      regenerateError: 'Regeneráciu sa nepodarilo spustiť.',
      statusReady: 'Dnešný prehľad je pripravený',
      statusGenerating: 'Generuje sa\u2026',
      statusUnavailable: 'Prehľad zatiaľ nie je k dispozícii',
    },
    pluginsSectionHint: 'Nastavujte a sledujte rozšírenia, ktoré pridávajú nástroje a platformy.',
    availablePluginsSectionHint: 'Prehliadajte register pluginov a inštalujte rozšírenia.',
    access: 'Prístupy',
    accessSectionHint: 'Kľúče, tokeny a heslá, s ktorými sa pluginy pripájajú k svojim službám.',
    dataSectionHint: 'Prezerajte súbory protokolov a potvrdzujte nevratné vymazanie prevádzkových údajov.',
    systemSectionHint: 'Sledujte verziu, služby, aktualizácie a zabezpečenie relácií.',
    logs: 'Protokoly',
    logsOpen: 'Otvoriť protokoly',
    logsEmpty: 'Zatiaľ tu nie sú žiadne súbory protokolov.',
    logsPickFile: 'Vyberte súbor protokolu, ktorý chcete zobraziť.',
    logsSearch: 'Filtrovať riadky…',
    logsMatches: '{n} z {total} riadkov',
    logsTruncated: 'Zobrazených posledných {n} z {total} riadkov.',
    logsTruncatedCapped: 'Zobrazených posledných {n} z {total} riadkov — maximum prehliadača logov.',
    logsLoadFull: 'Načítať celý súbor',
    logsError: 'Tento súbor protokolu sa nepodarilo načítať.',
    logsErrorGone: 'Tento súbor protokolu už neexistuje.',
    logsErrorTooBig: 'Tento súbor je príliš veľký na otvorenie v prehliadači záznamov.',
    logsDeleteFile: 'Odstrániť tento súbor záznamov',
    logsDeleteAll: 'Vymazať všetko',
    logsDeleteFileTitle: 'Odstrániť tento súbor záznamov?',
    logsDeleteFileDesc: 'Nenávratne vymaže {name}. Ak ide o dnešný súbor, znova sa vytvorí pri ďalšom zápise.',
    logsDeleteAllTitle: 'Odstrániť všetky súbory záznamov?',
    logsDeleteAllDesc: 'Natrvalo sa odstránia všetky súbory záznamov. Dnešné súbory sa znova vytvoria pri ďalšom zápise.',
    logsLevels: 'Úrovne záznamu',
    logsLevelsAll: 'Všetky úrovne',
    logsLevelsCount: '{n} zo {total} úrovní',
    conversationDiagnostics: {
      exactAggregate: 'Presný súčet od poskytovateľa', tokenSegments: 'Časti tokenov promptu',
      segmentTokens: '{role}: približne {n} tokenov', promptTokens: '~{n} tokenov promptu',
      title: 'Diagnostika konverzácií', description: 'Prezrite si presné požiadavky modelu zaznamenané touto inštanciou.',
      open: 'Otvoriť diagnostiku',
      captureDisabled: 'Podrobné zaznamenávanie požiadaviek je vypnuté.', enableCapture: 'Zapnúť zachytávanie',
      captureConfirmTitle: 'Zapnúť presné zaznamenávanie požiadaviek?',
      captureConfirmDescription: 'Na diagnostiku sa budú ukladať presné prompty poskytovateľa, obsah správ, definície nástrojov, údaje odovzdávané nástrojom a odpovede modelu. Zaznamenané údaje môžu obsahovať súkromné alebo citlivé informácie.',
      captureEnableError: 'Presné zaznamenávanie požiadaviek sa nepodarilo zapnúť.',
      sessions: 'Relácie', tools: 'Nástroje', content: 'Obsah', mobileView: 'Zobrazenie diagnostiky', requests: 'Požiadavky', messages: 'Správy', contentView: 'Obsah požiadavky', displayMode: 'Režim zobrazenia', searchSessions: 'Hľadať relácie…', searchMessages: 'Hľadať v prompte a správach…', searchTools: 'Hľadať nástroje…',
      filters: 'Filtre', userId: 'ID používateľa', userIdInvalid: 'Zadajte kladné celé číslo.', surface: 'Povrch', provider: 'Poskytovateľ', model: 'Model', status: 'Stav', role: 'Rola',
      all: 'Všetko', allRoles: 'Všetky roly', conversation: 'Konverzácia', channel: 'Kanál', subagent: 'Sub-agent', pending: 'Čaká', succeeded: 'Úspešné', captured: 'Zachytené', legacy: 'Staršie dáta', error: 'Chyba', interrupted: 'Prerušené', retry: 'Opakovanie',
      loadMore: 'Načítať ďalšie', loadError: 'Diagnostiku konverzácií sa nepodarilo načítať.', noSessions: 'Žiadna zodpovedajúca relácia.', noRequests: 'V tejto relácii nie sú zaznamenané žiadne požiadavky.',
      legacyWarning: 'Záznam vznikol pred zapnutím presného zaznamenávania. Prepis je iba orientačný.', noLegacyData: 'Starší prepis nie je k dispozícii.',
      toolCall: 'Volanie nástroja', toolResult: 'Výsledok nástroja', mediaContent: 'Binárny alebo mediálny obsah',
      prompt: 'Prompt', cacheRead: 'Čítanie z vyrovnávacej pamäte', cacheWrite: 'Zápis do vyrovnávacej pamäte', input: 'Vstup', output: 'Výstup', reasoning: 'Uvažovanie', cost: 'Cena', duration: 'Trvanie', cachedPrefixEstimate: 'Odhad dĺžky prefixu vo vyrovnávacej pamäti', notAvailable: 'Nie je k dispozícii',
      inspector: 'Detail', pickMessage: 'Vyberte položku promptu alebo správu.', pretty: 'Prehľad', json: 'JSON', copy: 'Kopírovať', rawRequest: 'Surová požiadavka poskytovateľa', payloadTooLarge: 'Údaje sú príliš veľké na zobrazenie v diagnostike.',
      unnamedItem: 'Položka', unnamedTool: 'nástroj',
      noTools: 'V tejto požiadavke neboli odoslané žiadne nástroje.', immediate: 'Okamžitý', deferred: 'Odložený', server: 'Server',
    },
    metric: {
      catalog: 'V katalógu',
      overrides: 'Prepísania kontextu',
      accounts: 'Účty poskytovateľov',
      connected: 'Pripojené',
      aiModels: 'Modely AI',
      pluginWorlds: 'Pluginy s rozhraním',
      pluginPages: 'Stránky pluginov',
      pluginSections: 'Nastavenia pluginov',
      logFiles: 'Súbory záznamov',
      logVolume: 'Objem záznamov',
      requestCapture: 'Záznam požiadaviek',
      conversationCleanup: 'Upratovanie konverzácií',
    },
    adminOnly: 'Len pre administrátorov',
    adminOnlyDesc: 'Táto sekcia je vyhradená administrátorom. Svoj účet upravíte v sekcii Môj účet.',
    tokenTtl: 'Platnosť prihlasovacieho tokenu',
    daysPolicy: {
      presets: 'Predvoľby: {policy}',
      preset: '{n} dní',
      custom: 'Vlastná…',
      customFor: 'Vlastná doba pre {policy}',
      days: 'dní',
    },
    autoUpdate: 'Automatické aktualizácie',
    skins: {
      label: 'Vzhľady',
      hint: 'Medzi ktorými vzhľadmi môžu účty prepínať v hornej lište. Ak sú povolené menej než dva, prepínač sa nezobrazí.',
      none: 'Prepínanie vypnuté',
      emptyHint: 'Ak nie je povolený žiadny, vidia všetci vzhľad nastavený pri nasadení.',
      builtinGroup: 'Vstavané',
      customGroup: 'Vlastné',
      unavailable: 'V tejto inštancii nie je k dispozícii',
      custom: {
        label: 'Vlastné vzhľady',
        hint: 'Vzhľady pridané do tejto inštancie. Vzhľad môže meniť len verejné dizajnové tokeny a pri pridaní sa overuje.',
        manage: 'Spravovať vlastné vzhľady',
        none: 'Žiadne vlastné vzhľady',
        count: { one: '{n} vlastný vzhľad', few: '{n} vlastné vzhľady', many: '{n} vlastných vzhľadov' },
        remove: 'Odobrať',
        removeTitle: 'Odobrať tento vzhľad?',
        removeHint: 'Priečinok vzhľadu sa z tejto inštancie odstráni. Kto ho mal zapnutý, prejde na vzhľad inštancie.',
        refusedBadge: 'Odmietnuté',
        takesEffect: 'Pridanie aj odobratie vzhľadu sa prejaví hneď, na každej otvorenej stránke.',
        idLabel: 'Identifikátor vzhľadu',
        idHint: 'Musí začínať na custom- a zodpovedať názvu priečinka, v ktorom vzhľad leží.',
        idPlaceholder: 'custom-sunrise',
        nameLabel: 'Zobrazovaný názov',
        namePlaceholder: 'Svetlé ráno',
        baseLabel: 'Vychádza z',
        baseHint: 'Vzhľad, ktorý sa prefarbuje a ktorého štruktúru si zachováva.',
        tokensLabel: 'Súbor tokenov',
        tokensHint: 'Jedno pravidlo :root s verejnými dizajnovými tokenmi, napríklad --radius: 8px;',
        tokensPlaceholder: ':root {\n  --radius: 8px;\n}',
        submit: 'Pridať vzhľad',
        refusedPrefix: 'Vzhľad nebol pridaný:',
        fontFamily: 'Rodina písma',
        fontFile: 'Súbor WOFF2',
        fontHint: 'Jeden bežný variabilný font WOFF2, najviac 2 MiB. Rodinu použite v --font-sans alebo --font-mono.',
        fontUpload: 'Nahrať písmo',
        fontRemove: 'Odobrať písmo',
        fontBusy: 'Ukladanie písma…',
      },
    },
    pushContact: 'Kontakt pre push oznámenia',
    pushContactPlaceholder: 'https://vasa-stranka.sk alebo mailto:vy@example.sk',
    system: 'Systém',
    version: 'Verzia Chetty',
    updateAvailable: 'K dispozícii {v}',
    upToDate: 'Aktuálna verzia',
    lastUpdateSucceeded: 'Posledná aktualizácia prebehla úspešne {date}',
    updateNow: 'Aktualizovať teraz',
    checkUpdates: 'Skontrolovať aktualizácie',
    updating: 'Prebieha aktualizácia…',
    services: 'Služby',
    serviceDaemon: 'Služba',
    serviceWeb: 'Web',
    serviceUp: 'Beží',
    serviceDown: 'Nedostupný',
    restartDaemon: 'Reštartovať službu',
    restartWeb: 'Reštartovať web',
    restartDaemonTitle: 'Reštartovať službu?',
    restartDaemonDesc: 'Krátko preruší API a bežiace konverzácie.',
    restartWebTitle: 'Reštartovať web?',
    restartWebDesc: 'Krátko preruší webové rozhranie; API pobeží ďalej.',
    restartConfirm: 'Reštartovať',
    unreadableTitle: 'Nastavenie sa nedá prečítať',
    unreadableDesc: 'Uložené nastavenie inštancie je poškodené. Zostalo bez zmeny, kým ho výslovne neobnovíte. Nič sa neukladá a nič z toho, čo je tu vidieť, nie je uložená konfigurácia. {reason}',
    unreadableReasonJson: 'Uložený záznam nie je platný JSON.',
    unreadableReasonObject: 'Uložený záznam nie je dokument nastavenia.',
    unreadableReasonValue: 'Niektorá uložená hodnota je neplatná.',
    unreadableAdminOnly: 'Požiadajte správcu o jeho obnovenie.',
    unreadableReset: 'Obnoviť nastavenie',
    unreadableResetTitle: 'Obnoviť nastavenie inštancie?',
    unreadableResetDesc: 'Poškodené nastavenie vrátane kľúčov poskytovateľov sa nahradí predvoleným a potom ho nie je možné získať späť. Poskytovateľov a kľúče bude potrebné zadať znova.',
    unreadableResetConfirm: 'Obnoviť',
    unreadableResetPending: 'Obnovujem',
    restartDaemonStarted: 'Služba sa reštartuje…',
    restartWebStarted: 'Web sa reštartuje…',
    systemDiagnostics: 'Diagnostika systému',
    systemDiagnosticsHint: 'Aktuálne využitie procesora, pamäte, disku, I/O a siete a čas behu služby. Kliknutím na meradlo otvoríte jeho históriu.',
    diagnosticCpu: 'CPU',
    diagnosticMemory: 'Pamäť',
    diagnosticUptime: 'Čas behu',
    diagnosticDisk: 'Disk',
    diagnosticIo: 'IO',
    diagnosticNetwork: 'Sieť',
    historyTitle: 'História vyťaženia',
    historyOpen: 'Otvoriť históriu {metric}',
    historyMetrics: 'Prostriedky',
    historyShare: 'Podiely z kapacity v %; IO v % limitu alebo v MB/s bez limitu; sieť v Mb/s',
    historyEmpty: 'Pre zvolené obdobie nie sú k dispozícii žiadne merania.',
    historyNotStarted: 'Zaznamenávanie sa ešte nezačalo.',
    historyGapsHelp: 'Chýbajúce alebo nedostupné merania zanechávajú medzery. Neznamenajú nulové vyťaženie.',
    historyAdjusted: 'Zobrazené obdobie bolo upravené podľa dostupnej histórie a času servera.',
    historyStale: 'Posledné známe hodnoty',
    historyError: 'Históriu vyťaženia sa nepodarilo načítať.',
    error_invalid_history_query: 'Filtre histórie nie sú platné.',
    error_invalid_history_range: 'Zvoľte platný začiatok a koniec obdobia.',
    error_range_outside_retention: 'Zvolené obdobie je mimo uchovávanej histórie posledných 30 dní.',
    error_unsupported_history_resolution: 'Tento interval nemožno použiť pre zvolené obdobie.',
    error_invalid_history_response: 'Odpoveď histórie nie je platná. Skúste to prosím znova.',
    retention: {
      label: "Automatické upratovanie konverzácií",
      hint: 'Každú hodinu odstráni staré nečinné konverzácie. Bežiace, aktívne ani kanálové relácie sa nemažú.',
      olderThan: "Staršie než",
      days: "dní",
    },
    on: 'Zapnuté',
    off: 'Vypnuté',
    modelSearchPlaceholder: 'Hľadať modely…',
    modelNoMatches: 'Tomuto hľadaniu nezodpovedá žiadny model.',
    modelCatalogEmpty: "Nie sú k dispozícii žiadne modely.",
  },
  projects: {
    newProject: 'Nový projekt',
    registry: 'Register projektov',
    workspaceIntro: 'Projekty, stav repozitárov a automatizácia na jednom mieste.',
    registryReady: 'Register je dostupný',
    metricProjects: 'projektov',
    metricIcons: 'vlastných ikon',
    metricDocumented: 's popisom',
    searchPlaceholder: 'Hľadať projekty, cesty alebo poznámky…',
    menuSearch: 'Hľadať projekty…',
    menuNoMatch: 'Nič sa nenašlo',
    searchLabel: 'Hľadať projekty',
    searchClear: 'Zrušiť hľadanie projektov',
    openProject: 'Otvoriť projekt {slug}',
    noMatches: 'Tomuto vyhľadávaniu nezodpovedá žiadny projekt.',
    tableLabel: 'Register projektov',
    cardOpen: 'Otvoriť',
    runtimeManaged: 'Spravované',
    runtimeHost: 'Hostiteľ',
    hostStateTitle: 'Projekt na hostiteľovi',
    hostStateHint: 'Beží v hostiteľskom adresári, bez vlastného kontajnera.',
    branchLabel: 'Aktuálna vetva',
    teamStrip: 'Ľudia s prístupom k projektu {slug}',
    membersCount: 'S prístupom: {n}',
    teamEmpty: 'Nikto nemá prístup',
    teamMore: 'Ďalší: {n}',
    locationHostTitle: 'Adresár hostiteľa',
    locationGuestRoot: 'Cesta v prostredí',
    locationAdoptedFrom: 'Prevedené z',
    detailSections: 'Sekcie projektu',
    tabOverview: 'Prehľad',
    tabAccess: 'Ľudia',
    groupLocation: 'Umiestnenie',
    groupDetails: 'Podrobnosti',
    accessTitle: 'Prístup používateľov',
    accessHint: 'Vyberte účty členov, ktoré môžu používať tento projekt. Administrátori majú automaticky prístup ku všetkým projektom.',
    accessCount: '{n} z {total} používateľov má prístup',
    accessEmpty: 'Nie sú dostupné žiadne bežné účty',
    addMember: 'Pridať člena',
    removeMember: 'Odobrať prístup',
    removeMemberTitle: 'Odobrať prístup?',
    removeMemberBody: '{name} stratí prístup k projektu {project} vrátane jeho súborov, pracovných stromov a uložených prihlasovacích údajov. Vlastné konverzácie a spomienky zostávajú.',
    memorySharedTitle: 'Zdieľaná pamäť',
    memorySharedDesc: 'Vybraní ľudia budú zdieľať pamäť tohto projektu. Agent ju v projekte využíva spolu s ich súkromnými spomienkami.',
    memoryEveryone: 'Ak nie je vybraný nikto, pamäť zdieľajú všetci členovia projektu.',
    memoryEveryoneShort: 'Všetci',
    memorySharersTitle: 'Kto pamäť zdieľa',
    memorySharersGroup: 'Kto zdieľa',
    memorySharersCount: 'Počet zdieľajúcich: {n}',
    memoryPickTitle: 'Prístup k zdieľanej pamäti',
    memoryPickHint: 'Vyberte členov, ktorí zdieľajú fond pamäte projektu. Prázdny výber znamená zdieľanie so všetkými priradenými členmi.',
    loadError: 'Nepodarilo sa načítať projekty',
    empty: 'Žiadne projekty',
    fieldSlug: 'Slug',
    rename: 'Premenovať',
    renameTitle: 'Premenovať projekt',
    renameMovesDirectory: 'Adresár projektu v prostredí sa presunie z {from} do {to}. Spustené prostredie sa kvôli tomu reštartuje: rozpracovaná práca sa ukončí a jeho služby sa spustia znova.',
    slugTaken: 'Projekt s týmto názvom už existuje. Zvoľte iný názov.',
    slugReserved: 'Tento názov je vyhradený pre prostredie projektu. Zvoľte iný názov.',
    renameWorktreesActive: 'Pred premenovaním odstráňte pracovné kópie projektu: odkazujú na jeho súčasný adresár.',
    fieldPath: 'Cesta',
    fieldNotes: 'Poznámky k projektu',
    create: 'Vytvoriť',
    removeConfirmTitle: 'Odobrať projekt',
    removeConfirmBody: 'Odobrať projekt „{slug}“, jeho prostredie a naviazané prostriedky? So súbormi sa naloží podľa zoznamu nižšie. Túto akciu nemožno vrátiť. Súkromná história konverzácií zostane zachovaná.',
    deletionDeleteFiles: 'Odstrániť aj súbory',
    deletionDeleteFilesHint: 'Odstráni sa aj pracovný priečinok projektu na hostiteľovi alebo spárovanom počítači, okrem priečinkov uvedených na zachovanie.',
    deletionKeepFilesHint: 'Súbory v pracovnom priečinku projektu zostanú zachované, s výnimkou nižšie uvedených úložísk vlastnených pluginmi.',
    deletionManagedDisk: 'Disk spravovaného prostredia a úložiská vlastnené pluginmi sa odstránia vždy, aj keď táto voľba nie je zaškrtnutá.',
    deletionPreservedPaths: 'Priečinky, ktorých súbory zostanú zachované:',
    deletionPreservedReasons: {
      protected: 'Súbory sa nevymažú: chránený systémový, domovský alebo aplikačný priečinok.',
      overlap: 'Súbory sa nevymažú: priečinok sa prekrýva s iným existujúcim projektom.',
    },
    deletionPreservedBody: 'Projekt a jeho naviazané prostriedky sa napriek tomu odstránia. Súbory v týchto priečinkoch zostanú bez zmeny.',
    deletionScopeChanged: 'Rozsah mazania sa zmenil. Skontrolujte aktualizovaný zoznam a znova ho potvrďte.',
    deletionPaths: 'Priečinky na odstránenie vrátane celého obsahu:',
    deletionItems: 'Naviazané prostriedky na odstránenie:',
    deletionUnavailable: 'Nedostupní správcovia: {owners}. Ich prostriedky teraz nemožno vypísať. Mazanie zostane blokované, kým nebudú títo správcovia dostupní.',
    deletionConfirmFiles: 'Potvrdením súhlasíte s trvalým vymazaním priečinkov uvedených na odstránenie a celého ich obsahu vrátane priečinkov existujúcich pred vytvorením projektu, prevzatých priečinkov hostiteľa a pracovných priečinkov spárovaných počítačov.',
    deletionPending: 'Projekt sa maže',
    deletionBlocked: 'Mazanie je blokované',
    deletionInactive: 'Počas mazania je tento projekt neaktívny.',
    deletionContinue: 'Pokračovať v mazaní',
    removeConfirmBtn: 'Odobrať',
    slugPlaceholder: 'moj-projekt',
    pathPlaceholder: '~/projects/moj-projekt',
    browse: 'Prechádzať',
    pickFolder: 'Vybrať priečinok projektu',
    parentFolder: 'O úroveň vyššie',
    selectFolder: 'Vybrať tento priečinok',
    folderEmpty: 'Žiadne podpriečinky',
    folderError: 'Priečinok nemožno načítať',
    pathMissing: 'Priečinok neexistuje',
    newFolder: 'Nový priečinok',
    folderName: 'Názov priečinka',
    folderNamePlaceholder: 'Názov priečinka',
    createFolder: 'Vytvoriť priečinok',
    folderExists: 'Priečinok s týmto názvom už existuje.',
    folderCreateError: 'Priečinok sa nepodarilo vytvoriť. Skontrolujte názov a oprávnenia a skúste to znova.',
    folderCreated: 'Priečinok „{name}“ bol vytvorený.',
    ctxCopyPath: 'Kopírovať cestu',
    ctxPathCopied: 'Cesta k priečinku skopírovaná',
    ctxRemove: 'Odobrať projekt',
    adoptProject: 'Previesť na spravované prostredie',
    adoptConfirm: 'Projekt bude používať spravované prostredie. Pri prvom spustení sa jeho pracovný priestor presunie do projektového zväzku. Prevod možno vrátiť len do prvého spustenia.',
    undoAdoption: 'Vrátiť prevod na spravované prostredie',
    undoAdoptionConfirm: 'Vrátiť zatiaľ nespustený projekt do pôvodného priečinka v hostiteľskom počítači?',
    managed: 'Spravované prostredie',
    host: 'Priečinok v hostiteľskom počítači',
    computer: 'Počítač',
    computerActivity: 'Aktivita',
    executionKind: 'Cieľ spúšťania',
    privateHint: 'Projekt zostane súkromný, kým ho výslovne nezdieľate. Administrátori k nemu majú vždy prístup. Prostredie sa spustí až pri prvom použití.',
    defaultBadge: 'Predvolený',
    defaultBadgeHint: 'Predvolený projekt, prvý v poradí. Otvárajú sa v ňom konverzácie z chatovacích platforiem, v ktorých ste žiadny projekt nevybrali.',
    reorderHint: 'Poradie zmeníte podržaním a potiahnutím úchytu karty, prvý projekt je predvolený.',
    reorderHandle: 'Presunúť projekt {slug}',
    reorderRole: 'presúvateľný projekt',
    reorderInstructions: 'Medzerníkom alebo klávesom Enter projekt uchopíte, šípkami ho presuniete, medzerníkom alebo klávesom Enter ho pustíte. Kláves Escape presun zruší.',
    reorderPickedUp: 'Projekt {name} je uchopený. Pozícia {position} z {total}.',
    reorderMoved: 'Projekt {name} je na pozícii {position} z {total}.',
    reorderDropped: 'Projekt {name} bol presunutý na pozíciu {position} z {total}.',
    reorderCancelled: 'Presun projektu {name} bol zrušený.',
    createGrant: 'Povoliť ďalšie projekty',
    createGrantHint: 'Účet smie zakladať projekty nad rámec predvoleného projektu.',
    shareGrant: 'Povoliť pozvania do projektov',
    shareGrantHint: 'Účet smie pozývať ďalších ľudí do svojich projektov.',
    limit: 'Limit spravovaných projektov',
    limitHint: 'Počíta sa aj predvolený projekt. Administrátori tieto limity účtu nemajú.',
    permissions: 'Oprávnenia projektov',
    invite: 'Pozvať člena',
    userId: 'ID účtu',
    userIdHint: 'Požiadajte danú osobu o ID účtu. Zoznam účtov môžu zobraziť iba administrátori.',
    member: 'Účet {id}',
    accessCountMembers: { one: 'Prístup má {n} používateľ', few: 'Prístup majú {n} používatelia', many: 'Prístup má {n} používateľov' },
    sharingWarning: 'Každý člen získa prístup ku všetkým doterajším súborom projektu, pracovným kópiám, profilom prehliadača a prihlasovacím údajom uloženým v prostredí. Členovia môžu projekt rovnako spravovať aj odstrániť. Súkromné konverzácie, spomienky a osobné prepojenia sa automaticky nezdieľajú.',
    computerSharingWarning: 'Každý člen pracuje na tomto počítači ako používateľ operačného systému, ktorý na ňom spúšťa pripojenie Chettyho: môže čítať a meniť jeho súbory a spúšťať na ňom príkazy. Súkromné konverzácie a spomienky sa nezdieľajú automaticky.',
    computerMembersOwnerOnly: 'Členov počítača spravuje len jeho vlastník.',
    inviteDenied: 'Na pozývanie členov potrebujete oprávnenie na zdieľanie, ktoré udeľuje administrátor.',
  },
  users: {
    projectDeleting: 'Projekt sa maže. Prístup k nemu teraz nemožno meniť.',
    existingProjects: 'Existujúce projekty',
    newPersonalProject: 'Nový osobný projekt',
    presets: {
      detachConfirm: "Zmeniť právo",
      apply: "Prepísať všetkým v predvoľbe",
      title: "Predvoľby účtov",
      button: "Predvoľby účtov",
      new: "Nová predvoľba",
      name: "Názov predvoľby",
      create: "Vytvoriť predvoľbu",
      delete: "Vymazať predvoľbu",
      deleteTitle: "Vymazať predvoľbu účtov?",
      deleteBody: "Vymazať „{name}“ a odpojiť {n} účtov? Účty si ponechajú súčasné práva a osobné nastavenia.",
      deleteError: "Predvoľbu sa nepodarilo vymazať.",
      choice: "Predvoľba",
      accountsHint: "Koľko účtov predvoľbu práve používa.",
      accounts: "Účty",
      identity: "Predvoľba",
      nameHint: "Názov, pod ktorým sa predvoľba ponúka pri účtoch.",
      nameTaken: "Predvoľba s týmto názvom už existuje.",
      intro: "Predvoľba určuje oprávnenia a predvolené správanie účtov, ktoré ju používajú.",
      choiceHint: "Účet preberá oprávnenia a nastavenia z predvoľby, kým niektoré z nich nezmení.",
      none: "Žiadna",
      newAccount: "Predvoľba pre nové účty",
      newAccountHint: "Nové ľudské účty dostanú túto predvoľbu. Bez predvoľby začínajú bez práv.",
      empty: "Zatiaľ nie sú vytvorené žiadne predvoľby účtov.",
      loadError: "Predvoľby účtov sa nepodarilo načítať.",
      search: "Hľadať predvoľby",
      section: "Sekcie predvoľby",
      rights: "Práva",
      behavior: "Správanie",
      behaviorHint: "Nevyplnené hodnoty sa dedia z predvolených nastavení inštancie. Osobné nastavenia účtu majú prednosť.",
      projectsHint: "Tieto Projekty sú minimom členstva pripojených účtov. Ďalšie členstvá zostávajú.",
      accountCount: "Pripojené účty: {n}",
      inherit: "Dediť predvolenú hodnotu inštancie",
      inherited: "Z predvolených nastavení inštancie",
      detachTitle: "Odpojiť účet od predvoľby?",
      detachBody: "Táto zmena práva odpojí účet od predvoľby „{name}“. Ďalšie úpravy predvoľby sa na účet nebudú vzťahovať.",
      applyTitle: "Prepísať nastavenia účtom v predvoľbe?",
      applyBody: "Vymazať vlastnú hodnotu „{field}“ u {n} účtov pripojených k predvoľbe „{name}“? Účty budú dediť hodnotu predvoľby.",
      retainedProjects: "Posledný aktívny Projekt zostal týmto účtom: {projects}",
    },
    defaults: {
      button: 'Predvolené nastavenia používateľov',
      title: 'Predvolené nastavenia používateľov',
      intro: "Základné správanie účtov. Vlastné hodnoty a správanie predvoľby majú prednosť.",
      navLabel: 'Sekcie predvolených nastavení',
      navSearch: 'Hľadať sekcie',
      navNoMatches: 'Tomuto vyhľadávaniu nezodpovedajú žiadne predvolené nastavenia.',
      ownCount: 'Účty s vlastnou hodnotou: {n}',
      apply: 'Prepísať všetkým',
      applyTitle: 'Prepísať všetkým?',
      applyBody: "Vymazať vlastnú hodnotu „{field}“ u {n} účtov? Budú dediť hodnotu predvoľby, ak ju má, inak predvolené nastavenia inštancie.",
      applied: 'Účty preberajúce predvolenú hodnotu: {n}',
      loadError: 'Predvolené hodnoty sa nepodarilo načítať.',
      missingModel: 'Model sa už neponúka',
      noChoice: 'Bez modelu',
      autoCompactAtHint: 'Podiel okna kontextu, pri ktorom sa konverzácia zhustí.',
      advisorStyleHint: 'Tón, ktorým agent píše, keď tento účet nechce nič iné.',
      localeHint: 'Jazyk, v ktorom začína rozhranie aj odpovede agenta.',
      rulesHint: 'Pravidlá nástrojov, predvolené YOLO a ako sa odpovedá na otázku bez dozoru. Všetko je to jeden záznam: účet ho buď má celý vlastný, alebo celý preberá.',
      pluginsEmpty: 'Žiadny nainštalovaný plugin neponúka osobné nastavenia.',
      sectionModels: 'Modely',
      sectionMemory: 'Pamäť',
      sectionSkills: 'Skills',
      sectionStyle: 'Štýl a inštrukcie',
      sectionLanguage: 'Jazyk',
      sectionRules: 'Pravidlá a YOLO',
      sectionPlugins: 'Pluginy',
    },
    projectRequired: 'Účet vyžaduje aspoň jeden aktívny projekt.',
    lastActiveProject: 'Najprv týmto účtom priraďte iný aktívny projekt. Inak by stratili svoj posledný aktívny projekt:',
    projectInactive: 'Vybraný projekt už nie je aktívny. Vyberte iný projekt.',
    projectsLoadError: 'Nepodarilo sa načítať projekty.',
    noActiveProjects: 'Žiadny aktívny projekt nie je k dispozícii. Vyberte nový osobný projekt.',
    workspaceEyebrow: 'Adresár prístupov',
    workspaceIntro: 'Účty, roly, prístup k projektom a oprávnenia k modelom aj nástrojom na jednom mieste.',
    workspaceReady: 'Adresár je synchronizovaný',
    metricUsers: 'používateľov',
    metricAdmins: 'administrátorov',
    searchPlaceholder: 'Hľadať používateľov…',
    searchLabel: 'Hľadať používateľov',
    searchClear: 'Vymazať hľadanie používateľov',
    openUser: 'Otvoriť používateľa {name}',
    manageProjects: 'Spravovať prístup k projektom',
    manageModels: 'Spravovať povolené modely',
    managePlugins: 'Spravovať pridelené pluginy',
    manageTools: 'Spravovať prístup k nástrojom',
    noMatches: 'Hľadaniu nezodpovedá žiadny používateľ',
    tableLabel: 'Adresár používateľov',
    role: 'Rola',
    createdAt: 'Vytvorené',
    webActivityOnline: 'Online v administrácii',
    webActivityAgo: 'Naposledy tu pred {time}',
    webActivityDate: 'Naposledy tu {date}',
    webActivityNever: 'Zatiaľ bez návštevy administrácie',
    sectionAccount: 'Účet',
    sectionPermissions: 'Oprávnenia',
    detailSections: 'Sekcie účtu',
    fromPreset: 'Z predvoľby',
    projectDeletingState: 'Odstraňuje sa',
    loadError: 'Nepodarilo sa načítať používateľov',
    empty: 'Žiadni používatelia',
    emptyDescription: 'Pre začiatok vytvorte prvý účet.',
    fieldUsername: 'Používateľské meno',
    fieldName: 'Zobrazované meno',
    usernameTaken: 'Toto používateľské meno je už obsadené',
    addUser: 'Pridať používateľa',
    newUser: 'Nový používateľ',
    create: 'Vytvoriť',
    delete: 'Vymazať',
    createError: 'Používateľa sa nepodarilo vytvoriť.',
    createInvalid: 'Zadajte platné používateľské meno a heslo s dĺžkou aspoň osem znakov.',
    deleteError: 'Používateľa sa nepodarilo vymazať.',
    deleteLastUser: 'Posledný používateľský účet nemožno vymazať.',
    deleteAdmin: 'Pred vymazaním používateľovi odoberte rolu administrátora.',
    deletePairedComputers: 'Účet má spárované počítače. Najprv musí ich vlastník potvrdiť odstránenie ich Projektov, potom možno účet vymazať.',
    deleteActiveProcesses: 'Používateľ má stále aktívne procesy. Pred vymazaním účtu ich ukončite.',
    deleteCleanupError: 'Používateľa nemožno vymazať, pretože sa nepodarilo vyčistiť dáta pluginov.',
    userNotFound: 'Používateľ už neexistuje.',
    adminRequired: 'Táto akcia vyžaduje oprávnenie administrátora.',
    cannotDemoteLastAdmin: 'Poslednému administrátorovi nemožno rolu odobrať.',
    confirmDeleteTitle: 'Vymazať {name}?',
    confirmDeleteDesc: 'Natrvalo odstránite používateľa a všetky jeho údaje: nastavenia, spomienky, osobnosť aj prístup k projektom. Túto akciu nemožno vrátiť.',
    projects: 'Projekty',
    admin: 'Administrátor',
    member: 'Člen',
    chatbot: 'Chatbot',
    chatbotHint: 'K tomuto účtu sa nemožno prihlásiť bežným spôsobom. Prihlásený administrátor doň môže vstúpiť, účet však nemôže získať rolu administrátora.',
    makeAdmin: 'Povýšiť na administrátora',
    removeAdmin: 'Odobrať administrátora',
    confirmMakeAdminTitle: 'Udeliť používateľovi {name} rolu administrátora?',
    confirmMakeAdminDesc: 'Získa prístup k správe používateľov, nastaveniam inštancie aj ku všetkým akciám dostupným iba administrátorom.',
    confirmRemoveAdminTitle: 'Odobrať používateľovi {name} administrátorský prístup?',
    confirmRemoveAdminDesc: 'Okamžite stratí prístup k správe používateľov, nastaveniam inštancie aj ku všetkým akciám dostupným iba administrátorom.',
    confirmSelfDemotionDesc: 'Okamžite stratíte prístup k časti Používatelia, nastaveniam inštancie aj ku všetkým akciám dostupným iba administrátorom. Rolu vám môže znova udeliť iba iný administrátor.',
    allowedModels: 'Povolené modely',
    allModels: 'Všetky modely',
    allModelsHint: 'Všetky modely, ktoré táto inštalácia ponúka, vrátane neskôr pridaných.',
    modelGrantHint: 'Vyberte modely, ktoré smie používateľ spúšťať. Bez výberu nesmie spúšťať žiadny model.',
    noModelsGranted: 'Žiadny povolený model',
    modelNotOffered: 'Nie je ponúkaný',
    updateError: 'Nepodarilo sa uložiť zmenu',
    ctxImpersonate: 'Prihlásiť sa ako',
    impersonateError: 'Prihlásenie ako používateľ sa nezdarilo',
    impersonatingAs: 'Prezeráte aplikáciu ako {name}',
    stopImpersonating: 'Späť na svoj účet',
    stopImpersonateError: 'Návrat na váš účet sa nepodaril',
    grantedPlugins: 'Povolené pluginy',
    grantedPluginsHint: 'Časti systému, napríklad plány a skilly, sa sprístupňujú jednotlivým používateľom. Bez udelenia prístupu ich používateľ nemôže používať.',
    grantedPluginsCount: 'Povolené {n} z {total}',
    grantedPluginsSelected: 'Povolené: {n}',
    grantedPluginsEmpty: 'Žiadny plugin sa nepovoľuje jednotlivým používateľom.',
    tools: 'Nástroje',
    toolsHint: 'Nástroje dostupné používateľovi v jeho vlastnom chate. Zaškrtnuté nástroje pluginov ste mu udelili. Nový účet ich nemá, kým mu ich administrátor nepridelí. Vstavané nástroje možno tiež zapínať a vypínať. Automatická pamäť vyžaduje povolený MemorySearch na vybavovanie a MemoryAdd na ukladanie. Nedostupný nástroj sprístupníte udelením príslušného pluginu. Prístup k zdieľaným kanálom Discordu určujú pravidlá rolí pluginu, nie tento zoznam.',
    toolsEmpty: 'Žiadne nástroje k dispozícii',
    statMemories: 'Pamäte',
    statSessions: 'Relácie',
    statTopModel: 'Najčastejší model',
    noMemories: 'Bez pamätí',
    noSessions: 'Zatiaľ žiadne relácie',
    noModel: 'Zatiaľ žiadny model',
    statTopModelHint: 'Model, ktorý účet používa najčastejšie.',
    statSessionsHint: 'Počet konverzácií, ktoré účet viedol.',
    statMemoriesHint: 'Koľko spomienok si o účte asistent uchováva.',
    createdAtHint: 'Kedy bol účet založený.',
    roleHint: 'Administrátori spravujú inštanciu, členovia pracujú v pridelených projektoch.',
    fieldUsernameHint: 'Prihlasovacie meno účtu. Musí byť jedinečné.',
    fieldNameHint: 'Meno, pod ktorým sa účet zobrazuje v zoznamoch a konverzáciách.',
    projectsNone: 'Účtu zatiaľ nie je pridelený žiadny projekt.',
    addProject: 'Pridať projekt',
    removeProject: 'Odobrať prístup',
    removeProjectTitle: 'Odobrať prístup k projektu?',
    removeProjectBody: 'Účet stratí prístup k projektu {project} vrátane jeho prostredia, súborov a uložených prihlasovacích údajov.',
    groupAccess: 'Modely a nástroje',
    groupActivity: 'Aktivita',
    groupIdentity: 'Identita',
  },
  managePicker: {
    manage: 'Spravovať',
    searchPlaceholder: 'Hľadať…',
    all: 'Všetko',
    none: 'Žiadny',
    selectedCount: 'Vybrané: {n}',
    saveChanges: 'Uložiť zmeny',
    noResults: 'Žiadne výsledky',
    filterByGroup: 'Filtrovať podľa skupiny',
    modelsCount: 'Modely: {n} · poskytovatelia: {p}',
    allModelsCount: 'Povolené všetky modely · dostupných: {n}',
    modelsSelected: 'Vybrané modely: {n}',
    projectsCount: 'Priradené projekty: {n} z {total}',
    projectsSelected: 'Vybrané projekty: {n}',
    projectsSubtitle: 'Projekty, ku ktorým má používateľ prístup.',
    toolsCount: 'Povolené nástroje: {n} z {total} · pluginy: {p}',
    toolsSelected: 'Vybrané nástroje: {n}',
    toolsSubtitle: 'Povoliť alebo zakázať nástroje používateľského účtu.',
    familyGrant: 'Povolené vzorom',
    familyGrantHint: 'Nástroj je súčasťou povolenej skupiny. Ak ho chcete zakázať, upravte povolený vzor v nastaveniach účtu.',
    notGranted: 'nepridelené',
    notGrantedHint: 'Používateľ nemá prístup k pluginu, ktorý poskytuje tento nástroj, a preto ho nemôže spustiť. Sprístupníte ho udelením pluginu.',
    toolGroupElowen: 'Chetty',
    toolGroupMemory: 'Pamäť',
  },
  vault: {
    share: "Zdieľať",
    shareItem: "Zdieľanie položky {name}",
    sharedWith: { one: "Zdieľané s {count} používateľom", few: "Zdieľané s {count} používateľmi", many: "Zdieľané s {count} používateľmi" },
    sharedBy: "Zdieľa {name}",
    shareSearch: "Vyhľadať používateľa",
    addAccess: "Zdieľať s {name}",
    revokeAccess: "Odobrať prístup: {name}",
    title: "Trezor",
    hint: "Agent vidí iba názvy a popisy a zapisuje {{vault:NAME}}; uložené hodnoty sa už nikdy nezobrazia.",
    listTitle: "Vaše položky",
    add: "Pridať položku",
    describe: "Upraviť popis",
    replace: "Nahradiť hodnotu",
    deleteTitle: "Vymazať túto položku?",
    deleteBody: "Položka {name} už nebude agentovi dostupná a jej zaznamenané použitie sa zmaže.",
    name: "Názov",
    nameHint: "A–Z, 0–9 a _, začína písmenom, najviac 64 znakov.",
    description: "Popis",
    descriptionHint: "Popíšte, na čo má agent položku použiť (1–500 znakov).",
    value: "Hodnota",
    valueHint: "Aspoň 4 znaky, najviac 64 KiB. Hodnota sa uloží presne tak, ako ju zadáte.",
    multiline: "Viacriadková hodnota",
    empty: "Zatiaľ žiadne položky",
    emptyHint: "Pridajte prihlasovací údaj, ktorý agent použije bez zobrazenia jeho hodnoty.",
    updated: "Posledná zmena",
    listHint: "Agent vidí názvy a popisy, uložené hodnoty sa znovu nezobrazujú. Vlastné aj zdieľané položky používa pomocou odkazu vault:NAME v dvojitých zložených zátvorkách. Názov musí byť vo vašom trezore jedinečný. Zdieľajte iba s ľuďmi, ktorým dôverujete: príjemca môže hodnotu cez nástroj vyniesť. Odobratie zdieľania zablokuje ďalšie použitie, ale nevezme hodnotu už bežiacemu procesu. Pri úniku údaj zmeňte aj u jeho poskytovateľa.",
    shareConflict: "Tento používateľ už má položku s rovnakým názvom.",
    shareFailed: "Zdieľanie sa nepodarilo zmeniť.",
    shareLoadFailed: "Zdieľanie sa nepodarilo načítať.",
    lastUsed: "Naposledy použité",
    never: "Nikdy",
    usageByPerson: "Použitie podľa osôb",
    deletedActor: "Vymazaný účet #{id}",
    statsLoadError: "Použitie sa nepodarilo načítať",
    chartTitle: "Použitie po dňoch",
    chartUses: "Použitia",
    totals: { one: "{n} použitie", few: "{n} použitia", many: "{n} použití" },
    exists: "Položka s týmto názvom už existuje.",
    notFound: "Táto položka už neexistuje. Načítajte zoznam znova.",
    unavailable: "Trezor nie je dostupný. Skúste to prosím neskôr.",
    chatbot: "Trezor nie je pre účty chatbotov dostupný.",
    failed: "Položku sa nepodarilo uložiť. Skúste to prosím znova.",
    validation: "Skontrolujte názov, popis a hodnotu podľa pravidiel pri poliach.",
  },
  apiTokens: {
    sectionHint: 'Osobné API tokeny umožňujú vašim nástrojom ovládať agenta cez HTTP, s vaším oprávnením.',
    listTitle: 'Vaše tokeny',
    listHint: 'Každý token sa prihlasuje ako vy, s vaším oprávnením.',
    create: 'Nový token',
    createTitle: 'Nový API token',
    name: 'Názov',
    namePlaceholder: 'CI pipeline',
    expires: 'Platnosť do',
    expiresHelp: 'Token prestane fungovať na konci tohto dňa v UTC. Nechajte prázdne pre token, ktorý platí, kým ho nevymažete.',
    expiresPast: 'Dátum vypršania platnosti nesmie byť v minulosti.',
    expiresNever: 'Bez obmedzenia',
    createSubmit: 'Vytvoriť token',
    createError: 'Token sa nepodarilo vytvoriť',
    revealedTitle: 'Skopírujte si token',
    revealedHint: 'Zobrazuje sa len teraz. Chetty si ukladá iba jeho odtlačok, takže ho neskôr už nemožno vypísať.',
    copy: 'Kopírovať',
    copied: 'Skopírované',
    done: 'Hotovo',
    columns: {
      lastUsed: 'Naposledy použitý',
      expires: 'Platnosť do',
    },
    never: 'Nikdy',
    costUnknown: 'Cena neznáma',
    emptyTitle: 'Zatiaľ žiadne tokeny',
    emptyDescription: 'Vytvorte token a volajte agenta zo svojich skriptov alebo z CI.',
    loadError: 'Tokeny sa nepodarilo načítať',
    statsLoadError: 'Spotrebu sa nepodarilo načítať',
    chartTitle: 'Behy a náklady po dňoch',
    chartTurns: 'Behy',
    chartAnswered: 'Zodpovedané',
    chartErrors: 'Zlyhalo',
    chartCost: 'Náklady',
    chartEmpty: 'V tomto období nič zaznamenané',
    chartCostUnknown: 'Niektoré behy v tomto období nehlásili náklady, takže ich súčet nie je známy, nie že je nula.',
    totals: '{requests} požiadaviek · {turns} behov · {answered} zodpovedaných · {failed} zlyhalo · {tokens} tokenov · {cost}',
    limitsTitle: 'Limity',
    limitsHint: 'Každý limit je nepovinný. Limit prepnutý na bez obmedzenia sa nevynucuje.',
    limitsError: 'Limity sa nepodarilo uložiť',
    unlimited: 'Bez obmedzenia',
    limits: {
      dailyCostMicrousd: 'Náklady/deň',
      monthlyCostMicrousd: 'Náklady/mesiac',
      requestsPerMinute: 'Požiadavky/min',
      maxConcurrentTurns: 'Súbežne',
    },
    limitHints: {
      dailyCostMicrousd: 'Deň sa počíta v UTC. Keď zaznamenané náklady dosiahnu túto sumu, behy sa odmietnu. Odmietajú sa aj v deň, keď niektorý beh nehlásil náklady, pretože útratu nemožno overiť.',
      monthlyCostMicrousd: 'Mesiac sa počíta v UTC. Keď zaznamenané náklady dosiahnu túto sumu, behy sa odmietnu až do začiatku ďalšieho mesiaca. Odmietajú sa aj v mesiaci, keď niektorý beh nehlásil náklady, pretože útratu nemožno overiť.',
      requestsPerMinute: 'Platí pre každý požiadavok overený týmto tokenom, nech žiada čokoľvek.',
      maxConcurrentTurns: 'Koľko behov môže mať tento token súčasne spustených.',
    },
    regenerateTitle: 'Vytvoriť novú hodnotu tokenu?',
    regenerateBody: '„{name}“ si nechá názov, limity aj zaznamenanú spotrebu, ale dostane novú hodnotu: súčasná okamžite prestane fungovať a všetko, čo ju používa, sa musí aktualizovať.',
    regenerate: 'Vytvoriť novú hodnotu',
    regenerateError: 'Novú hodnotu tokenu sa nepodarilo vytvoriť.',
    delete: 'Vymazať',
    deleteTitle: 'Vymazať tento token?',
    deleteBody: 'Všetko, čo používa „{name}“, prestane okamžite fungovať a jeho zaznamenaná spotreba sa zmaže.',
    deleteError: 'Token sa nepodarilo vymazať',
    callTitle: 'Volanie agenta',
    callHint: 'Pošlite token ako bearer hlavičku na /api/v1/agent/runs tohto hostu. Odpoveď uvádza svoju konverzáciu; odovzdaním jej identifikátora ako conversationId v nej pokračujete. S "stream": true dostávate priebeh ako server-sent events.',
  },
  elowenCli: {
    sectionHint: 'Prepojte svoje počítače s Chettym. Agent na nich pracuje so súbormi a príkazmi.',
    approveTitle: 'Schváliť prihlásenie',
    accountApproveTitle: 'Schváliť prihlásenie CLI na serveri',
    accountApproveHint: 'Terminál získa osobný API token s prístupom k vášmu účtu. Počítač sa nepáruje. Prístup môžete zrušiť v Účet → API tokeny.',
    accountApproved: 'Prihlásenie CLI na serveri bolo schválené',
    terminal: 'Terminál',
    approveHint: 'Zariadenie získa plný prístup k vášmu účtu.',
    device: 'Zariadenie',
    code: 'Kód',
    approve: 'Schváliť',
    deny: 'Zamietnuť',
    approved: 'Zariadenie bolo schválené',
    denied: 'Prihlásenie bolo zamietnuté',
    decideError: 'Rozhodnutie sa nepodarilo uložiť',
    codeExpired: 'Platnosť kódu vypršala',
    codeExpiredHint: 'Spustite na zariadení znova elowen login.',
    codeDecided: 'O tomto prihlásení už bolo rozhodnuté',
    codeLoadError: 'Žiadosť o prihlásenie sa nepodarilo načítať',
    installTitle: 'Inštalácia',
    installHint: 'Skopírovaný príkaz spustite v termináli v Linuxe alebo macOS.',
    installHintWindows: 'Skopírovaný príkaz vložte do PowerShellu vo Windows.',
    installHintMac: 'Skopírovaný príkaz spustite v aplikácii Terminál v macOS.',
    installHintLinux: 'Skopírovaný príkaz spustite v termináli v Linuxe.',
    installerLabel: 'Operačný systém',
    installerUnix: 'macOS a Linux',
    installerWindows: 'Windows',
    installSelfOnly: 'Počítač môže pripojiť len používateľ sám.',
    copyInstall: 'Kopírovať inštalačný príkaz',
    enrollmentLoadError: 'Platnosť inštalačného príkazu sa nepodarilo načítať',
    copyCountdown: 'Skopírované · {time}',
    copyAvailableAt: 'Inštalačný príkaz bol skopírovaný. Znova ho môžete skopírovať o {time}.',
    copied: 'Inštalačný príkaz bol skopírovaný',
    installError: 'Inštalačný príkaz sa nepodarilo vytvoriť',
    devicesTitle: 'Moje počítače',
    connected: 'Pripojené',
    neverConnected: 'Zatiaľ nepripojené',
    computerName: 'Názov',
    system: 'Systém',
    client: 'Klient',
    emptyTitle: 'Zatiaľ žiadne počítače',
    emptyDescription: 'Spustite inštalačný príkaz na počítači, ktorý chcete pripojiť.',
    loadError: 'Vaše počítače sa nepodarilo načítať',
    offline: 'Offline',
    clientVersion: 'klient {version}',
    lastOnline: 'Naposledy online',
    statsLoadError: 'Využitie sa nepodarilo načítať',
    chartTitle: 'Behy a príkazy po dňoch',
    chartTurns: 'Behy',
    chartCommands: 'Príkazy',
    chartErrors: 'Zlyhalo',
    chartCost: 'Náklady',
    chartCostUnknown: 'Niektoré behy v tomto období nehlásili náklady, takže ich súčet nie je známy, nie že je nula.',
    costUnknown: 'Cena neznáma',
    totals: '{turns} behov · {commands} príkazov · {files} upravených súborov · {tokens} tokenov · {cost}',
    loadTitle: 'Aktuálne zaťaženie',
    loadUnknown: 'Žiadne aktuálne meranie. Zobrazí sa, keď je počítač pripojený.',
    cores: { one: '{n} jadro', few: '{n} jadrá', many: '{n} jadier' },
  },
  account: {
    effectsTitle: 'Vizuálne efekty',
    effectsHint: 'Ovláda animácie a prechody na tomto zariadení. Režim Automaticky sa riadi nastavením operačného systému.',
    effectsAuto: 'Automaticky',
    effectsFull: 'Plný rozsah',
    effectsReduced: 'Obmedzené',
    effectsOff: 'Vypnuté',
    title: 'Môj účet',
    navigationLabel: 'Sekcie účtu',
    navigationSearch: 'Hľadať v účte',
    navigationNoMatches: 'Vyhľadávaniu nezodpovedá žiadne nastavenie účtu.',
    profileHint: 'Spravujte svoju identitu, predvolené nastavenia a prepojené účty.',
    name: 'Meno',
    email: 'E-mail',
    uploadAvatar: 'Nahrať avatar',
    saveError: 'Uloženie zlyhalo',
    password: 'Heslo',
    passwordHint: 'Zmeňte si prihlasovacie heslo. Nové heslo musí mať aspoň 8 znakov.',
    currentPassword: 'Súčasné heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrdenie nového hesla',
    changePassword: 'Zmeniť heslo',
    passwordChanged: 'Heslo zmenené',
    passwordMismatch: 'Nové heslá sa nezhodujú',
    passwordWrong: 'Súčasné heslo nie je správne',
    passwordError: 'Zmena hesla zlyhala',
    uiScale: 'Mierka rozhrania',
    uiScaleReset: 'Obnoviť',
    tabProfile: 'Účet',
    tabApiTokens: 'API tokeny',
    tabComputers: 'Počítače',
    tabSecurity: 'Zabezpečenie',
    tabNotifications: 'Oznámenia',
    tabCli: 'Modely',
    apiDocs: 'Dokumentácia API',
    tabTerminal: 'Terminál',
    tabMemory: 'Pamäť',
    tabPersonality: 'Osobnosť',
    personalPluginConfig: 'Osobné nastavenia pluginu',
    platformLinkConflict: 'Táto identita je už prepojená s iným účtom.',
    linkedAccounts: 'Prepojené účty',
    linkDisconnect: 'Odpojiť',
    detailsTitle: 'Osobné údaje',
    detailsHint: 'Ako sa zobrazujete v pracovnom priestore a kam vám chodia e-maily.',
    appearanceTitle: 'Vzhľad',
    appearanceHint: 'Predvoľby zobrazenia pre toto zariadenie.',
    passwordRequirement: 'Použite aspoň 8 znakov.',
  },
  accountMemory: {
    recallTitle: 'Automatické vyhľadávanie spomienok',
    recallToggle: 'Vyhľadávať v pamäti po každej správe',
    liveRecallTitle: 'Vyhľadávanie pri príprave odpovede',
    liveRecallToggle: 'Znovu vyhľadávať spomienky počas prípravy odpovede',
    saveTitle: 'Automatické ukladanie',
    saveToggle: 'Ukladať nové spomienky po každej odpovedi',
    learnSkillsTitle: 'Učenie skillov',
    learnSkillsToggle: 'Učiť sa skilly z dokončenej práce',
    saveError: 'Nastavenie pamäte sa nepodarilo uložiť.',
    review: {
      last: 'Naposledy {date}',
      none: 'Zatiaľ neprebehol žiadny prechod',
      outcome: { nothing: 'nič nenavrhnuté', saved: 'uložené: {names}', rejected: 'návrhy zamietnuté', failed: 'zlyhalo', aborted: 'vypršal čas' },
      totals: 'celkom {parts}',
      runs: { one: '{n} prechod', few: '{n} prechody', many: '{n} prechodov' },
      saved: { one: '{n} uložený skill', few: '{n} uložené skilly', many: '{n} uložených skillov' },
      failed: { one: '{n} zlyhanie', few: '{n} zlyhania', many: '{n} zlyhaní' },
      next: { one: 'ďalší prechod o {n} krok', few: 'ďalší prechod o {n} kroky', many: 'ďalší prechod o {n} krokov' },
    },
    dreaming: {
      abortCause: {
        disabled: 'Zastavené po vypnutí údržby pamäte.',
        noProgress: 'Údržba bola ukončená, pretože dávka neskontrolovala žiadne ďalšie spomienky.',
        user: 'Zastavené používateľom.',
        accountDeleted: 'Zastavené z dôvodu odstránenia účtu.',
        daemonPause: 'Prerušené pri pozastavení služby.',
        parentTeardown: 'Zastavené pri ukončení nadradenej konverzácie.',
        treeAbort: 'Zastavené spolu s nadradenou úlohou.',
        recovery: 'Zastavené pri obnove služby.',
      },
      operationTitle: 'Údržba pamäte',
      reviewing: 'Skontrolované {reviewed} z {total} spomienok',
      showHistory: 'Zobraziť celú históriu',
      hideHistory: 'Skryť históriu',
      title: 'Automatická údržba pamäte',
      hint: 'Zlučuje podobné poznámky, opravuje zastarané údaje a skracuje pamäte pre ďalšie použitie.',
      toggle: 'Automatická údržba pamäte',
      off: 'Kým je táto voľba vypnutá, nič nebeží automaticky.',
      model: 'Model údržby',
      modelHint: 'Ktorý model spomienky zlučuje. Predvolená voľba preberá model konverzácie, z ktorej údržba vychádza.',
      sameModel: 'Rovnaký model ako konverzácia',
      unavailable: 'Nedostupný',
      overview: 'Prebehnuté údržby',
      overviewHint: 'Kedy ktorá údržba prebehla a čo zmenila. Po rozbalení uvidíte stav každej spomienky pred zmenou a po nej.',
      runNow: 'Spustiť teraz',
      deleteRun: 'Odstrániť z histórie',
      deleteTitle: 'Odstrániť záznam údržby?',
      deleteBody: 'Tento záznam bude odstránený z histórie údržby. Vaše spomienky a ich história zmien zostanú zachované.',
      deleteError: 'Záznam údržby sa nepodarilo odstrániť.',
      stop: 'Zastaviť',
      empty: 'Zatiaľ neprebehla žiadna údržba',
      emptyHint: 'Prvá údržba sa spustí sama, keď bude účet dostatočne v pokoji, alebo hneď po tom, čo ju spustíte ručne.',
      noChanges: 'Táto údržba nezmenila žiadnu spomienku.',
      loadError: 'Údržbu pamäte sa nepodarilo načítať.',
      runsError: 'Prebehnuté údržby sa nepodarilo načítať.',
      changesError: 'Zmeny tejto údržby sa nepodarilo načítať.',
      openMemory: 'Otvoriť pamäte',
      before: 'Pred',
      after: 'Po',
      memory: 'Spomienka #{id}',
      older: 'Staršie',
      newer: 'Novšie',
      trigger: { auto: 'automaticky', manual: 'ručne' },
      status: { running: 'prebieha', completed: 'dokončené', failed: 'zlyhalo', aborted: 'zastavené', interrupted: 'prerušené' },
      counts: 'pridané {added} · upravené {updated} · zlúčené {merged} · zmazané {deleted} · skontrolované {reviewed}/{batch}',
      refusal: {
        model_not_allowed: 'Zvolený model nie je pre tento účet povolený.',
        model_unavailable: 'Zvolený model sa už neponúka.',
        memory_tools_not_granted: 'Tento účet nesmie zapisovať do pamäte, preto údržba nemôže bežať.',
        memory_writes_denied_by_rule: 'Zápis do pamäte blokuje pravidlo oprávnení, preto údržba nemôže bežať.',
        no_conversation: 'Údržba vychádza z niektorej z vašich konverzácií a zatiaľ žiadna nie je k dispozícii.',
        spend_limit: 'Účet dosiahol limit útraty.',
      },
    },
  },
  personality: {
    intro: 'Nastavte, ako má Chetty komunikovať a spolupracovať s vami.',
    styleLabel: 'Štýl komunikácie',
    styleProfessional: 'Profesionálny',
    styleFriendly: 'Priateľský',
    styleConcise: 'Stručný',
    styleDetailed: 'Podrobný',
    bodyLabel: 'Pokyny pre agenta',
    bodyPlaceholder: 'Napíšte vlastné pokyny pre Chetty…',
    bodyHint: 'Vlastné pokyny, ako sa má Chetty správať a spolupracovať s vami. Platia všade.',
    bodyEdit: 'Upraviť pokyny',
    bodyAdd: 'Pridať pokyny',
    saveError: 'Pokyny sa nepodarilo uložiť',
  },
  memory: {
    embeddingTestError: 'Test vloženého modelu sa nepodaril.',
    // List
    workspaceIntro: 'Trvalé informácie, rozhodnutia a preferencie, ktoré môže Chetty využívať v ďalších konverzáciách.',
    synchronized: 'Pamäť synchronizovaná',
    metricDecisions: 'Rozhodnutia',
    metricFacts: 'Fakty',
    searchPlaceholder: 'Hľadať v pamäti…',
    searchClear: 'Zrušiť hľadanie',
    openRow: 'Otvoriť pamäť: {excerpt}',
    filterStatus: 'Stav',
    filterKind: 'Druh',
    statusActive: 'Aktívne',
    statusArchived: 'Archivované',
    statusDeleted: 'Vymazané',
    statusAll: 'Všetko',
    allKinds: 'Všetky druhy',
    empty: 'Zatiaľ žiadne spomienky.',
    emptyHint: 'Pridajte fakt, ktorý si má asistent pamätať, alebo ich nechajte zaznamenávať počas práce.',
    emptySearch: 'Vášmu vyhľadávaniu nevyhovuje žiadna spomienka.',
    newMemory: 'Nová spomienka',
    detailTitle: 'Detail spomienky',
    // Detail fields
    fieldBody: 'Spomienka',
    fieldBodyPlaceholder: 'Trvalý, samostatne zrozumiteľný fakt…',
    fieldKind: 'Druh',
    fieldKindPlaceholder: 'napr. user, feedback, project, reference',
    fieldImportance: 'Dôležitosť',
    fieldVitality: 'Vitalita',
    // Usage
    usage: 'Využitie',
    useCount: 'Použité {n}×',
    neverUsed: 'Nikdy nepoužité',
    usedAt: 'Použité',
    // Vývoj vitality (graf v detaile)
    vitalityChart: 'Vývoj vitality',
    vitalitySeriesLabel: 'rad',
    vitalitySeriesMeasured: 'namerané',
    vitalitySeriesForecast: 'predpoveď',
    vitalityEvictOn: 'Presunie sa do koša {date}',
    vitalityForecastHint: 'Prerušovaná čiara počíta s tým, že sa spomienka už znova nevybaví.',
    vitalityNoHistory: 'Táto spomienka sa používala ešte pred začiatkom zaznamenávania histórie. Preto sa zobrazuje len predpoveď.',
    // Timestamps
    createdAt: 'Vytvorené',
    updatedAt: 'Upravené',
    sourceLabel: 'Zdroj',
    detailsHeading: 'Podrobnosti',
    // Actions
    edit: 'Upraviť',
    delete: 'Vymazať',
    restore: 'Obnoviť',
    merge: 'Zlúčiť',
    save: 'Uložiť',
    done: 'Hotovo',
    cancel: 'Zrušiť',
    create: 'Vytvoriť',
    // Toasts
    bodyRequired: 'Text spomienky je povinný',
    // Delete confirm
    deleteConfirmTitle: 'Vymazať spomienku?',
    deleteConfirmBody: 'Spomienka sa presunie do koša a asistent si ju prestane vybavovať. Neskôr ju môžete obnoviť.',
    // Merge
    mergeTitle: 'Zlúčiť spomienky',
    mergeHint: 'Vybrané spomienky sa spoja do jednej novej. Pôvodné sa presunú do koša.',
    mergeBodyLabel: 'Zlúčená spomienka',
    mergeSelected: 'Vybrané: {n}',
    mergeConfirm: 'Zlúčiť',
    mergeNeedsTwo: 'Na zlúčenie vyberte aspoň dve spomienky.',
    // Permanent delete and trash
    purge: 'Vymazať natrvalo',
    purgeConfirmTitle: 'Vymazať natrvalo?',
    purgeConfirmBody: 'Týmto sa spomienka natrvalo odstráni. Nemožno ju obnoviť.',
    purgeConfirm: 'Vymazať natrvalo',
    emptyTrash: 'Vysypať kôš',
    emptyTrashConfirmTitle: 'Vysypať kôš?',
    emptyTrashConfirm: 'Natrvalo vymaže všetky spomienky v koši. Túto akciu nemožno vrátiť späť.',
    // Card order (filter panel)
    sortLabel: 'Radenie',
    sortDirection: 'Smer',
    sortDescending: 'Zostupne',
    sortAscending: 'Vzostupne',
    // Bulk selection
    selectPage: 'Vybrať túto stránku',
    selectRow: 'Vybrať pamäť: {excerpt}',
    clearSelection: 'Zrušiť výber',
    selectedCount: 'Vybrané: {n}',
    bulkDelete: 'Vymazať vybrané',
    bulkDeleteConfirmTitle: 'Vymazať vybrané spomienky?',
    bulkDeleteConfirmBody: 'Presunúť vybrané spomienky do koša ({n})? Neskôr ich môžete obnoviť.',
    bulkRestore: 'Obnoviť vybrané',
    // History
    auditHeading: 'História',
    auditEmpty: 'Zatiaľ žiadna história.',
    actionAdd: 'Pridané',
    actionUpdate: 'Upravené',
    actionDelete: 'Vymazané',
    actionRestore: 'Obnovené',
    actionMerge: 'Zlúčené',
    eventModel: 'Model',
    // Retrieval debug
    // Používateľská údržba
    maintenanceTitle: 'Údržba pamäte',
    maintenanceIntro: 'Obnovte údaje na vyhľadávanie alebo usporiadajte svoje spomienky. Operácie prebiehajú na pozadí a pokračujú aj pri chybe jednotlivých položiek.',
    maintenanceReindex: 'Znovu vytvoriť index spomienok',
    maintenanceReindexRow: 'Index pamäte',
    maintenanceReindexHint: 'Znova vytvorí údaje na vyhľadávanie všetkých aktívnych spomienok vo vašom účte.',
    maintenanceRecategorize: 'Znova usporiadať spomienky',
    maintenanceRecategorizeRow: 'Triedenie pamäte',
    maintenanceRecategorizeHint: 'Model na triedenie zaradí vaše spomienky do vašich kategórií.',
    maintenanceCategorizationUnconfigured: 'Pred usporiadaním spomienok nastavte v Nastaveniach model na triedenie.',
    maintenanceRun: 'Spustiť',
    maintenanceRunAll: 'Spustiť pre všetko',
    maintenanceAll: 'Znova usporiadať všetky spomienky',
    maintenanceAllConfirmTitle: 'Znova usporiadať všetky spomienky?',
    maintenanceAllConfirmBody: 'Kategorizačný model skontroluje každú aktívnu spomienku vo vašom účte. Ručné zmeny vykonané počas operácie zostanú zachované.',
    maintenanceFailed: 'Údržba pamäte zlyhala.',
    maintenanceRunning: 'Prebieha',
    maintenanceDone: 'Dokončené',
    maintenanceError: 'Zlyhalo',
    maintenanceInterrupted: 'Prerušené reštartom',
    maintenanceInterruptedChip: 'Prerušené',
    maintenanceCounts: 'Úspešne: {succeeded}; zlyhalo: {failed}.',
    maintenanceAcknowledge: 'Potvrdiť výsledok',
    maintenanceIdle: 'Pripravené',
    maintenanceFailures: 'Neaktualizované položky: {n}',
    // Embedding settings
    embeddingProvider: 'Poskytovateľ embeddingov',
    embeddingProviderPlaceholder: 'napr. openai',
    embeddingModel: 'Model embeddingov',
    embeddingDimensions: 'Dimenzie',
    embeddingUnconfigured: 'Nenastavené',
    embeddingSaveError: 'Uloženie nastavenia embeddingu zlyhalo',
    embeddingTest: 'Otestovať',
    embeddingTesting: 'Testujem…',
    embeddingTestOk: 'Test úspešný — {dimensions} dimenzií.',
    embeddingUnconfiguredError: 'Najprv nastavte poskytovateľa embeddingu.',
    reindexUnconfigured: 'Pred reindexáciou nastavte poskytovateľa embeddingu.',
    // Categories
    categoryFilter: 'Kategória',
    categoryAll: 'Všetky kategórie',
    categoryUncategorized: 'Bez kategórie',
    categoryChipNone: 'Bez kategórie',
    groupByCategory: 'Zoskupiť podľa kategórie',
    categoriesTitle: 'Kategórie',
    categoriesEmpty: 'Zatiaľ žiadne kategórie.',
    categoryNew: 'Nová kategória',
    categoryName: 'Názov',
    categoryNamePlaceholder: 'napr. Preferencie',
    categoryDescription: 'Popis',
    categoryDescriptionPlaceholder: 'Čo do tejto kategórie patrí…',
    categoryProject: 'Rozsah projektu',
    categoryProjectGlobal: 'Globálne (všetky konverzácie)',
    categoryProjectsLoading: 'Načítavajú sa projekty…',
    categoryProjectsError: 'Projekty sa nepodarilo načítať.',
    categoryColor: 'Farba',
    categoryIcon: 'Ikona',
    categoryIconSuggest: 'Navrhnúť ikonu',
    categoryCreate: 'Vytvoriť',
    categoryDelete: 'Vymazať kategóriu',
    categoryDeleteConfirmTitle: 'Vymazať kategóriu?',
    categoryDeleteConfirmBody: 'Kategória sa odstráni a zmizne zo všetkých spomienok, ktoré ju používajú. Samotné spomienky zostanú.',
    categoryNameRequired: 'Názov kategórie je povinný',
    categoryNameExists: 'Kategória s týmto názvom už existuje.',
    categorySaveError: 'Uloženie kategórie zlyhalo',
    memoryCount: '{n}',
    sharedBadge: 'zdieľané · {project}',
    sharedBy: 'Zdieľal {author}',
    categoryShared: 'zdieľaná',
    categorySharedHint: 'Ide o zdieľanú pamäť projektu. Jej opis ovplyvňuje triedenie pre celý tím. Meniť ju môže iba administrátor a projekt už nemožno zmeniť.',
    // Záložky pohľadu
    viewBrain: 'Mapa',
    viewList: 'Zoznam',
    // Neural memory brain
    brainCore: 'Pamäť',
    brainEmpty: 'Zatiaľ nie je čo mapovať.',
    brainEmptyHint: 'S pribúdajúcimi spomienkami sa tu zobrazí ich mapa.',
    brainCategoryCount: '{n} spomienok',
  },
  pills: {
    showMore: "+{n} ďalších",
    showLess: "Zobraziť menej",
  },
  categorization: {
    configured: "Nastavené",
    notConfigured: "Nenastavené",
    saveError: "Nastavenie kategorizácie sa nepodarilo uložiť.",
  },
  brain: {
    routerChoice: 'Router',
    routerRemoveMember: 'Odobrať z routera',
    routerRequirement: 'Vyberte aspoň dva účty od najmenej dvoch poskytovateľov.',
    routerEmpty: 'Vybrané účty nemajú spoločné modely.',
    routerPreviewError: 'Spoločné modely sa nepodarilo načítať.',
    routerPriceUnknown: 'Cena nie je známa',
    routerUnknown: 'nie je známe',
    routerMemberLimits: 'Limity a ceny upravujte pri modeloch členských poskytovateľov.',
    routerLimits: 'Kontext: {context}, výstup: {output}',
    routerPrices: 'USD za milión tokenov: vstup {input}, výstup {output}',
    routerReferenced: 'Účet používa router. Pred odstránením upravte jeho členov.',
    maxSteps: "Max krokov",
    maxStepsHint: "Najvyšší počet kôl s modelom pre jednu požiadavku. Chráni pred zacyklením. Rozsah 100–1 000 po 100, predvolené 200.",
    subagents: {
      forkParentContext: "Zdieľať kontext",
      forkParentContextHint: 'Ak volanie Delegate neurčí inak, sub-agent začne s touto konverzáciou: dostane rovnaký systémový prompt, rovnaké nástroje aj celú históriu. Poskytovateľ tak môže použiť uložený začiatok kontextu, ktorý stojí menej než nový vstup. Vyrovnávacia pamäť sa zdieľa len vtedy, keď sa prístup sub-agenta nijako neobmedzí. Preto mu nemožno nastaviť vlastnú súpravu nástrojov, režim len na čítanie ani typ sub-agenta. Pri použití iného modelu sa vyrovnávacia pamäť nezdieľa.',
    },
    limits: {
      title: "Limity a opätovné pripájanie",
      manage: "Upraviť limity",
      hint: "Limity asistenta a jednotné pravidlá opakovania požiadaviek na model a pripojení.",
      toolOutputMaxLines: 'Výstup: riadky',
      toolOutputMaxLinesHint: "Koľko riadkov výstupu nástroja zobrazí rozbalený náhľad, než sa staršie riadky skryjú. Rozsah {min}–{max}, predvolené {default}.",
      toolOutputMaxChars: 'Výstup: tokeny',
      toolOutputMaxCharsHint: "Približný strop počtu tokenov rozbaleného výstupu nástroja; dlhší výstup sa oreže. Počíta sa so 4 znakmi na token. Rozsah ≈{min}–{max} tokenov, predvolené ≈{default}.",
      toolResultInlineBytes: 'Inline limit',
      toolResultInlineBytesHint: 'Limit pre zobrazenie výsledkov nástrojov a výsledkov odovzdaných pomocou Delegate alebo Workflow. Čo ho prekročí, dorazí len v obmedzenom náhľade; celý obsah zostane dostupný cez Read. Hodnota je v bajtoch. Rozsah 30 000–180 000 B, predvolené 120 000 B.',
      toolResultGroupBudgetBytes: 'Limit na ťah',
      toolResultGroupBudgetBytesHint: "Celkový limit paralelných výsledkov nástrojov a dokončených delegovaných výsledkov v jednom ťahu. Najväčšie výsledky sa odložia na disk, kým sa blok nezmestí. Hodnota je v bajtoch a nikdy neklesne pod limit zobrazenia. Rozsah 100 000–300 000 B, predvolené 200 000 B.",
      compactionFailureLimit: 'Zlyhania',
      compactionFailureLimitHint: 'Po koľkých neúspešných pokusoch za sebou prestane konverzácia automaticky skracovať kontext. Ďalší pokus by spotreboval volanie modelu, ktoré nemôže uspieť. Príliš nízka hodnota zastaví skracovanie aj po krátkom výpadku poskytovateľa. Manuálny príkaz „/compact“ zostáva vždy dostupný. Rozsah 1–10, predvolené 3.',
      retryMaxRetries: 'Počet pokusov',
      retryMaxRetriesHint: 'Koľkokrát sa po prvom pokuse automaticky zopakuje požiadavka na model alebo iná požiadavka, ak prechodná chyba dovoľuje opakovanie. Prvý pokus sa nepočíta. 0 znamená jediný pokus bez automatického opakovania. Spárované počítače a pripojenia platforiem sa znova pripájajú bez obmedzenia počtu, s rovnakým časovaním. Rozsah {min}–{max}, predvolené {default}.',
      retryBaseDelayMs: 'Omeškanie',
      retryBaseDelayMsHint: 'Prestávka pred prvým opakovaním v sekundách, spoločná pre opakovanie požiadaviek na model aj ďalších požiadaviek a obnovu pripojenia. Ďalšie prestávky sa zdvojnásobujú až do 60 s, bez náhodných odchýlok. Minimálna prestávka vyžadovaná serverom môže byť dlhšia. Rozsah {min}–{max} s, predvolené {default}.',
      compactionRetries: 'Zopakovanie',
      compactionRetriesHint: 'Koľkokrát sa požiadavka, ktorá skracuje kontext, pošle znova po prechodnej chybe alebo odmietnutej odpovedi, než sa namiesto nej spustí vstavané zhrnutie. 0 znamená jediné odoslanie bez opakovania. Rozsah {min}–{max}, predvolené {default}.',
      elicitationTimeoutMs: 'Limit otázky',
      elicitationTimeoutMsHint: "Ako dlho čaká odložená otázka AskUserQuestion na odpoveď, než sa vyrieši ako „bez odpovede“. Po vypršaní ju nemožno zodpovedať v žiadnom chate ani kanáli. Rozsah 0,5 min až 6 h, predvolené 6 h.",
      memoryRecallCount: 'Načítané',
      memoryRecallCountHint: "Koľko relevantných spomienok sa vloží do kontextu každého ťahu. Viac = bohatší kontext, ale vyššia spotreba tokenov. Rozsah 1–20, predvolené 10.",
      memoryRecallBytes: 'Rozpočet',
      memoryRecallBytesHint: "Približný rozpočet tokenov pre spomienky vložené na začiatku ťahu; vybavovanie prestane pridávať po jeho dosiahnutí. Rozpočet sa počíta v bajtoch UTF-8, teda v rovnakej jednotke ako vybavovanie počas práce, a zobrazenie odhaduje tokeny približne ako 4 bajty na token. Rozsah ≈1 000–10 000 tokenov, predvolené ≈5 000.",
      memoryRecallWaitMs: 'Čakanie',
      memoryRecallWaitMsHint: 'Ako dlho najviac čaká prvá odpoveď na vybavenie spomienok na začiatku ťahu. Ak hľadanie trvá dlhšie, odpoveď začne bez nich a nájdené spomienky sa pridajú pri ďalšom kroku, prípadne pri nasledujúcej správe. Hodnota 0 nečaká vôbec. Rozsah {min}–{max} s, predvolené {default} s.',
      memoryLiveRecallPasses: 'Živé hľadania',
      memoryLiveRecallPassesHint: 'Bezpečnostný strop vyhľadávania pamätí na pozadí v jednom ťahu, teda vybavovania počas práce. Bráni tomu, aby dlhá slučka nástrojov bez užitočnej pamäte vydávala embeddingy donekonečna; hodnota 0 vybavovanie počas práce vypne. Rozsah 0–20, predvolené 10.',
      memoryLiveRecallCount: 'Dávka',
      memoryLiveRecallCountHint: "Najvyšší počet spomienok, ktoré smie jedno vyhľadanie na pozadí vložiť naraz, teda v jednej dávke vybavovania počas práce. Menšie dávky držia každý krok sústredený; hodnota 0 vybavovanie počas práce vypne. Rozsah 0–10, predvolené 2.",
      memoryLiveRecallBytes: 'Rozpočet ťahu',
      memoryLiveRecallBytesHint: "Celkový rozpočet v bajtoch, ktorý všetky priebežne vložené dávky zdieľajú v jednom ťahu. Hlasový hovor má navyše celkový rozpočet spomienok; zobrazenie odhaduje tokeny približne ako 4 bajty na token. Rozsah ≈2 500–10 000 tokenov, predvolené ≈5 000.",
      voiceMemoryBytes: 'V hovore',
      voiceMemoryBytesHint: 'Celkový rozpočet spomienok pre celý hlasový hovor vrátane úvodu a priebežného vybavovania. Po odovzdaní práce asistentovi sa neobnovuje. Hodnota 0 spomienky v hovore vypne. Ukladá sa v bajtoch vrátane rámovania; zobrazenie odhaduje 4 bajty na token. Rozsah ≈{min}–{max} tokenov, predvolené ≈{default}.',
      goalTurnBudget: 'Počet ťahov',
      goalTurnBudgetHint: 'Predvolený počet samostatných ťahov, ktoré /goal vykoná, než sa pozastaví a požiada vás o potvrdenie. V režime YOLO pokračuje. Rozsah {min}–{max}, predvolené {default}.',
      goalMaxTurns: 'Strop ťahov',
      goalMaxTurnsHint: 'Najvyšší povolený počet samostatných ťahov cieľa. Aj v režime YOLO sa tu cyklus pozastaví, aby cieľ nespotreboval neobmedzené množstvo tokenov. Rozsah {min}–{max}, predvolené {default}.',
      channelSessionCap: 'Živé relácie',
      channelSessionCapHint: "Koľko živých kanálových konverzácií (napr. Discord vlákien) zostáva v pamäti, než sa najdlhšie nepoužitá zahodí (jej história zostáva v databáze). Rozsah 4–256, predvolené 32.",
      clamped: "Uložené ako {value} — zadaná hodnota bola mimo povolený rozsah.",
      filterPlaceholder: 'Filtrovať limity',
      noMatches: 'Filtru nezodpovedá žiadny limit',
      groupToolOutput: 'Výstup nástrojov a výsledky',
      groupCompaction: 'Skracovanie kontextu',
      groupRetries: 'Opakovanie a čakanie',
      groupMemory: 'Pamäť',
      groupGoals: 'Ciele',
      groupChannels: 'Kanály',
      groupSubagents: 'Sub-agenti',
      minuteUnit: "min",
      secondUnit: "s",
      tokenUnit: "tokenov",
    },
    runtime: {
      title: 'Beh',
      manage: "Upraviť behové prostredie",
      hint: 'Nastavenia behu: miestny príkazový riadok, relevantnosť spomienok, odložené nástroje, retencia záznamov a kontrola spojenia chatu. Každá hodnota sa obmedzí na rozumný rozsah. Predvolené hodnoty ponechajte, ak nemáte dôvod ich meniť.',
      localShellTimeoutMs: 'Timeout shellu',
      localShellTimeoutMsHint: "Ako dlho smie bežať príkaz spustený v CLI cez „!“, než bude ukončený. Beží na stroji, kde beží CLI, nie medzi nástrojmi asistenta. Rozsah 10–300 s, predvolené 30 s.",
      codeModeDefaultYieldTimeMs: 'Čakanie exec',
      codeModeDefaultYieldTimeMsHint: "Ako dlho exec čaká bez vlastnej pragmy, kým vráti priebežný výsledok. Príkaz wait má vlastnú dobu čakania. Vyššia hodnota šetrí kolá modelu pri dlhých skriptoch. Rozsah 10–600 s, predvolené 10 s.",
      codeModeMaxOutputTokens: 'Max. výstup',
      codeModeMaxOutputTokensHint: "Režim code: tvrdý strop textového výstupu každého reportu exec aj wait. Obmedzí aj explicitné max_output_tokens a max_tokens, aby skript nezaplnil kontext. Rozsah 1 000–50 000 tokenov, predvolené 10 000.",
      memorySemanticFloorPerMille: 'Prah relevancie',
      memorySemanticFloorPerMilleHint: "Prah relevancie: minimálna sémantická podobnosť, pri ktorej sa spomienka považuje za súvisiacu s dopytom; čokoľvek pod ňou sa do vybavovania ani do vyhľadávania v pamäti nedostane. Vyššia hodnota = prísnejší výber a menej vybavených spomienok. Skutočne súvisiace dvojice sa zvyčajne pohybujú nad 0,50. Rozsah {min}–{max}, predvolené {default}.",
      memoryDuplicatePerMille: 'Prah zápisu',
      memoryDuplicatePerMilleHint: 'Prah duplicity pri ukladaní: pri tejto podobnosti automatické ukladanie považuje novú spomienku za preformulovanie už uloženej a nahradí ju. Spomienku uloženú asistentom zachová a iba upozorní na podobnosť. Nižšia hodnota obmedzí duplicity, ale zvyšuje riziko prepísania inej informácie. Po zmene embedding modelu alebo výraznom náraste počtu spomienok prah znova overte. Rozsah 0,50–0,98, predvolené 0,93.',
      memoryParaphrasePerMille: 'Prah čítania',
      memoryParaphrasePerMilleHint: 'Prah duplicity pri vybavovaní: pri tejto podobnosti už ďalšia spomienka nepridá novú informáciu, a preto sa do promptu nezaradí. Zabraňuje tomu, aby dva záznamy o tej istej veci zabrali dve z mála dostupných miest. Chyba tu iba vynechá jeden výsledok, preto môže byť hodnota voľnejšia než pri ukladaní. Rozsah 0,50–0,98, predvolené 0,70.',
      memoryImportanceWeightPerMille: 'Dôležitosť',
      memoryImportanceWeightPerMilleHint: "Váha dôležitosti pri vybavovaní: akou časťou sa na poradí vybavených spomienok podieľa ručne nastavená dôležitosť. Zvyšok po odčítaní tejto a nasledujúcej hodnoty pripadá na zhodu s dopytom, takže zvýšením oboch znižujete vplyv samotnej otázky. Rozsah 0–30 %, predvolené 10 %.",
      memoryVitalityWeightPerMille: 'Váha vitality',
      memoryVitalityWeightPerMilleHint: "Váha vitality pri vybavovaní: akou časťou sa na poradí podieľa vitalita, teda ako často a ako nedávno bola spomienka použitá. Pozor: vitalita rastie práve z vybavovania, takže vysoká hodnota vytvára slučku, v ktorej sa stále dokola vybavuje to isté a zvyšok pamäte sa k slovu nedostane. Rozsah 0–30 %, predvolené 10 %.",
      memoryCuratorMaxOps: 'Zápisy pamäti',
      memoryCuratorMaxOpsHint: "Koľko spomienok smie automatické ukladanie po jednej výmene najviac pridať, upraviť alebo zmazať. Hodnota 0 automatické ukladanie úplne vypne; ručné nástroje pamäte fungujú ďalej. Vyššia hodnota zapĺňa pamäť rýchlejšie, než ju stíhate kontrolovať. Rozsah 0–6, predvolené 2.",
      memoryDreamingMinHours: 'Po hodinách',
      memoryDreamingMinHoursHint: "Zlučovanie spomienok: ako dlho musí byť pamäť bez údržby, kým môže začať ďalšie automatické slučovanie spomienok. Slučovanie porovnáva spomienky z viacerých konverzácií, takže kratší interval znamená viac prechodov a vyššie náklady. Rozsah {min}–{max} h, predvolené {default}.",
      memoryDreamingMinSessions: 'Po konverzácii',
      memoryDreamingMinSessionsHint: "Zlučovanie spomienok: koľko ďalších konverzácií účtu musí od posledného prechodu obsahovať dokončenú výmenu, kým môže začať ďalšie automatické slučovanie. Jedna vyťažená konverzácia ešte neznamená, že si uložené spomienky odporujú. Rozsah {min}–{max}, predvolené {default}.",
      skillReviewMaxOps: 'Zápisy skillov',
      skillReviewMaxOpsHint: "Koľko zápisov skillov (vytvorenie alebo vylepšenie skillu) smie jedna kontrola navrhnúť. Obmedzuje navrhnuté zápisy, nie volania modelu. Hodnota 0 učenie skillov vypne pre všetkých; ručné nástroje skillov fungujú ďalej. Skilly, ktoré človek napísal alebo upravil, sa nikdy nemenia. Rozsah {min}–{max}, predvolené {default}.",
      skillReviewMaxCorrections: 'Opravy JSON',
      skillReviewMaxCorrectionsHint: "Ďalšie volania modelu v tej istej kontrole, ak nemožno prečítať JSON alebo má obálka návrhov nesprávny tvar. Neopakuje neplatné jednotlivé návrhy ani chyby poskytovateľa. Hodnota 0 opravy vypne. Každé ďalšie volanie sa bežne účtuje. Rozsah {min}–{max}, predvolené {default}.",
      skillReviewEveryToolCalls: 'Kontrola po N',
      skillReviewEveryToolCallsHint: "Kontrola skillov po každých N volaniach nástrojov. Počíta sa naprieč výmenami: keď dokončené vhodné výmeny účtu dosiahnu spolu toľko úspešných volaní nástrojov, skontroluje sa kontext dokončenej konverzácie. Nižšia hodnota nájde viac postupov a stojí viac volaní modelu. Rozsah {min}–{max}, predvolené {default}.",
      skillReviewMinToolCalls: 'Min. volaní',
      skillReviewMinToolCallsHint: "Najmenej volaní nástrojov pre kontrolu skillov. Počíta sa v rámci jednej dokončenej výmeny: výmena s menším počtom úspešných volaní nástrojov je na postup príliš jednoduchá, preto sa nekontroluje ani nezapočítava do intervalu kontroly. Zvýšte ju, ak sa má učiť iba z dlhších úloh. Rozsah {min}–{max}, predvolené {default}.",
      eventRetentionDays: 'Log aktivity',
      eventRetentionDaysHint: "Ako dlho sa záznamy o aktivite v časovej osi uchovávajú, než ich hodinové upratovanie odstráni. Rozsah 1–365 dní, predvolené 30 dní.",
      providerRequestRetentionDays: 'Diagnostika',
      providerRequestRetentionDaysHint: 'Ako dlho zostávajú presné telá požiadaviek na poskytovateľov dostupné na diagnostiku problémov. Upratovanie vždy odstráni celú diagnostiku relácie, nikdy iba časť požiadavky, a konverzáciu ponechá nezmenenú. Rozsah 1–90 dní, predvolené 14 dní.',
      providerRequestRetentionMiB: 'Limit úložiska',
      providerRequestRetentionMiBHint: 'Celkový limit úložiska presnej diagnostiky požiadaviek poskytovateľom v novom formáte. Po jeho prekročení upratovanie odstráni najstaršie celé diagnostické relácie. Konverzácie aj zachované požiadavky zostanú nedotknuté. Staršie záznamy sa riadia vyššie uvedeným časovým limitom. Rozsah 64–16384 MiB, predvolené 1024 MiB.',
      originIpRetentionDays: 'IP adresy',
      originIpRetentionDaysHint: "Ako dlho zostane zaznamenaná IP adresa klienta čitateľná v prehľade spotreby podľa pôvodu, než ju hodinové upratovanie nahradí zástupnou hodnotou. Súčty tokenov a nákladov zostanú zachované, zmizne iba adresa. Samotný záznam sa odstráni neskôr, podľa retencie protokolu aktivity vyššie. Rozsah 1–365 dní, predvolené 30 dní.",
      streamSilenceLimitMs: 'Nečinnosť',
      streamSilenceLimitMsHint: "Ako dlho smie dátový tok chatu zostať bez jediného rámca — správy alebo tepu démona — na stránke, ktorú máte otvorenú pred sebou, než prehliadač vyhlási spojenie za mŕtve a pripojí sa znova. Dolná hranica končí zámerne na 35 s: tep prichádza každých 30 s, takže kratší limit by za mŕtvy označil aj zdravý, len nečinný tok. Rozsah 35–300 s, predvolené 75 s.",
      streamReviveSilenceLimitMs: 'Po prebudení',
      streamReviveSilenceLimitMsHint: "To isté ticho merané vo chvíli, keď sa stránka prebudí (odomknutie obrazovky, návrat na kartu). Spiaca stránka nespúšťa žiadne časovače, takže kontrola vyššie prebehnúť nemohla a stav toku sa posudzuje podľa hodín — spravidla o niečo prísnejšie. Rovnaká dolná hranica 35 s ako pri limite vyššie, a z rovnakého dôvodu. Rozsah 35–300 s, predvolené 45 s.",
      toastDurationMs: 'Oznámenie',
      toastDurationMsHint: "Ako dlho zostane oznámenie v pravom hornom rohu webovej aplikácie na obrazovke, než samo zmizne. Prejdením myšou sa odpočet pozastaví a zavrieť ho možno vždy ručne, takže táto hodnota určuje len to, ako dlho čaká samo od seba. Rozsah 2–15 s, predvolené 4,5 s.",
      stepContextEveryToolCalls: 'Pripomienky',
      stepContextEveryToolCallsHint: 'Ako často sa počas ťahu pripomienky pluginov pridajú. Bežné pripomienky počítajú vyvolania nástrojov v jednom ťahu. Zoznam úloh počíta správy asistenta od poslednej zmeny úlohy aj od poslednej pripomienky. Paralelné vyvolania sa počítajú ako jedna správa asistenta a správy obsahujúce iba premýšľanie sa nepočítajú. Uložené hodnoty zostávajú. Pripomienky sa pridávajú do konverzácie bez prepisovania vyrovnávacej pamäte promptu. Vypnutie príslušného pluginu vypne jeho pripomienky.',
      planModeExploreAgents: 'Prieskum',
      planModeExploreAgentsHint: "Agenti prieskumu: koľko prieskumných sub-agentov len na čítanie ponúkne režim Plánovanie najviac spustiť súbežne, kým asistent skúma kód. Koľko ich naozaj spustí, rozhodne asistent, zvyčajne jedného. Hodnota 0 nechá prieskum na asistentovi samotnom. Platí len tam, kde sú sub-agenti k dispozícii. Rozsah {min}–{max}, predvolené {default}.",
      planModePlanAgents: 'Návrh',
      planModePlanAgentsHint: "Agenti návrhu: koľko plánovacích sub-agentov len na čítanie ponúkne režim Plánovanie najviac spustiť súbežne, aby zmenu navrhli každý z iného pohľadu. Koľko ich naozaj spustí, rozhodne asistent a výsledný plán zapíše sám. Hodnota 0 nechá návrh len na asistentovi. Platí len tam, kde sú sub-agenti k dispozícii. Rozsah {min}–{max}, predvolené {default}.",
      subagentRunnerEnabled: 'V procesoch',
      subagentRunnerEnabledHint: "Delegované ťahy pobežia vo vlastných procesoch, takže systém rozdelí prácu medzi jadrá a rozhranie zostane svižné. Vypnuté ich spúšťa vnútri démona. Zmena platí hneď, bez reštartu.",
      clamped: 'Uložené ako {value}: zadaná hodnota bola mimo povoleného rozsahu.',
      filterPlaceholder: 'Filtrovať nastavenia',
      noMatches: 'Filtru nezodpovedá žiadne nastavenie',
      groupExecution: 'Spúšťanie príkazov',
      groupMemory: 'Pamäť',
      groupSkills: 'Skilly',
      groupPlanning: 'Sub-agenti',
      groupChat: 'Chat a oznámenia',
      groupRetention: 'Retencia',
      secondUnit: "s",
      dayUnit: { one: "deň", few: "dni", many: "dní" },
      tokenUnit: "tokenov",
    },
    toolLoading: {
      title: "Načítanie nástrojov",
      manage: "Spravovať nástroje",
      hint: "Zvoľte, ktoré definície nástrojov zostanú v prompte celé; ostatné sa načítajú na požiadanie. Zmeny platia pre nové a znovu vytvorené konverzácie.",
      globalTitle: "Pravidlá načítania nástrojov",
      globalHint: 'Definície nástrojov nechajte mimo promptu, kým ich nebudete potrebovať. Miestny ToolSearch prehľadáva názvy, popisy a parametre podľa slov a pri nastavenom embeddingovom modeli aj podľa významu. Existujúce konverzácie si ponechajú svoju aktuálnu sadu nástrojov.',
      enabled: "Odložené načítanie",
      enabledHint: 'Vypnuté nastavenie ponechá všetky definície nástrojov v prompte. Vaše voľby pre jednotlivé nástroje zostanú uložené a po opätovnom zapnutí sa znova použijú.',
      threshold: "Prah",
      thresholdHint: 'Nástroje bez výslovnej voľby, okrem základných nástrojov, sa načítajú na požiadanie, keď ich počet prekročí túto hodnotu. Rozsah 1–100, predvolená hodnota 10.',
      search: "Hľadať nástroje",
      searchPlaceholder: "Hľadať nástroje alebo pluginy",
      clearSearch: "Vymazať vyhľadávanie",
      resultCount: {
        one: "{n} nástroj",
        few: "{n} nástroje",
        many: "{n} nástrojov",
      },
      default: "Predvolené",
      immediate: "Ihneď",
      deferred: "Na požiadanie",
      groupMode: "Režim načítania pre {group}",
      toolMode: "Režim načítania pre {tool}",
      plugin: "Plugin",
      builtIn: "Vstavané",
      empty: 'Vyhľadávanie nenašlo žiadny nástroj.',
      loadError: "Katalóg nástrojov sa nepodarilo načítať.",
      saveError: "Nastavenia načítania nástrojov sa nepodarilo uložiť.",
      reason: {
        'global-disabled': "Globálne nastavenie je vypnuté",
        core: "Základný nástroj",
        'tool-override': "Voľba nástroja",
        'source-override': "Voľba pluginu",
        'source-default': "Predvolená voľba",
        threshold: "Automatické pravidlo",
      },
    },
    retention: {
      title: 'Retencia pamäte',
      manage: 'Upraviť uchovávanie',
      hint: 'Ako dlho si nepoužívaná spomienka zachová svoju hodnotu, kým sa presunie do koša. Presun možno vrátiť. Slabne každá úroveň dôležitosti, čím vyššia, tým pomalšie. Koľko spomienok sa smie automaticky presunúť za 24 hodín, určuje denný limit.',
      enabled: 'Automaticky',
      enabledHint: "Hlavný vypínač. Vypnuté = žiadna pamäť sa automaticky nepresunie do koša, bez ohľadu na hodnoty nižšie. V predvolenom stave zapnuté.",
      graceDays: 'Lehota',
      graceDaysHint: 'Nové spomienky sa počas tohto obdobia neodstraňujú, ani keď sa nepoužívajú. Môžu sa tak ešte vybaviť. Rozsah 0–365 dní, predvolená hodnota 14.',
      vitalityFloor: 'Prah hodnoty',
      vitalityFloorHint: 'Aktívna spomienka, ktorej hodnota klesne pod tento prah, sa presunie do koša. Presun možno vrátiť. Vyššia hodnota znamená dôkladnejšie čistenie. Rozsah 1–90, predvolená hodnota 10.',
      dailyDeletionLimit: 'Denný limit',
      dailyDeletionLimitHint: 'Koľko spomienok jedného účtu sa smie automaticky presunúť do koša za ľubovoľných 24 hodín. Ostatné počkajú na ďalšie čistenie. Rozsah 1–200, predvolená hodnota 5.',
      groupCleanup: 'Čistenie pamäte',
      halfLifeSection: 'Polčas rozpadu',
      halfLifeRow: 'Dôležitosť {n}',
      halfLifeLevel: 'Čas do poklesu na polovicu, dôležitosť {n}',
      halfLifeHint: "Za koľko dní klesne hodnota nepoužívanej spomienky na polovicu. Čím nižšia hodnota, tým rýchlejšie spomienka slabne a dosiahne prah. Rozsah 0,1–365 dní, predvolené hodnoty 1/3/7/14/21/30/45/60/90/180.",
    },
    contextWindow: "Kontext",
    contextWindowHint: "Koľko konverzácie a promptu model prijme.",
    modelLimits: "Limity modelu",
    modelLimitsEdit: "Upraviť limity modelu",
    modelLimitOutOfBounds: "Hodnota musí byť číslo od {min} do {max}.",
    modelOverrideInherited: "Zdedené",
    modelVision: "Obrázky",
    modelVisionHint: "Či model vie čítať ťahy s obrázkami.",
    modelVisionYes: "Áno",
    modelVisionNo: "Nie",
    modelPrice: "Cena / 1M tokenov (USD)",
    modelPriceInput: "Vstup",
    modelPriceOutput: "Výstup",
    modelPriceCacheRead: "Čítanie cache",
    modelPriceCacheWrite: "Zápis cache",
    modelPriceHelp: "Cena od poskytovateľa alebo z katalógu. Skutočne účtovaná cena, ak ju poskytovateľ vráti, má prednosť.",
    modelImageResize: "Zmenšenie obrázkov",
    modelImageWidth: "Max. šírka",
    modelImageWidthHint: "Najväčšia šírka obrázka v pixeloch.",
    modelImageHeight: "Max. výška",
    modelImageHeightHint: "Najväčšia výška obrázka v pixeloch.",
    modelImageBytes: "Max. objem",
    modelImageBytesHint: "Najväčšia veľkosť obrázka po zakódovaní.",
    modelImageQuality: "Kvalita JPEG",
    modelImageQualityHint: "Kvalita JPEG pri zmenšení obrázka.",
    modelImageResizeHelp: "Obrázky sa zmenšujú pred uložením do konverzácie. Už uložené obrázky sa nemenia.",
    maxOutputTokens: "Max. výstup",
    maxOutputTokensHint: "Koľko smie model napísať v jednej odpovedi. Nesmie presiahnuť kontext.",
    maxOutputTokensTooLarge: "Toto kontextové okno umožňuje najviac {max} výstupných tokenov.",
    modelsHintPicker: 'Načítané z adresy API. Kliknutím vyberte modely. Ak nevyberiete žiadny, použijú sa všetky.',
    pickModelsTitle: "Modely - {provider}",
    pickModelsHint: 'Vyberte, ktoré modely z tohto účtu môže Chetty ponúkať. Ak nevyberiete žiadny, ponúknu sa iba textové modely. Ostatné druhy vyberte výslovne.',
    modelsUnavailable: 'Už nie je v katalógu',
    filterModelsByKind: 'Filtrovať modely podľa druhu',
    modelOutputKinds: { text: 'Text', embeddings: 'Vektory', image: 'Obrázky', audio: 'Zvuk', video: 'Video', transcription: 'Prepis', speech: 'Reč', decisions: 'Rozhodovanie', rerank: 'Preusporiadanie' },
    imageModelDefault: 'Predvolený model poskytovateľa',
    addAccount: 'Pridať účet',
    account: 'Účet',
    noAccounts: 'Zatiaľ nie je prepojený žiadny účet.',
    paused: 'Pozastavené',
    pause: 'Pozastaviť',
    resume: 'Obnoviť',
    relogin: 'Prihlásiť znova',
    deleteAccount: 'Odstrániť účet',
    deleteAccountConfirm: 'Odstrániť účet {account} aj jeho uložené nastavenie? Prihlásenie a predvoľby sa zrušia; pozastavenie ich na rozdiel od toho zachová.',
    kindsError: 'Nepodarilo sa načítať podporované služby. Skúste to znova, aby ste mohli pridať poskytovateľa.',
    spendLimitAction: 'Limit výdavkov',
    accountCount: { one: '{n} účet', few: '{n} účty', many: '{n} účtov' },
    accountUsage: 'Čerpanie účtov',
    settings: 'Nastavenia',
    detailSections: 'Časti nastavení poskytovateľa',
    tabGeneral: 'Všeobecné',
    tabConnection: 'Pripojenie',
    tabAdvanced: 'Pokročilé',
    connected: 'Pripojené',
    accountActive: 'Aktívny',
    providerId: 'ID poskytovateľa',
    providerIdHint: 'Identifikátor, na ktorý odkazujú modely, oprávnenia a priradené roly. Volí sa raz pri vytvorení poskytovateľa a nikdy sa nemení.',
    advancedNone: 'Tento poskytovateľ nemá žiadne pokročilé nastavenia.',
    routing: {
      title: 'Smerovanie',
      on: 'Smerovanie zapnuté',
      off: 'Smerovanie vypnuté',
      enabled: 'Automaticky vyberať účet',
      enabledHint: 'Vypnuté: každá konverzácia používa predvolený účet a nič samo nepreskakuje. Zapnuté: vyberie sa účet s najnižším čerpaním, bežiaca konverzácia si účet ponechá a vyčerpaný účet sa nahradí iným spôsobilým účtom.',
      defaultAccount: 'Predvolený účet',
      defaultAccountHint: 'Účet, ktorý používa vypnuté smerovanie, a jeden z kandidátov pri zapnutom smerovaní. Prechádza rovnakými kontrolami ako každý iný účet, takže pozastavený alebo nepovolený predvolený účet znamená nedostupného poskytovateľa, nie obchádzanie voľby.',
      noDefault: 'Bez predvoleného účtu',
      idleRebalance: 'Presúvať neaktívne konverzácie',
      idleRebalanceHint: 'Presunúť nečinnú konverzáciu na menej čerpaný účet. Meria sa od poslednej modelovej požiadavky; dlho bežiaci nástroj ani stream nie sú nečinnosť.',
      idleMinutes: 'Presunúť po nečinnosti',
      idleMinutesHint: 'Ako dlho musí byť konverzácia nečinná, kým sa smie presunúť. Vyhodnocuje sa pri ďalšej požiadavke, nikdy buďením počas nečinnosti.',
      minGain: 'Minimálne zlepšenie',
      minGainHint: 'Najmenšie zlepšenie v najviac čerpanom kvótovom okne, ktoré ospravedlní dobrovoľný presun, aby konverzácie nepreskakovali kvôli drobnému kolísaniu.',
      minutes: '{n} min',
      hours: '{n} h',
      days: '{n} d',
      points: '{n} p. b.',
    },
    usageWeekly: 'týždenne',
    usageWindow: 'okno',
    usageResets: 'Obnoví sa {time}',
    usageResetsUtc: 'Free modely, denný limit, obnoví sa {time} (00:00 UTC)',
    usageDaily: 'denne',
    usageMonthly: 'mesačne',
    usageBalance: 'Zostatok',
    usageBalanceHint: 'Zostatok: {amount}',
    usageLimit: 'Limit',
    usageKeyLimitHint: 'Limit kľúča {amount}',
    usageFreeModels: 'Free',
    usageSpend: 'Výdavky',
    accounts: 'Prepojené účty',
    providers: 'Poskytovatelia AI',
    addProvider: 'Pridať poskytovateľa',
    removeProvider: 'Odobrať poskytovateľa',
    removeProviderConfirm: 'Odobrať {provider} a jeho uložené nastavenia? Akciu nemožno vrátiť späť.',
    providerLabel: 'Názov',
    baseUrl: 'Adresa API',
    baseUrlHintOpenai: 'Vrátane verzie, napr. https://ai.example.com/v1',
    baseUrlHintAnthropic: 'Prázdne = https://api.anthropic.com',
    probeFailed: 'Endpoint neodpovedal: {reason}',
    apiKey: 'API kľúč',
    apiKeyKeepHint: 'Nechajte prázdne, ak chcete ponechať uložený kľúč.',
    wireApi: 'Wire API',
    wireApiMessages: 'Anthropic',
    modelApi: 'API',
    modelApiReset: 'Resetovať API',
    modelApiParameterReset: 'Resetovať detekciu parametra {parameter}',
    modelApiUnavailable: 'Stav API nie je dostupný.',
    temperature: 'Teplota',
    temperatureInvalid: 'Zadajte číslo od 0 do 2 alebo nechajte pole prázdne, aby sa použila predvolená hodnota modelu.',
    temperatureHint: 'Určuje, ako veľmi model mení formulácie. Nižšia hodnota znamená ustálenejšie odpovede, vyššia nápaditejšie. Nechajte pole prázdne, aby sa hodnota neposielala a model použil vlastné predvolené nastavenie. Platí iba pre tohto poskytovateľa, pretože niektoré modely iné hodnoty neprijímajú. Kimi K3 a Claude Opus 4.7 a novšie prijímajú iba predvolenú hodnotu.',
    compatibility: {
      title: 'Kompatibilita',
      safeHint: 'Auto preberá nastavenie modelu. Hodnoty meňte iba podľa dokumentácie poskytovateľa.',
      safeDefaults: 'Automatické nastavenie',
      customSummary: '{n} vlastné nastavenia',
      on: 'Zapnuté',
      off: 'Vypnuté',
      temperatureOverride: 'Vlastná teplota',
      reset: 'Obnoviť automatické nastavenie',
      supportsLongCacheRetention: 'Cache 24 h',
      supportsLongCacheRetentionHint: 'Odosiela prompt_cache_retention a stabilný kľúč vyrovnávacej pamäte. Nepodporované koncové body môžu odmietnuť celú požiadavku.',
      supportsDeveloperRole: 'Rola developer',
      supportsDeveloperRoleHint: 'Na pokyny modelu používa rolu developer. Pri sprostredkovacích službách, ktoré prijímajú iba klasickú rolu system, nechajte túto voľbu vypnutú.',
      supportsUsageInStreaming: 'Štatistiky',
      supportsUsageInStreamingHint: 'Vyžiada súčty tokenov v poslednej udalosti prenosu pomocou stream_options.',
      supportsStrictMode: 'Prísny režim',
      supportsStrictModeHint: 'Označí schémy funkcií ako prísne. Zapnite iba vtedy, keď koncový bod podporuje prísny režim OpenAI.',
      supportsStore: 'Ukladanie',
      supportsStoreHint: 'Odosiela store: false. Niektoré kompatibilné koncové body toto pole špecifické pre OpenAI nepoznajú.',
      supportsReasoningEffort: 'Úvaha',
      supportsReasoningEffortHint: 'Ak model podporuje uvažovanie, umožní odoslať zvolenú úroveň ako reasoning_effort.',
      maxTokensField: 'Limit tokenov',
      maxTokensFieldHint: 'Vyberte pole požiadavky, ktorým tento koncový bod obmedzuje dĺžku odpovede modelu.',
    },
    wireApiAuto: 'Auto',
    wireApiResponses: 'Responses',
    wireApiCompletions: 'Chat Completions',
    models: 'Modely',
    modelsHintAuto: 'Zadajte jedno ID modelu na riadok. Ak zoznam necháte prázdny, modely z /models tohto koncového bodu sa načítajú automaticky.',
    modelCount: 'Počet modelov: {n}',
    modelsAuto: 'Modely sa vypisujú automaticky',
    keySet: 'Kľúč je nastavený',
    hostedSearchUnsupported: 'Vyhľadávanie nástrojov nie je podporované',
    hostedSearchUnverified: 'Vyhľadávanie nástrojov nie je overené',
    codeModeTitle: 'Režim kódu',
    codeModeHelp: 'Model dostane jediný nástroj `exec`, ktorého vstupom je JavaScript, a na ostatné nástroje siaha zvnútra skriptu. Nadväzujúce volania sa tak vybavia v jednom ťahu namiesto jedného kola modelu za každé. Každé volanie ďalej prechádza rovnakými oprávneniami a schvaľovaním ako priame volanie. Platí pre všetky modely tohto poskytovateľa. Najlepšie s ním pracujú modely trénované na tento spôsob práce (GPT-5.6 a novšie); pri inom modeli si najprv porovnajte skutočnú úlohu, než ho necháte zapnutý.',
    responsesStatefulTitle: 'Stavové odpovede',
    responsesStatefulHelp: 'Poskytovateľ ukladá odpovede na svojich serveroch a ďalšie požiadavky nadväzujú na predchádzajúce. Môže to zvýšiť využitie vyrovnávacej pamäte. Dobu uchovávania určuje poskytovateľ.',
    hostedSearchTitle: 'Vstavané vyhľadávanie nástrojov',
    hostedSearchHelp: 'Poskytovateľ hľadá nástroje vo svojom katalógu, takže sa celý katalóg neposiela v prompte. Po vypnutí sa použije miestny ToolSearch, ktorý hľadá podľa slov v názvoch, popisoch a parametroch. Každé miestne hľadanie stojí model jedno kolo navyše. Vstavané vyhľadávanie vyžaduje aj zapnutú voľbu „Odkladať externé nástroje“.',
    toolStatusError: 'Nepodarilo sa načítať stav spúšťania nástrojov u poskytovateľov uvedených nižšie.',
    testProvider: 'Otestovať pripojenie',
    testOk: 'Test prebehol úspešne, model: {model}',
    testFailed: 'Test zlyhal',
    testUnreachable: 'Test sa nepodarilo vykonať. Skontrolujte, či je služba Chetty dostupná, a skúste to znova.',
    saveError: 'Uloženie poskytovateľov zlyhalo',
    providerSaveError: 'Poskytovateľa sa nepodarilo uložiť. Skontrolujte adresu koncového bodu a prihlasovacie údaje a skúste to znova.',
    noProviders: 'Zatiaľ nie sú nastavení žiadni poskytovatelia. Pridajte jedného, aby ho mohol asistent používať.',
    notConnected: 'Nepripojené',
    connect: 'Pripojiť',
    disconnect: 'Odpojiť',
    disconnectConfirm: 'Odpojiť {provider}? Chetty prestane tento účet používať, kým ho znovu nepripojíte.',
    connectedToast: 'Účet pripojený',
    connectFailed: 'Pripojenie účtu zlyhalo',
    connectError: 'Prihlásenie sa nepodarilo spustiť.',
    connectUnknownAccount: 'Tento účet už v konfigurácii nie je. Zavrite dialóg a pridajte účet znova.',
    connectInProgress: 'Prihlásenie tohto účtu už prebieha. Dokončite alebo zavrite to prebiehajúce a skúste to znova.',
    connectTitle: 'Pripojiť účet',
    connectStarting: 'Spúšťa sa prihlasovanie…',
    connectUserCode: 'Zadajte tento kód',
    connectCodePlaceholder: 'Vložte kód alebo adresu presmerovania',
    connectMethod: 'Spôsob prihlásenia',
    connectBrowser: 'Prehliadač',
    connectCopyCode: 'Cez kód',
    connectCopyCodeHint: 'Otvorte autorizačný odkaz, prihláste sa a vložte kód zobrazený službou Claude.',
    connectSubmitError: 'Kód sa nepodarilo odoslať. Skúste to prosím znova.',
    connectCodeError: 'Prihlásenie sa nepodarilo. Kód môže byť nesprávny alebo už neplatný. Zatvorte toto okno a spustite prihlásenie znova.',
    connectSubmitCode: 'Odoslať',
    connectWaiting: 'Čaká sa na dokončenie prihlasovania…',
    keyAccount: {
      minimaxKeyHint: 'Vložte Subscription Key z medzinárodného účtu MiniMax (M Plan). Bežný kľúč pre platbu podľa spotreby ani čínsky účet nepoužívajte. Kľúč sa uloží na tomto serveri a už sa nezobrazí.',
      connectTitle: 'Pripojiť {provider}',
      editTitle: 'Pripojenie: {provider}',
      editConnection: 'Upraviť pripojenie',
      accountLabel: 'Názov účtu',
      accountLabelHint: 'Pod týmto názvom je účet uvedený. Premenovanie nemení ID ani históriu.',
      endpointHint: 'Adresa, ktorú pre túto službu určuje katalóg.',
      keyHint: 'Vložte kľúč API zo svojho účtu {provider}. Je uložený na tomto serveri a už sa nezobrazuje.',
      format: 'Formát API',
      formatHint: 'Auto vyberá API pre každý model. Výberom formátu nastavíte API pre celý provider.',
    },
    types: {
      'openai': 'Kompatibilné s OpenAI',
      'anthropic': 'Anthropic API',
      'oauth-anthropic': 'Účet Claude',
      'oauth-openai-codex': 'Účet ChatGPT',
      'oauth-github-copilot': 'GitHub Copilot',
      'oauth-kimi': 'Účet Kimi',
      'oauth-xai': 'Účet xAI',
      'oauth-meta': 'Účet Meta',
      'oauth-opendesign': 'Účet Opendesign',
      'oauth-openrouter': 'Účet Openrouter',
    },
    stats: {
      button: "Štatistiky",
      trackedSince: "Sledované od {day}",
      refreshError: "Štatistiky sa nepodarilo obnoviť. Zobrazené údaje môžu byť zastarané.",
      rangeHelp: "Dni sa počítajú v UTC a obdobie vždy zahŕňa celé dni.",
      kpiTokens: "Tokeny",
      kpiCost: "Cenníková cena",
      kpiRequests: "Požiadavky",
      kpiCache: "Zásahy cache",
      kpiCacheHelp: "Podiel vstupu, ktorý poskytovateľ prečítal zo svojej cache, namiesto aby ho dostal znova.",
      costHelpSubscription: "Cenníková cena je suma, ktorú by rovnaké tokeny stáli podľa cien za token, ktoré Chetty pre tieto modely pozná. Účty s predplatným sa neúčtujú za token, preto ide o ekvivalent, nie o skutočný poplatok. Model bez známej ceny sa počíta ako $0.00.",
      costHelpComputed: "Cenníková cena sa počíta z cien modelov, ktoré Chetty pozná, preto sa môže líšiť od vašej faktúry. Model bez známej ceny alebo model zadarmo sa počíta ako $0.00.",
      costHelpReported: "OpenRouter hlási cenu každej požiadavky, preto je táto suma tým, čo si účtoval, nie odhadom.",
      costUnavailable: "Nedostupné",
      allowanceTitle: "Limit využitia",
      allowanceNone: "Limit nie je hlásený",
      allowanceNoneHelp: "Tento poskytovateľ nehlási limit využitia, ktorý by Chetty mohol prečítať, preto sa nezobrazuje žiadne percento.",
      usersTitle: "Kto to používal",
      usersHelp: "Podiel každej osoby na tokenoch, ktoré Chetty v danom období poslal tomuto poskytovateľovi, pripísaný tomu, kto ťah zadal. Nejde o podiel na limite poskytovateľa.",
      usersOthers: "Ostatní",
      modelsTitle: "Modely",
      trendTitle: "Po dňoch",
      chartTokens: "Tokeny",
      chartCost: "Cenníková cena",
      chartsAriaLabel: "Tokeny a cenníková cena po dňoch",
      breakdownTitle: "Rozpis tokenov",
      tokensIn: "Vstup",
      tokensOut: "Výstup",
      cacheRead: "Čítanie z cache",
      cacheWrite: "Zápis do cache",
      reasoning: "Uvažovanie",
      breakdownHelp: "Tokeny uvažovania sú už započítané vo výstupe.",
      empty: "V tomto období žiadne využitie",
      emptyNever: "Pre tohto poskytovateľa zatiaľ nič nebolo zaznamenané",
      loadError: "Štatistiky sa nepodarilo načítať",
      subscriptionTitle: "Predplatné",
      subscriptionUnavailable: "Aktuálne okná sa práve nepodarilo načítať.",
      quotaTitle: "Podiel predplatného využitý za deň",
      quotaHelp: "Poskytovatelia hlásia len aktuálne okno, preto si ho Chetty priebežne zapisuje: skoršie dni sa nedajú spätne získať, využitie pred prvým meraním a medzi posledným meraním a obnovením okna sa nezaznamená a za dni, keď Chetty nebežal, údaj chýba. Prvý zaznamenaný deň sa preto počíta len od svojho prvého merania. Údaje platia pre celý účet vrátane použitia mimo Chettyho.",
      quotaRecordingStarted: "Zaznamenávanie predplatného práve začalo. Graf sa bude v nasledujúcich dňoch postupne napĺňať.",
      quotaEmptyRange: "V tomto období nebolo nič zaznamenané. Zaznamenávanie sa začalo {day}.",
      quotaGapNote: "V niektoré dni chýbali hodiny merania, pretože Chetty nebežal alebo poskytovateľ nebol dostupný. Využitie za ten čas je pripísané ku dňu, keď bolo prvýkrát vidieť.",
      quotaSince: "Zaznamenávané od {day}",
      quotaTotal: "Za toto obdobie",
      quotaTotalHelp: "Súčet dní v grafe. 100 % je jedno celé okno ({window}), takže za dlhšie obdobie môže hodnota presiahnuť 100 %.",
      quotaBusiest: "Najvyťaženejší deň",
      quotaBusiestGap: "môže zahŕňať aj skoršie dni",
      quotaSeriesConsumed: "Využité za deň (okno: {window})",
      quotaChartAria: "Podiel predplatného využitý za deň",
      tokensSectionTitle: "Tokeny cez Chettyho",
      tokensSectionHelp: "Tokeny, ktoré Chetty poslal tomuto poskytovateľovi. Ide o vlastné počítanie Chettyho a nie je to to isté ako percentá predplatného vyššie, ktoré platia pre celý účet.",
    },
  },
  plugins: {
    bundled: 'Vstavaný',
    user: 'Používateľský',
    tools: 'Nástroje',
    skills: 'Skilly',
    platforms: 'Platformy',
    enable: 'Zapnúť',
    disable: 'Vypnúť',
    pendingToast: 'Zmena je uložená. Prejaví sa pri najbližšom spustení démona.',
    restartingToast: 'Zmena je uložená. Chetty sa teraz reštartuje, aby ju načítala.',
    grantsTitle: 'Zapnúť plugin {name}?',
    grantsIntro: 'Tento plugin žiada o prístup, ktorý pretrvá aj po skončení odpovede. Zapnutím mu udelíte:',
    grantsConfirm: 'Zapnúť a udeliť',
    grantTools: 'Meniť nástroje dostupné agentovi vrátane nahradenia existujúcich',
    grantControl: 'Používať rozhranie pluginu {control}',
    grantToolAuthority: 'Používať profil oprávnení {authority} pre nástroje zodpovedajúce vzoru {pattern}',
    grantManagedProjectRead: 'Čítať súbory spravovaných projektov',
    grantOwnOutputRead: 'Čítať uložené výstupy vlastnej konverzácie',
    grantProjectFileRead: 'Čítať súbory projektov cez rozhranie pre binárne dáta',
    grantProjectFileWrite: 'Zapisovať súbory projektov cez rozhranie pre binárne dáta',
    grantProjectTransfer: 'Prenášať súbory medzi prístupnými projektmi',
    grantSkillLoad: 'Načítavať skilly pomocou nástrojov zodpovedajúcich vzoru {pattern}',
    grantServerAutomation: 'Spúšťať automatizované úlohy na serveri',
    grantTerminalTimeouts: 'Čítať nastavenia časových limitov terminálu',
    grantAgentDirectory: 'Čítať adresár definícií sub-agentov',
    grantWorkflowEngine: 'Používať workflow engine',
    authorityGranted: 'Udelené',
    authorityMissing: 'Chýba súhlas',
    grantPrompt: 'Nahradiť systémový prompt a promptové šablóny',
    grantEvents: 'Zapisovať do protokolu aktivity',
    grantWorkflowDag: 'Meniť bežiace workflow sub-agentov',
    grantConversations: 'Zakladať konverzácie v pridelených účtoch a spúšťať v nich agenta na náklady účtu',
    dependencyHelp: 'Funguje iba so zapnutými doplnkami {plugins}.',
    dependencyOn: 'Tento doplnok vyžaduje, aby ste najprv zapli doplnok {plugin}, ktorý poskytuje {control}.',
    dependencyMissing: 'Tento doplnok vyžaduje iný doplnok poskytujúci {control}, žiadny však nie je nainštalovaný.',
    dependencyInUse: 'Tento doplnok poskytuje {control}, ktorý doplnok {plugin} stále potrebuje. Najprv vypnite {plugin}.',
    toggleError: 'Zmena pluginu zlyhala',
    updateInProgress: 'Prebieha aktualizácia. Pred zmenou tohto pluginu prosím počkajte na jej dokončenie.',
    empty: 'Žiadne pluginy nenájdené',
    searchPlaceholder: 'Hľadať pluginy…',
    categoryFilter: 'Kategória',
    catAll: 'Všetko',
    catPlatforms: 'Platformy',
    catTools: 'Nástroje',
    catMemory: 'Pamäť',
    catAutomation: 'Automatizácia',
    catUi: 'Rozhranie',
    catSecurity: 'Zabezpečenie',
    catDevelopment: 'Vývoj',
    healthOk: 'V poriadku',
    healthError: 'Chyba',
    noMatches: 'Žiadne zodpovedajúce pluginy',
    noMatchesHint: 'Skúste iný hľadaný výraz alebo kategóriu.',
    install: 'Inštalovať',
    installing: 'Inštaluje sa…',
    installError: 'Inštalácia pluginu zlyhala',
    installQueued: 'Inštalácia pluginu sa začala. Chetty sa o chvíľu krátko reštartuje a plugin potom bude pripravený.',
    updateQueued: 'Aktualizácia pluginu sa začala. Chetty sa o chvíľu krátko reštartuje a potom pobeží nová verzia.',
    updateAllQueued: 'Aktualizácia pluginov sa začala. Chetty sa o chvíľu krátko reštartuje a potom pobežia nové verzie.',
    repairQueued: 'Oprava pluginu sa začala. Chetty sa o chvíľu krátko reštartuje a plugin potom bude opäť v poriadku.',
    uninstall: 'Odinštalovať',
    uninstallConfirm: 'Naozaj odinštalovať plugin „{name}“? Jeho súbory aj uložené dáta sa odstránia.',
    uninstallError: 'Odinštalovanie pluginu zlyhalo',
    remove: 'Odobrať',
    removeConfirm: 'Odobrať vstavaný plugin „{name}“? Zmizne zo zoznamu a prestane sa načítavať. Súbory zostanú a plugin môžete kedykoľvek obnoviť v časti Dostupné pluginy.',
    removedError: 'Odobranie pluginu zlyhalo',
    restore: 'Obnoviť',
    restoreError: 'Obnovenie pluginu zlyhalo',
    removedSection: 'Odobrané vstavané pluginy',
    updateAvailable: 'K dispozícii je novšia verzia',
    updateError: 'Aktualizácia pluginu zlyhala',
    updateAll: 'Aktualizovať všetky pluginy',
    updateAllConfirm: 'Aktualizovať všetky pluginy s dostupnou novšou verziou? Aktualizácia prebehne spoločne a reštartuje Chettyho. Vypnuté pluginy zostanú vypnuté.',
    marketplaceEmpty: 'Zatiaľ nie sú dostupné žiadne ďalšie pluginy',
    marketplaceError: 'Katalóg pluginov sa nepodarilo načítať',
    detail: 'Detail',
  },
  pluginDetail: {
    workspaceNav: 'Pracovný priestor pluginu',
    tabSetup: 'Prepojenie',
    tabBehavior: 'Správanie',
    tabCapabilities: 'Schopnosti',
    tabActivity: 'Aktivita',
    tabAdvanced: 'Pokročilé',
    setupChecklist: 'Kontrola prepojenia',
    setupChecklistHint: 'Povinné údaje, ktoré plugin potrebuje na spustenie.',
    setupMissing: 'Chýba {n}',
    setupNoRequired: 'Tento plugin nemá žiadne povinné kroky prepojenia.',
    statusTitle: 'Stav',
    statusHint: 'Čo plugin potrebuje na fungovanie. Kontrola prebieha priebežne.',
    statusOk: 'Všetko funguje',
    statusProblem: 'Vyžaduje pozornosť: {n}',
    statusCopy: 'Kopírovať',
    overviewVersion: 'Verzia',
    overviewSource: 'Zdroj',
    statusDisabled: 'Vypnuté',
    config: 'Konfigurácia',
    behaviorEmpty: 'Tento plugin nemá žiadne ďalšie nastavenia správania.',
    configEmpty: 'Tento plugin nemá žiadne nastavenia.',
    tools: 'Nástroje',
    toolsHint: 'Nástroje, ktoré tento plugin pridáva asistentovi.',
    toolsEmpty: 'Tento plugin neregistruje žiadne nástroje.',
    skills: 'Skilly',
    platforms: 'Platformy',
    hooks: 'Háky',
    hooksHint: 'Háky, ktoré tento plugin registruje počas behu asistenta.',
    hooksEmpty: 'Tento plugin neregistruje žiadne háky.',
    hookExecutions: 'Nedávne spustenia',
    hookExecutionsHint: 'Každé spustenie háku tohto pluginu, jeho výsledok a trvanie.',
    outcomeOk: 'Aplikované',
    outcomeThrew: 'Zlyhalo',
    outcomeTimeout: 'Vypršal čas',
    outcomeRejected: 'Odmietnuté',
    permissions: 'Oprávnenia',
    capabilities: 'Deklarované schopnosti',
    capabilitiesDeny: 'V predvolenom stave zakázané: plugin smie len to, čo tu deklaruje. Chýbajúca schopnosť znamená, že danú akciu nemôže vykonať.',
    capMutates: 'Smie meniť',
    capNetwork: 'Sieť',
    capNetworkOn: 'Odchádzajúci prístup',
    capReads: 'Číta',
    capAuthorities: 'Súhlasy s právomocami',
    permissionsHint: 'Čo tento plugin potrebuje a aký je citlivý.',
    requiresEnv: 'Vyžadované premenné prostredia',
    requiresConfig: 'Vyžadovaná konfigurácia',
    requiresNone: 'Tento plugin nevyžaduje žiadne špeciálne prostredie ani konfiguráciu.',
    riskLow: 'Nízke riziko',
    riskMedium: 'Stredné riziko',
    riskHigh: 'Vysoké riziko',
    data: 'Uložené dáta',
    dataPath: 'Umiestnenie',
    dataSize: 'Veľkosť',
    dataFiles: '{n} súborov',
    dataPartial: 'Meranie je neúplné: prehľad narazil na limit, preto uvedené súčty predstavujú najnižšie možné hodnoty.',
    dataUnreadable: '{n} položiek sa nedalo zmerať. Disk prostredia patrí jeho stroju a táto služba doň nevidí.',
    dataEmpty: 'Tento plugin zatiaľ neuložil žiadne dáta.',
    dataClear: 'Vymazať dáta',
    dataClearConfirm: 'Vymazať všetky uložené dáta tohto pluginu? Túto akciu nemožno vziať späť.',
    dataClearError: 'Vymazanie dát pluginu zlyhalo',
    logs: 'Logy',
    logsHint: 'Najnovšie riadky logu z tohto pluginu.',
    logsEmpty: 'Žiadne nedávne záznamy v logu.',
  },
  agents: {
    tokens: 'Tokeny',
    steeredInto: 'počas práce dostal nové pokyny',
    steerQueued: 'Čaká na prevzatie',
    steerDelivered: 'Pokyn doručený',
    steerDropped: 'Pokyn nedoručený',
  },
  brainChat: {
    skillLabel: 'Skill',
    archiveWaiting: 'Čaká sa na odpoveď. Pred zatvorením ju zadajte.',
    archiveFailed: 'Konverzáciu sa nepodarilo archivovať.',
    archiveConflict: 'Konverzácia sa zmenila. Pred ďalším pokusom ju načítajte znova.',
    compacting: 'Prebieha zhrnutie konverzácie…',
    ux: {
      recalledInputsLabel: 'Vrátené správy',
      recalledInputsCount: 'Čaká na obnovenie: {count}',
      restoreRecalledInput: 'Obnoviť správu',
      messageCopy: "Kopírovať správu",
      codeCopy: "Kopírovať kód",
      regenerate: "Vygenerovať znova",
      editResend: "Upraviť a znova odoslať",
      editMessage: "Upraviť správu",
      reissueConfirm: "Znova spustiť túto výmenu?",
      reissueWarning: "Pôvodná odpoveď sa nahradí. Už vykonané akcie sa nevrátia späť a nástroje sa môžu spustiť znova.",
      reissueUnconfirmed: "Výsledok odoslania nie je potvrdený. Najprv obnovte stav konverzácie.",
      attachmentsKept: "Pôvodné prílohy sa zachovajú.",
      approvalConversation: "Povoliť v tejto konverzácii",
      approvalConversationHint: "Povoliť „{pattern}“ pre tento účet a prostredie v tejto konverzácii, aj po reštarte.",
      approvalInstead: "Nie, namiesto toho…",
      approvalInstruction: "Čo má model urobiť namiesto toho?",
      approvalSubmitInstead: "Odmietnuť a odovzdať pokyn",
      approvalFeedbackRequired: "Zadajte pokyn s dĺžkou 1 až 2000 znakov.",
      approvalConversationOutcome: "Povolené v tejto konverzácii",
      approvalFeedbackOutcome: "Odmietnuté s pokynom",
      revokeConsents: "Zrušiť súhlasy",
      revokeConsentsHint: "Zrušia sa iba vaše uložené súhlasy v tejto konverzácii.",
      consentsRevoked: "Súhlasy pre túto konverzáciu boli zrušené.",
      deliveryNow: "Odovzdať teraz",
      deliveryChanged: "Odovzdané, Chetty si správu prečíta hneď v ďalšom kroku.",
      deliveryUnavailable: "Túto správu už nemožno odovzdať teraz. Stav fronty bol obnovený.",
      searchTitle: "Hľadať v konverzácii",
      searchPlaceholder: "Hľadaný text (aspoň 2 znaky)…",
      searchEmpty: "Žiadne zodpovedajúce správy.",
      searchFailed: "Správy sa nepodarilo vyhľadať.",
      searchNext: "Ďalšia zhoda",
      searchPrevious: "Predchádzajúca zhoda",
      searchMore: "Načítať ďalšie zhody",
      searchCount: "Načítané zhody: {count}",
      searchLatest: "Späť k najnovším",
      shortcutsTitle: "Klávesové skratky",
      shortcutsCommands: "Príkazy",
      shortcutsScope: "Skratky platia iba pri práci v chate. Mimo chatu sa klávesy prehliadača nemenia.",
      shortcutChange: "Zmeniť",
      shortcutCapture: "Stlačte klávesy…",
      shortcutUnbound: "Nenastavené",
      shortcutInvalid: "Neplatný zápis skratky.",
      shortcutConflict: "Túto skratku používa akcia „{action}“.",
      shortcutReserved: "Túto kombináciu nemožno použiť vo webovom chate.",
      shortcutSaveError: "Skratky sa nepodarilo uložiť.",
      replyAction: "Odpovedať",
      cancelReply: "Zrušiť odpoveď",
      typingOne: "{name} píše…",
      typingMany: "Píšu: {names}",
      answeringUser: "Odpovedá používateľovi: {name}",
      unreadDivider: "Nové správy",
      jumpToUnread: "Prejsť na nové správy",
      muteConversation: "Stlmiť oznámenia",
      unmuteConversation: "Zapnúť oznámenia",
      conversationMuted: "Oznámenia konverzácie sú stlmené.",
      conversationUnmuted: "Oznámenia konverzácie sú zapnuté.",
      conversationMuteFailed: "Nastavenie oznámení sa nepodarilo uložiť.",
      globalReplyMuteHint: "Oznámenia odpovedí sú naďalej stlmené v nastavení účtu.",
      shortcutActions: {
        leader: "Predpona skratiek",
        mode_toggle: "Prepnúť režim",
        reasoning_cycle: "Úroveň premýšľania",
        stash: "Odložiť správu",
        rewind: "Vrátiť správu",
        rename: "Premenovať konverzáciu",
        subagent_cycle: "Prepnúť agenta",
        subagent_stop: "Zastaviť agenta",
        telemetry_toggle: "Štatistiky",
        queue_steer: "Odoslať z frontu",
        queue_remove: "Odobrať z frontu",
        stop: "Zastaviť beh",
        reconnect: "Obnoviť pripojenie",
        help: "Otvoriť pomocníka",
        theme_picker: "Zmeniť vzhľad",
        model_picker: "Vybrať model",
        sessions_picker: "Vybrať konverzáciu",
        search: "Hľadať v konverzácii",
      },
    },
    promptHistoryError: 'Históriu promptov sa nepodarilo načítať alebo uložiť v tomto prehliadači.',
    leaderPending: 'Ctrl+X: čaká na ďalšiu klávesu',
    suggestionHint: 'Tab alebo medzerník vloží návrh; Enter odošle správu.',
    viewLabel: 'Interaktívne zobrazenie',
    viewLoading: 'Načítanie zobrazenia…',
    viewError: 'Odpoveď sa nepodarilo potvrdiť. Skúste voľbu znova.',
    historyLoadError: 'Konverzácie sa nepodarilo načítať.',
    loadingOlder: 'Načítavanie starších správ',
    olderLoadError: 'Staršie správy sa nepodarilo načítať.',
    attach: 'Priložiť súbor',
    attachRemove: 'Odobrať prílohu',
    attachmentAlt: 'Priložený obrázok',
    attachmentOpen: 'Otvoriť v plnej veľkosti',
    attachmentGone: 'Obrázok už nie je k dispozícii',
    imageAttached: 'Obrázok v konverzácii',
    messageBlocks: 'Položky spomenuté v odpovedi',
    fileDownload: 'Stiahnuť',
    attachFailed: 'Súbor sa nepodarilo nahrať a nebol priložený.',
    uploadProgress: 'Nahrávanie súboru {name}',
    uploadPercent: '{percent} %',
    uploadCancel: 'Zrušiť nahrávanie súboru {name}',
    attachedFile: 'priložený súbor',
    attachOnly: '(príloha)',
    deleteChat: 'Vymazať konverzáciu',
    deleteChatConfirmTitle: 'Vymazať túto konverzáciu?',
    deleteChatConfirmDescription: 'Týmto natrvalo vymažete „{title}“ a celú históriu správ. Ak je konverzácia práve otvorená, chat sa prepne na inú. Akciu nemožno vrátiť späť.',
    deleteChatError: 'Konverzáciu sa nepodarilo vymazať. Nič sa nezmenilo.',
    bulkDelete: 'Vymazať vybrané',
    bulkDeleteConfirmTitle: 'Vymazať vybrané konverzácie?',
    bulkDeleteConfirmBody: 'Týmto natrvalo vymažete {n} konverzácií a ich históriu správ. Ak je medzi nimi práve otvorená konverzácia, chat sa prepne na inú. Akciu nemožno vrátiť späť.',
    bulkDeletePartial: 'Vymazaných konverzácií: {done}, {failed} sa nepodarilo vymazať.',
    bulkDeleteFailed: 'Vybrané konverzácie sa nepodarilo vymazať. Nič sa nezmenilo.',
    selectedCount: 'Vybrané: {n}',
    clearSelection: 'Zrušiť výber',
    selectRow: 'Vybrať konverzáciu: {title}',
    context: 'kontext',
    newChat: 'Nová konverzácia',
    searchPlaceholder: 'Hľadať v konverzáciách…',
    searchError: 'Vyhľadávanie sa nepodarilo dokončiť',
    searchOpenError: 'Túto konverzáciu nemožno otvoriť',
    newChatError: 'Novú konverzáciu sa nepodarilo založiť.',
    abortError: 'Odpoveď sa nepodarilo zastaviť.',
    conversationBusy: 'Konverzácia práve čaká na dokončenie inej akcie. Skúste správu odoslať neskôr.',
    sendError: 'Správu sa nepodarilo odoslať. Koncept zostal v editore.',
    sendErrorPreviousConversation: 'Správa do predchádzajúcej konverzácie nebola odoslaná. Jej text čaká v koncepte tej konverzácie.',
    freshConversation: 'Predchádzajúca konverzácia nebola aktívna. Pokračujeme v novej.',
    readOnly: 'Táto konverzácia prebieha na inej platforme alebo v úlohe. Tu ju môžete iba sledovať.',
    readOnlyExit: 'Späť do chatu',
    childFocusCommandDisabled: 'Tento príkaz patrí do hlavnej konverzácie. Najprv opustite zobrazenie sub-agenta.',
    untitled: 'Bez názvu',
    placeholder: 'Napíšte správu alebo zadajte / pre príkazy',
    placeholderShort: 'Správa…',
    send: 'Odoslať',
    stop: 'Zastaviť',
    rewindHelp: 'F9: zastaviť odpoveď, potom odoberať posledné správy',
    rewindEmpty: 'Žiadna ďalšia správa na odobratie.',
    rewindActionsRemain: 'História konverzácie bola odobratá. Už vykonané akcie zostávajú v platnosti.',
    rewindFailed: 'Históriu sa nepodarilo zmeniť.',
    clearCompacting: 'Kontext konverzácie sa práve skracuje. Skúste to znova, keď to skončí.',
    clearSettling: 'V konverzácii prebieha práca. Zastavte ju alebo počkajte na dokončenie.',
    clearQueued: 'V poradí čaká správa. Odstráňte ju alebo počkajte na odoslanie.',
    clearPendingQuestion: 'Najprv odpovedzte na čakajúcu otázku alebo ju zatvorte.',
    clearDelegationRunning: 'Beží podriadený agent alebo workflow. Zastavte ho alebo počkajte na dokončenie.',
    clearProcessRunning: 'Beží proces na pozadí. Zastavte ho v paneli procesov.',
    clearActiveGoal: 'Najprv pozastavte alebo zrušte aktívny cieľ.',
    clearResultPending: 'Čaká sa na doručenie výsledku podriadenej práce. Skúste to znova po jeho doručení.',
    rewindCompacting: 'Kontext konverzácie sa práve skracuje. Skúste to znova, keď to skončí.',
    rewindSettling: 'Odpoveď sa ešte ukladá. Skúste to o chvíľu znova.',
    rewindQueued: 'V poradí čaká správa. Počkajte, kým sa odošle, a skúste to znova.',
    rewindPendingQuestion: 'Najprv odpovedzte na čakajúcu otázku alebo ju zatvorte.',
    rewindActiveGoal: 'Najprv pozastavte alebo zrušte aktívny cieľ.',
    rewindUnsettledTurn: 'Posledný ťah ešte neskončil. Skúste to o chvíľu znova.',
    rewindSubagentRunning: 'Táto odpoveď spustila sub-agenta, ktorý stále beží. Najprv ho zastavte alebo počkajte, kým dobehne.',
    rewindWorkflowRunning: 'Táto odpoveď spustila workflow, ktoré stále beží. Najprv ho zastavte alebo počkajte, kým dobehne.',
    rewindResultPending: 'Výsledok práce spustenej touto odpoveďou ešte nebol doručený. Skúste to znova, keď dorazí.',
    modelSwitchQueued: 'Po aktuálnej odpovedi sa model prepne.',
    modelPicker: 'Model',
    modelPickerLoading: 'Načítavanie modelov…',
    modelPickerEmpty: 'Žiadny dostupný model',
    modelPickerError: 'Modely sa nepodarilo načítať',
    modelPickerRetry: 'Skúsiť znovu',
    projectPickerFailed: 'Cieľ spúšťania sa nepodarilo zmeniť',
    projectPickerHost: 'Bez projektu',
    newConversationProject: {
      title: 'Kde má táto konverzácia bežať?',
      empty: 'Pre tento účet nie je dostupný žiadny projekt.',
    },
    modelActive: 'Aktívny model',
    modelReasoning: 'Náročnosť uvažovania',
    askWaiting: 'Chetty čaká na vaše odpovede',
    approvalWaiting: 'Vyžaduje sa schválenie',
    approvalRunCommand: 'Spustiť tento príkaz?',
    approvalRunTool: 'Povoliť spustenie nástroja „{tool}“?',
    approvalOnce: 'Povoliť raz',
    approvalAlways: 'Povoliť vždy',
    approvalAlwaysHint: 'vždy povoliť „{pattern}“',
    approvalDeny: 'Zamietnuť',
    approvalWarningNote: 'Upozornenie: tento príkaz {note}.',
    approvalWarnings: {
      gitResetHard: 'môže zahodiť necommitnuté zmeny',
      gitForcePush: 'môže prepísať históriu vzdialeného repozitára',
      gitCleanForce: 'môže trvalo zmazať nesledované súbory',
      gitDiscardWorktree: 'môže zahodiť zmeny v pracovnom strome',
      gitStashDrop: 'môže trvalo odstrániť odložené zmeny',
      gitBranchForceDelete: 'môže vynútene zmazať vetvu',
      gitNoVerify: 'môže preskočiť kontrolné hooky',
      gitCommitAmend: 'môže prepísať posledný commit',
      rmRecursiveForce: 'môže násilne odstrániť súbory vrátane podpriečinkov',
      rmRecursive: 'môže odstrániť súbory vrátane podpriečinkov',
      rmForce: 'môže vynútene odstrániť súbory',
      sqlDropTable: 'môže odstrániť alebo vyprázdniť databázové objekty',
      sqlDeleteAll: 'môže zmazať všetky riadky databázovej tabuľky',
      kubectlDelete: 'môže zmazať prostriedky Kubernetes',
      terraformDestroy: 'môže zničiť infraštruktúru spravovanú Terraformom',
      mkfs: 'môže zmazať súborový systém',
      deviceOverwrite: 'môže prepísať surové diskové zariadenie',
      chmodWorldWritable: 'môže sprístupniť súbory na zápis komukoľvek',
      killEveryProcess: 'môže ukončiť všetky procesy tohto účtu',
      forkBomb: 'môže vyčerpať tabuľku procesov',
    },
    askOther: 'Vlastná odpoveď',
    askOtherPlaceholder: 'Napíšte vlastnú odpoveď',
    askSubmit: 'Odoslať odpoveď',
    askRecommended: 'Odporúčané',
    askMulti: 'vyberte jednu alebo viac',
    askPreview: 'Náhľad',
    askDetailBody: 'Celý text',
    askProgress: '{answered} z {total} zodpovedané',
    askSending: 'Odosielam…',
    askRetry: 'Skúsiť znova',
    askReadOnly: 'Na túto otázku možno odpovedať iba v hlavnej konverzácii.',
    askExpired: 'Otázka už nie je dostupná na zodpovedanie.',
    askExpiredRecord: 'Otázka vypršala bez odpovede.',
    askAllowedOnce: 'Povolené raz',
    askAllowedAlways: 'Povolené vždy',
    askDenied: 'Zamietnuté',
    askQuestionOf: 'Otázka {current} z {total}',
    askError: 'Odpoveď sa nepodarilo odoslať. Skúste to znova.',
    toolOutputExpand: 'Zobraziť celý výstup',
    toolOutputCollapse: 'Zobraziť menej',
    diffLabel: 'Rozdiel zmien',
    diffExpand: 'Zobraziť zostávajúcich {n} riadkov rozdielu',
    diffCollapse: 'Zobraziť menej riadkov rozdielu',
    diffRowAdded: 'pridaný riadok',
    diffRowRemoved: 'odobraný riadok',
    cardFallback: 'Karta',
    eventModel: 'model',
    eventWireApi: 'Model teraz komunikuje cez {api}.',
    // Účet vlastnej konverzácie: ktorý účet ju obsluhuje a prečo sa presunula. Daemon rozsah stráži sám —
    // cudzí alebo odňatý predchádzajúci účet dorazí bez mena — takže tu iný pomenovať nemožno.
    accountMoved: 'presunuté: {reason}',
    accountMovedFrom: 'z účtu {account}: {reason}',
    accountChangeReason: {
      paused: 'účet je pozastavený',
      'not-authorized': 'účet na túto konverzáciu nemá oprávnenie',
      'no-credential': 'účet nemá prihlásenie',
      'model-unavailable': 'model tam nie je dostupný',
      'quota-limited': 'kvóta je vyčerpaná',
      'spend-limit': 'účet je obmedzený mesačným limitom výdavkov',
      'already-attempted': 'už bol použitý',
      regenerated: 'prihlásenie bolo obnovené',
      'reconfigured': 'účet bol prekonfigurovaný',
      rebalanced: 'záťaž sa vyvážila',
    },
    eventMode: 'režim',
    eventMembershipJoined: '{name} je novo v konverzácii',
    eventMembershipLeft: '{name} už nie je v konverzácii',
    eventMembershipRemoved: '{name} už nie je v konverzácii · odobranie: {actor}',
    eventMembershipRemovedAnonymous: '{name} už nie je v konverzácii',
    eventPlanDismissed: 'Plán odmietnutý',
    eventPlanHeldComputer: 'Plán zostal na počítači {name} a v tomto kroku nie je k dispozícii. Presunie sa sem, keď bude možné prenos dokončiť.',
    eventPlanHeldProject: 'Plán zostal v projekte {name} a v tomto kroku nie je k dispozícii. Presunie sa sem, keď bude možné prenos dokončiť.',
    eventPlanHeldServer: 'Plán zostal na serveri Chetty a v tomto kroku nie je k dispozícii. Presunie sa sem, keď bude možné prenos dokončiť.',
    eventRenamed: 'premenované',
    eventCwd: 'cwd',
    eventOfflineTarget: 'Počítač {computer} je offline. Konverzácia teraz beží na serveri: {project}.',
    eventSubagentDone: 'sub-agent dokončil prácu',
    eventSubagentFailed: 'sub-agent zlyhal',
    eventWorkflowDone: 'workflow dokončený',
    eventWorkflowFailed: 'workflow zlyhal',
    eventWorkflowStopped: 'workflow zastavený',
    eventDreaming: { one: 'Slučovanie pamätí vylepšilo {n} spomienku', few: 'Slučovanie pamätí vylepšilo {n} spomienky', many: 'Slučovanie pamätí vylepšilo {n} spomienok' },
    eventNodes: 'uzlov',
    eventReasoning: 'uvažovanie',
    eventInterruptedUser: 'Prerušené používateľom',
    eventInterruptedTool: 'Prerušené používateľom počas práce nástroja',
    eventInterruptedStepLimit: 'Zastavené: ťah dosiahol limit {n} krokov',
    eventInterruptedParent: 'Zastavené nadradeným agentom',
    eventError: 'Chyba',
    eventErrorProviderRetries: 'Požiadavka na poskytovateľa zlyhala aj po automatickom opakovaní. Skúste to prosím znova.',
    eventErrorCompactionStopped: 'Automatické skracovanie kontextu zlyhalo {n}× po sebe, preto je v tejto konverzácii vypnuté. Začnite novú konverzáciu alebo spustite /compact sami, keď bude príliš veľký obsah preč.',
    eventErrorCompactionUnreachable: 'Automatické skracovanie nedokáže zmenšiť túto konverzáciu pod svoj prah: aj po skrátení má kontext asi {floor} tokenov, teda aspoň {trigger} tokenov, pri ktorých sa skracovanie spúšťa. Automatické skracovanie je tu preto vypnuté; /compact ďalej funguje a spoľahlivým riešením je nová konverzácia.',
    nativeCheckpointConversionFailed: 'Konverzáciu sa nepodarilo previesť na čitateľnú históriu. Prihláste sa k pôvodnému účtu ChatGPT, overte povolenie pôvodného modelu a skúste zmenu znova.',
    clientSessionStopped: 'Správa nebola odoslaná, pretože toto okno bolo nahradené alebo zastavené. Odošlite ju prosím znova.',
    localTargetOffline: 'Počítač tejto konverzácie je offline. Pripojenie Chettyho na tomto počítači nebeží; spustite ho tam a skúste to znova.',
    localWorkDirMissing: 'Pracovný adresár tejto konverzácie na jej počítači už neexistuje. Obnovte adresár alebo začnite novú konverzáciu v existujúcom adresári.',
    eventErrorModelSwitchFailed: 'Prepnutie modelu zlyhalo: {error}',
    commandCompacted: 'Konverzácia bola skrátená',
    commandNotCompactedAlready: 'Neskrátené: konverzácia už je skrátená, od posledného zhrnutia nepribudlo nič nové',
    commandNotCompactedNothing: 'Neskrátené: zatiaľ nie je čo skracovať',
    commandGoalSet: 'Cieľ nastavený: {goal}',
    commandGoalDraft: 'Koncept cieľa uložený: {goal}',
    commandGoalPaused: 'Cieľ pozastavený',
    commandGoalResumed: 'Cieľ obnovený',
    commandGoalCleared: 'Cieľ zrušený',
    commandGoalNone: 'Žiadny aktívny cieľ',
    commandGoalStatus: 'Cieľ {status} · {used}/{budget} {turns}',
    commandGoalSubgoals: 'Čiastkové ciele {done}/{total}',
    commandGoalPausedReason: 'Pozastavené: {reason}',
    commandGoalEvidence: 'Doklad: {evidence}',
    goalState: { active: 'aktívny', draft: 'koncept', paused: 'pozastavený', done: 'splnený' },
    commandFastOn: 'Rýchly režim je pre tento model zapnutý',
    commandFastOff: 'Rýchly režim je pre tento model vypnutý',
    commandFastUnavailable: 'Rýchly režim pre tento model nie je k dispozícii',
    commandRestart: 'Reštartuje sa démon Chetty…',
    shellExit: 'návratový kód {code}',
    shellKilledTimeout: 'zastavené: vypršal časový limit',
    shellKilledAbort: 'zastavené',
    shellKilledOverflow: 'zastavené: príliš veľký výstup',
    shellOutput: 'Výstup príkazu',
    commandFailedRestartUnavailable: 'Reštart nie je v tomto nasadení k dispozícii',
    commandFailedNotRunning: 'Konverzácia zatiaľ nebeží. Najprv pošlite správu a potom to skúste znova.',
    contextCompacted: 'Kontext skrátený',
    proposedPlan: 'Navrhnutý plán',
    planImplement: 'Implementovať plán',
    planDecision: 'Plán čaká na vaše rozhodnutie. Môžete ho tiež ďalej spresňovať správami.',
    planRefine: 'Spresniť ďalej',
    planDecisionError: 'Rozhodnutie o pláne sa nepodarilo potvrdiť. Skúste to znova.',
    modeSwitchError: 'Režim konverzácie sa nepodarilo zmeniť. Skúste to znova.',
    statusReadError: 'Stav konverzácie sa nepodarilo načítať.',
    workMode: { build: 'Realizácia', plan: 'Plánovanie', workflow: 'Postup' },
    actions: 'Možnosti',
    actionsTitle: 'Možnosti, režim: {mode}',
    workModeGroup: 'Režim práce',
    commandHints: {
      plan: 'Najprv premyslieť postup, zatiaľ bez úprav',
      build: 'Vykonávať zmeny pomocou nástrojov',
      workflow: 'Riadiť úlohu ako graf sub-agentov',
      compact: 'Zhrnúť konverzáciu a uvoľniť miesto v kontexte',
      rename: 'Premenovať túto konverzáciu',
      new: 'Začať novú konverzáciu',
      model: 'Prepnúť model',
    },
    /** A picker command a plugin published that this build has no renderer for. A refusal, not a result:
     *  nothing opened, and the reader is told where the command does work. */
    renameTitle: 'Premenovať konverzáciu',
    commandField: {
      open: 'Otvoriť pole príkazov',
      title: 'Pole príkazov',
      compact: 'Zhustiť',
      rename: 'Premenovať',
      newChat: 'Nová konverzácia',
      model: 'Model',
    },
    queued: 'Vo fronte',
    removeFromQueue: 'Odobrať z frontu',
    queueRemoveError: 'Správu sa nepodarilo odobrať. Stále čaká vo fronte na doručenie.',
    queueDetachCapacity: 'Bol dosiahnutý limit procesov na pozadí.',
    queueDetachUnavailable: 'Bežiacu prácu nemožno presunúť na pozadie.',
    toolRunning: 'Prebieha',
    reasoningLabel: 'Uvažovanie',
    turnDuration: 'Doba behu',
    workLive: 'Pracujem…',
    workDuration: 'Doba práce: {duration}',
    workLog: 'Priebeh práce',
    workStopped: 'Zastavené',
    workStoppedAfter: 'Zastavené po {duration}',
    workFailed: 'Zlyhalo',
    workFailedAfter: 'Zlyhalo po {duration}',
  },
  chat: {
    historyTitle: 'Konverzácie',
    openHistory: 'Všetky konverzácie',
    openRegister: 'Všetky konverzácie',
    registerHint: 'Úplný prehľad konverzácií z webu, CLI, kanálov aj úloh agentov.',
    moreOptions: 'Ďalšie možnosti',
    showStats: 'Zobraziť štatistiky',
    hideStats: 'Skryť štatistiky',
    todos: 'Úlohy',
    emptyHistory: 'Zatiaľ žiadne konverzácie',
    rename: 'Premenovať',
    renamePlaceholder: 'Názov konverzácie',
    renameError: 'Konverzáciu sa nepodarilo premenovať',
    conversationNamePlaceholder: 'Automatický názov',
    pin: 'Pripnúť konverzáciu',
    unpin: 'Odopnúť konverzáciu',
    pinError: 'Pripnutie konverzácie sa nepodarilo zmeniť',
    fork: 'Vetviť konverzáciu',
    forkError: 'Konverzáciu sa nepodarilo rozvetviť',
    exportHtml: 'Exportovať ako HTML',
    exportJsonl: 'Exportovať ako JSONL',
    exportError: 'Export sa nepodaril',
    moreActions: 'Ďalšie akcie',
    roleYou: 'Vy',
    roleElowen: 'Chetty',
    activityIdle: 'Nedávno neprebehla žiadna aktivita',
    activityWorking: 'Prebieha práca',
    activityPermission: 'Čaká na schválenie',
    activityQuestion: 'Čaká na odpoveď',
    activityBackground: 'Prebieha práca na pozadí',
    activityDone: 'Dokončené',
    activityDoneScheduled: 'Naplánovaná úloha dokončená',
    activityFailed: 'Beh sa nepodaril',
    activityUnread: 'Neprečítaný výsledok',
    participants: 'Členovia',
    membersCount: 'Členovia {count}',
    inviteHeading: 'Pozvať…',
    removeMemberLabel: 'Odobrať z konverzácie: {name}',
    participantsLoadFailed: 'Účastníkov sa nepodarilo načítať.',
    participantChangeFailed: 'Účastníkov sa nepodarilo zmeniť.',
    inviteConfirm: 'Pozvať',
    inviteConfirmTitle: 'Pozvať do tejto konverzácie?',
    inviteConfirmBody: 'Uvidí celú históriu.',
    invited: '{name} bol(a) pozvaný(á).',
    alreadyParticipant: 'Už je v konverzácii',
    noInvitable: 'Nikoho ďalšieho nemožno pozvať.',
    invitableLoadFailed: 'Ľudí na pozvanie sa nepodarilo načítať.',
    clearFilter: 'Vymazať filter',
    noPeopleMatch: 'Filtru nezodpovedá nikto.',
    inviteFailed: {
      notShareable: 'Túto konverzáciu nie je možné zdieľať.',
      generic: 'Pozvánku sa nepodarilo odoslať.',
    },
    leaveConversation: 'Opustiť konverzáciu',
    leaveConfirm: 'Opustiť túto konverzáciu?',
    leaveConfirmBody: 'Ručné pozvanie bude zrušené. Prístup zabezpečený pluginom zostane zachovaný.',
    removedFromConversation: 'Boli ste odobraní z tejto konverzácie.',
    conversationUnavailable: 'Konverzácia nie je dostupná.',
    ownerOnlyControl: 'Môže meniť len majiteľ konverzácie.',
    ownerDecidesPlan: 'O pláne rozhoduje majiteľ konverzácie.',
    queuedBy: 'Vo fronte od {name}',
    replyTo: 'Odpoveď na',
    jumpToMessage: 'Prejsť na pôvodnú správu',
    messageUnavailable: 'Správa už nie je k dispozícii.',
    react: 'Reagovať',
    reactionUp: 'Palec hore',
    reactionDown: 'Palec dole',
    reactedBy: 'Reagovali: {names}',
    reactionFailed: 'Reakciu sa nepodarilo uložiť.',
    mentionPlaceholder: 'Spomenúť niekoho',
    mentionOwnerOnly: 'Pozvať môže len majiteľ konverzácie.',
    mentionNotParticipantError: 'Spomenutý účet už nie je v konverzácii.',
    mentionsYou: 'Spomína vás',
    mentionChip: 'Zmienka:',
    mentionAgentHint: 'Odpovie na túto správu',
    ownerBadge: 'Majiteľ',
    agentGroup: 'Zdieľaná konverzácia',
    pauseAgent: 'Pozastaviť agenta',
    pauseAgentHint: 'Ľudia si píšu, agent zatiaľ neodpovedá',
    resumeAgent: 'Spustiť agenta',
    resumeAgentHint: 'Agent odpovie na ďalšiu správu a uvidí všetko',
    agentPaused: 'Agent je pozastavený. Správy uvidí po spustení, alebo hneď, keď ho spomeniete cez @Chetty.',
    agentPauseFailed: 'Stav agenta sa nepodarilo zmeniť.',
  },
  telemetry: {
    title: 'Telemetria',
    contextUsed: 'Využité',
    contextTokens: 'Tokeny',
    cost: 'Cena',
    resize: 'Šírka panela telemetrie',
    open: 'Zobraziť telemetriu',
    close: 'Skryť telemetriu',
    collapse: 'Zbaliť panel telemetrie',
    expand: 'Rozbaliť panel telemetrie',
    statusRunning: 'Prebieha práca',
    statusIdle: 'Nečinný',
    empty: 'Zatiaľ nie sú k dispozícii žiadne údaje.',
    limits: 'Limity',
    goal: 'Cieľ',
    goalTurns: { one: 'ťah', few: 'ťahy', many: 'ťahov' },
    goalSubgoals: 'Podciele',
    goalProgress: 'Priebeh: {text}',
    tasks: 'Úlohy',
    tasksOpen: 'Otvoriť zoznam úloh',
    taskWaiting: 'čaká na {ids}',
    workflow: 'Workflow',
    branch: 'vetva',
  },
  workflowModal: {
    elapsed: 'Doba behu',
    graph: 'Graf uzlov workflow',
    wave: 'Vlna {n}',
    gone: 'Toto workflow už nie je v živom prehľade.',
    statusPending: 'čaká',
    statusRunning: 'beží',
    statusDone: 'hotovo',
    statusError: 'zlyhalo',
    deps: 'Závisí od',
    depsNone: 'bez závislostí',
    result: 'Výsledok',
    error: 'Chyba',
    activity: 'Priebeh',
    working: 'Pracuje…',
    failed: 'Uzol zlyhal.',
    notStarted: 'Uzol zatiaľ nezačal.',
    noOutput: 'Nebol uvedený žiadny výstup.',
    openConversation: 'Otvoriť konverzáciu',
    openUnavailable: 'Dostupné po spustení uzla.',
    followLive: 'Sledovať priebeh',
    followLiveHint: 'Výberom bežiaceho uzla obnovíte sledovanie.',
    backToGraph: 'Graf',
    feeds: 'Nadväzuje',
    task: 'Úloha',
    model: 'Model',    status: 'Stav',
    reasoning: 'Uvažovanie',
    tokens: 'Tokeny',
    speed: 'Rýchlosť',
    time: 'Čas',
    waveCount: '{n} súbežne',
    finishedOf: 'Dokončených {done} z {total}',
    runStopped: 'Zastavené',
    reconnecting: 'Živé aktualizácie sú pozastavené, obnovuje sa spojenie…',
    planBuilding: 'Plán sa zatiaľ pripravuje.',
    keysMove: 'Šípky: pohyb',
    keysOpen: 'Enter: otvoriť',
    keysClose: 'Esc: zavrieť',
    stop: 'Zastaviť workflow',
    stopConfirm: 'Zastaviť toto workflow a jeho bežiace uzly?',
    stopFailed: 'Workflow sa nepodarilo zastaviť.',
    terminalNode: '{id}: {status}',
    resultFailed: 'Úplný výsledok uzla sa nepodarilo načítať.',
    resultReleased: 'Zobrazuje sa skrátený náhľad; úplný výsledok už nie je v živom prehľade. Celý ho nájdete v konverzácii uzla.',

  },
  access: {
    statusConnected: 'Pripojené',
    statusMissing: 'Chýbajú povinné údaje',
    statusReconnect: 'Treba znova pripojiť',
    statusUnset: 'Nenastavené',
    emptyTitle: 'Žiadne prístupy',
    emptyDescription: 'Žiadny zapnutý plugin nevyžaduje kľúč, token ani heslo.',
    reconnectHint: 'Uložený údaj sa už nedá prečítať. Zadajte ho znova.',
    loadFailed: 'Prístupové údaje tohto pluginu sa nepodarilo načítať.',
    cardDescription: 'Kľúče a heslá tohto pluginu sa nastavujú na jednom mieste, v Nastavenia → Prístupy.',
    open: 'Otvoriť v Prístupoch',
  },
  pluginCfg: {
    roleAdmin: 'Prístup administrátora',
    roleAdminHint: 'Označuje dôveryhodnú rolu administrátora platformy. Projekty a oprávnenia k nástrojom sa naďalej preberajú z prepojeného účtu Chettyho.',
    roleAdminBadge: 'Administrátor',
    sectionConnection: 'Pripojenie a prístupové údaje',
    sectionConnectionHint: 'Tokeny, ID a adresy koncových bodov. Ukladajú sa na serveri a znova sa nezobrazujú.',
    sectionBehavior: 'Správanie',
    back: 'Pluginy',
    invalidJson: 'Pred uložením tejto zmeny zadajte platný JSON.',
    numberRange: 'Povolený rozsah: {min}–{max}.',
    editorEmpty: 'Prázdne',
    editorLines: '{n} riadkov',
    editorItems: '{n} položiek',
    secretSet: 'Uložené',
    secretUnreadable: 'Nečitateľné, zadajte znova',
    secretKeepHint: 'Uložená hodnota zostane nezmenená, kým ju nenahradíte. Nahradenie prázdnou hodnotou ju vymaže.',
    secretReplace: 'Nahradiť',
    secretReplaceHint: 'Uloží sa po opustení poľa alebo klávesom Enter. Prázdne pole uloženú hodnotu vymaže, kláves Esc nahradenie zruší.',
    secretPlaceholder: 'Zadajte hodnotu',
    secretReplacementPlaceholder: 'Zadajte náhradu',
    noProviders: 'Nie je k dispozícii vhodný poskytovateľ. Pridajte ho v Nastaveniach → Chetty AI.',
    catalogProjects: 'Projekty',
    catalogPlugins: 'Pluginy, ktoré možno prideliť',
    timezoneServerDefault: 'Predvolené časové pásmo servera',
    timezoneBrowserDetected: 'Časové pásmo zistené prehliadačom',
    timezoneCatalog: 'Časové pásma',
    timezoneSaved: 'Uložená hodnota',
    timezoneCustom: 'Vlastné časové pásmo IANA',
    timezoneCustomPlaceholder: 'napr. Pacific/Kiritimati',
    userMissing: 'Účet sa nenašiel',
    usersLoadFailed: 'Účty sa nepodarilo načítať',
    tokenListAdd: 'Pridať do poľa {label}',
    tokenListItems: 'Položky poľa {label}',
    tokenListRemove: 'Odobrať {value}',
    tokenListBrowse: 'Prehľadávať adresáre',
    tokenListPlaceholder: 'Hodnota, potom Enter',
    noRoles: 'Zatiaľ žiadne roly',
    noRolesHint: 'Používatelia bez namapovanej roly sú ignorovaní.',
    roleNew: 'Nová rola',
    roleId: 'ID roly',
    roleName: 'Názov',
    rolePrompt: 'Prompt pre rolu',
    addRole: 'Pridať rolu',
    removeRole: 'Odobrať rolu',
    removingRole: 'Odoberanie…',
    removeRoleTitle: 'Odobrať pravidlo roly „{name}“?',
    removeRoleDescription: 'Uložením tohto pravidla sa zmenia oprávnenia používateľov s rolou „{name}“. Môžu stratiť prístup alebo administrátorské oprávnenia.',
    valueRefused: 'Server túto hodnotu odmietol. Skontrolujte zadané údaje a skúste to znova.',
    roleActivationPending: 'Pravidlo roly je uložené. Aktivácia oprávnení počká na dokončenie práve prebiehajúcej práce.',
  },
  terminal: {
    saveError: 'Nepodarilo sa uložiť nastavenia terminálu.',
    fontTitle: 'Písmo',
    fontSize: 'Veľkosť',
    fontFamily: 'Typ písma',
    fonts: { system: 'Systémové', menlo: 'Menlo / Consolas', ibm: 'IBM Plex Mono', courier: 'Courier' },
    cursorTitle: 'Kurzor',
    cursorStyle: 'Štýl',
    cursorBlink: 'Blikanie kurzora',
    cliTitle: 'CLI chat',
    showThoughts: 'Zobrazovať riadky s uvažovaním (Thought) v CLI',
    showThoughtsHelp: 'Riadky s uvažovaním modelu v prepise konverzácie. Rýchle prepnutie: /reasoning show.',
    promptHistoryDepth: 'História promptov',
    promptHistoryDepthHelp: 'Koľko odoslaných promptov si chat uchováva na vyvolanie šípkou nahor. CLI ukladá históriu pre každý projekt na tomto počítači, web pre Váš účet v tomto prehliadači naprieč konverzáciami. Hĺbka sa prenáša s účtom. Rozsah 20–1 000, predvolená hodnota 100.',
    lineUnit: 'riadkov',
    cursorBlock: 'Blok',
    cursorBar: 'Čiara',
    cursorUnderline: 'Podčiarknutie',
    historyTitle: 'História',
    scrollback: 'Riadky',
    scrollbackHelp: 'Koľko riadkov histórie si terminál pamätá.',
    colorsTitle: 'Farby',
    colorsHelp: 'Automatický režim použije tmavú paletu terminálu. Vlastný režim použije vašu paletu.',
    themeMode: 'Farebná téma',
    themeAuto: 'Automaticky',
    themeCustom: 'Vlastné',
    loadPreset: 'Načítať predvoľbu',
    presetPlaceholder: 'Vyberte predvoľbu…',
    palette: {
      background: 'Pozadie', foreground: 'Text', cursor: 'Kurzor', cursorAccent: 'Zvýraznenie kurzora', selectionBackground: 'Výber',
      black: 'Čierna', red: 'Červená', green: 'Zelená', yellow: 'Žltá', blue: 'Modrá', magenta: 'Purpurová', cyan: 'Azúrová', white: 'Biela',
      brightBlack: 'Jasná čierna', brightRed: 'Jasná červená', brightGreen: 'Jasná zelená', brightYellow: 'Jasná žltá', brightBlue: 'Jasná modrá', brightMagenta: 'Jasná purpurová', brightCyan: 'Jasná azúrová', brightWhite: 'Jasná biela',
    },
  },
  cli: {
    // Account → Models. The shared role vocabulary (Model roles, Inherit, Inherited) is read from
    // `settings.modelRoles`, so both pages say the same words for the same thing.
    modelRolesHint: 'Ktorý model používajú vaše konverzácie.',
    chatRuntimeTitle: 'Správanie konverzácie',
    promptSuggestions: 'Návrhy ďalšej správy',
    promptSuggestionsHint: 'Po dokončení odpovede ponúkne návrh vo webe aj CLI. Používa ďalšiu platenú požiadavku na model návrhov ďalšej správy; bez výslovnej voľby to je pomocný model.',
    chatRuntimeHint: 'Ako sa konverzácia správa. Žiadna z týchto volieb nevyberá model.',
    // A stored pick the catalog no longer offers. The runtime does not honour it — the spawn chain
    // skips a refused selection and compaction discards a stale one — so the row names what runs.
    unavailableBadge: 'Nedostupný',
    unavailableSummary: '{model} nie je dostupný. Použije sa {fallback}.',
    unavailableNoFallback: 'bez náhradného modelu',
    projectPinFallback: 'Pre tento projekt sa použije náhradný model {fallback}.',
    inheritUnknown: 'Zdedené',
    unreadableTitle: 'Niektoré uložené nastavenia sa nedajú prečítať',
    unreadableDesc: 'Tieto uložené nastavenia sú poškodené a zobrazujú sa ako prázdne: {names}. Zmeny v nich sa odmietnu, kým ich neobnovíte.',
    unreadableReset: 'Obnoviť nečitateľné nastavenia',
    unreadableResetTitle: 'Obnoviť nečitateľné nastavenia?',
    unreadableResetDesc: 'Poškodené hodnoty sa odstránia a nie je možné ich získať späť. Vaše voľby pre ne začnú od prázdnych.',
    unreadableResetConfirm: 'Obnoviť',
    unreadableResetPending: 'Obnovujem',
    unreadableKeys: {
      autoCompactAtByModel: 'Prahy zhrnutia podľa modelu',
      projectModelPreferences: 'Modely podľa projektu',
      fastModels: 'Modely s rýchlym režimom',
    },
    primaryModelLabel: 'Hlavný model',
    visionModelLabel: 'Záložný model pre obrázky',
    visionInherit: 'Prevziať: {model} (číta obrázky)',
    visionNoFallback: 'Bez náhradného modelu: obrázky sa nebudú spracúvať',
    visionNoFallbackBadge: 'Bez náhradného modelu',
    compactModelLabel: 'Model na skrátenie kontextu',
    projectModelsTitle: 'Modely podľa projektu',
    projectModelsCount: 'Projektov: {n}',
    projectModelsNone: 'Žiadne',
    projectModelsEmpty: 'Zatiaľ žiadny projekt nemá vlastný model.',
    projectModelsClear: 'Zrušiť model pripnutý k projektu {project}',
    instanceModelsTitle: 'Modely inštancie',
    openSettings: 'Otvoriť nastavenia',
    thinkingLabel: 'Úroveň uvažovania',
    thinkingDefault: 'Predvolené',
    autoCompact: 'Automaticky skracovať kontext',
    autoCompactToggle: 'Automaticky skracovať dlhé konverzácie',
    autoCompactAt: 'Skrátiť pri naplnení kontextu',
    compactByModelTitle: 'Skrátenie kontextu podľa modelu',
    compactByModelGlobal: 'Predvolený prah',
    compactByModelGlobalHint: 'Podiel okna kontextu, pri ktorom sa konverzácia skráti. Použije sa pri každom modeli, ktorý má nižšie vlastnú hodnotu.',
    compactByModelOwn: 'vlastné',
    compactByModelFilter: 'Filtrovať modely',
    compactByModelNone: 'Tomuto filtru nezodpovedá žiadny model',
    fastModeTitle: 'Rýchly režim',
    fastModeUnavailable: 'Rýchly režim nie je pre vaše modely dostupný',
    fastModeRoutes: 'Rýchly režim funguje s prihlásením cez ChatGPT, s API kľúčmi OpenAI a Azure OpenAI a s API kľúčom Anthropic, pre modely, ktoré katalóg uvádza s touto funkciou. Modely v predplatnom Claude ho nepodporujú.',
    yoloTitle: 'Režim YOLO',
    yoloToggle: 'Automaticky schvaľovať požiadavky na použitie nástrojov (YOLO)',
    yoloWarning: 'Po zapnutí sa vo všetkých nových reláciách automaticky schvália požiadavky na použitie nástrojov a spustenie príkazov. Pravidlá, ktoré výslovne zakazujú akciu, zostávajú v platnosti. Používajte opatrne.',
    yoloConfirmTitle: 'Povoliť režim YOLO?',
    yoloConfirm: 'Povoliť YOLO',
    unattendedTitle: 'Behy bez dohľadu',
    unattendedAllow: 'Povoliť',
    unattendedDeny: 'Blokovať',
    permTitle: 'Oprávnenia príkazov',
    permToolsTitle: 'Pravidlá nástrojov',
    permEmpty: 'Zatiaľ žiadne pravidlá. Zobrazia sa tu príkazy, ktoré v chate schválite voľbou „Povoliť vždy“.',
    permPatternPlaceholder: 'napr. git status*',
    permAdd: 'Pridať',
    permDeleteTitle: 'Vymazať toto pravidlo?',
    permAllow: 'Povoliť',
    permAsk: 'Opýtať sa',
    permDeny: 'Zakázať',
    permMore: 'a ďalších {n}',
    saveError: 'Uloženie nastavení zlyhalo',
  },
  alerts: {
    bellLabel: 'Oznámenia',
    panelTitle: 'Oznámenia',
    markAllRead: 'Označiť všetko ako prečítané',
    markRead: 'Označiť ako prečítané',
    dismiss: 'Skryť',
    emptyTitle: 'Žiadne oznámenia',
    emptyDescription: 'Nové oznámenia sa zobrazia tu.',
    loadError: 'Oznámenia sa nepodarilo načítať.',
    saveError: 'Nastavenie sa nepodarilo uložiť.',
    prefsTitle: "Oznámenia",
    kinds: "Druhy oznámení",
    kindsHint: "Vyberte, čo sa zobrazí vo zvončeku a na prihlásených zariadeniach. Stlmené druhy nedorazia nikam. Nové druhy sú predvolene zapnuté.",
    enabledCount: "Zapnuté {n} z {total}",
    manage: "Spravovať oznámenia",
  },
  push: {
    title: "Toto zariadenie",
    deviceToggle: "Push oznámenia",
    deniedStatus: "Zablokované",
    denied: "Povoľte oznámenia v nastaveniach webu v prehliadači a potom sa sem vráťte.",
    unsupported: "Nepodporované",
    error: "Oznámenia sa nepodarilo nastaviť.",
    homeScreen: "Pridajte Chetty na plochu",
    homeScreenHint: "V Safari zvoľte Zdieľať → Pridať na plochu. Potom otvorte Chetty z ikony na ploche a povoľte oznámenia.",
    updateRequired: "Aktualizujte iOS",
    updateRequiredHint: "Oznámenia z plochy vyžadujú iOS alebo iPadOS 16.4 či novší.",
    reenable: "Znovu zapnúť",
    reenableHint: "Po zmene kľúča oznámení znovu pripojte toto zariadenie.",
    impersonationHint: "Oznámenia zariadenia nemožno meniť pri zastupovaní iného účtu.",
  },
  assetEditor: {
    search: 'Hľadať…',
    emptySearch: 'Filtru nič nezodpovedá',
    filterAll: 'Všetko',
    filterUser: 'Vlastné',
    filterBuiltin: 'Vstavané',
    colName: 'Názov',
    colSource: 'Zdroj',
    openRow: 'Otvoriť položku: {name}',
    selectRow: 'Vybrať položku: {name} ({scope})',
    selectedCount: 'Vybrané: {n}',
    clearSelection: 'Zrušiť výber',
    bulkEnable: 'Povoliť vybrané',
    bulkDisable: 'Zakázať vybrané',
    bulkDelete: 'Vymazať vybrané',
    bulkDeleteTitle: 'Vymazať vybrané položky?',
    bulkDeleteBody: 'Vymazať vybrané položky ({n})? Túto akciu nemožno vrátiť.',
  },
  desktop: {
    viewerConnection: 'Pripojenie obrazovky',
    controlConnection: 'Pripojenie ovládania',
    moreActions: 'Ďalšie možnosti',
    pictureQuality: 'Kvalita',
    pictureSpeed: 'Rýchlosť',
    dismissNarration: 'Skryť správu agenta',
    enlarge: 'Zväčšiť náhľad',
    closeView: 'Zavrieť náhľad',
    takeControl: 'Prevziať ovládanie',
    returnToAgent: 'Vrátiť agentovi',
    controlledElsewhere: 'Ovládané v inom okne',
    statusClosed: 'Ukončené',
    statusViewerLimit: 'Príliš veľa divákov',
    statusDisconnected: 'Odpojené',
    statusStalled: 'Náhľad sa neobnovuje',
    statusHandoverPending: 'Čaká sa na dokončenie súčasnej akcie',
    statusYouControl: 'Ovládate vy',
    statusUserControl: 'Ovláda používateľ',
    statusWaitingForUser: 'Čaká sa na váš vstup',
    statusAgentControl: 'Ovláda agent',
    statusConnecting: 'Pripájanie',
    connecting: 'Pripája sa obraz obrazovky\u2026',
    unavailable: 'Živý náhľad nie je dostupný',
    openToView: 'Otvorte obrazovku, aby ste ju videli naživo.',
    agentWaiting: 'Agent čaká, kým mu vrátite ovládanie',
    requestFailed: 'Požiadavka na plochu zlyhala.',
  },
  pluginUi: {
    eyebrow: 'Rozšírenie',
    unavailableTitle: 'Rozhranie nie je k dispozícii',
    manage: 'Spravovať pluginy',
    pickerUnavailable: '/{command} z pluginu {plugin} tu nemožno zobraziť.',
    notGranted: 'Tento doplnok nie je k dispozícii. Môže byť vypnutý, chýbať alebo nemusíte mať udelený prístup. Administrátor môže skontrolovať nastavenia pluginov a oprávnenia účtu.',
    incompatible: 'Tento plugin vyžaduje novšiu verziu aplikácie. Na použitie jeho rozhrania aktualizujte server.',
    loadFailed: 'Rozhranie pluginu sa nepodarilo načítať. Skontrolujte záznamy pluginu v Nastavenia → Pluginy.',
    pageMissing: 'Plugin nemá na tejto adrese žiadnu stránku.',
    settingsUnavailable: 'Plugin pre túto sekciu neposkytuje žiadny panel nastavení.',
    crashed: 'V rozhraní pluginu došlo k chybe. Zvyšok aplikácie to neovplyvňuje.',
  },
  help: {
    embeddingDimensions: "Ponechajte prázdne pre predvolenú veľkosť vektora daného modelu.",
    embeddingProvider: 'Kľúč API sa preberá od vybraného poskytovateľa modelu (Nastavenia → Modely).',
    embeddingIntro: 'Prevádza spomienky na vektory, aby sa dali vyhľadávať podľa významu. Platí pre celý pracovný priestor.',
    rolePrompt: 'Ďalšie pokyny, ktoré sa pridávajú do konverzácií tejto roly.',
    projectNotes: "Kontext dostupný asistentovi pri práci v tomto projekte.",
    projectPath: "Absolútna cesta k projektu na disku.",
    projectSlug: "Krátky identifikátor, napr. chetty.",
    computerName: 'Názov, pod ktorým sa tento počítač zobrazuje v projektoch a vo výbere projektu v chate.',
    accountPlatformLinks: 'Prepojte četovací účet, aby asistent na danej platforme rozpoznal vaše správy a sprístupnil vám vaše nástroje a oprávnenia. Zobrazia sa len platformy, ku ktorým je táto inštancia pripojená.',
    accountUiScale: "Rozhranie sa prispôsobí šírke okna. Týmto posuvníkom nastavíte jeho veľkosť oproti normálu (predvolené je 100 %) pre toto zariadenie.",
    memoryRecall: "Po odoslaní vašej správy sa automaticky prehľadá pamäť a najrelevantnejšie spomienky sa pridajú ako kontext k odpovedi.",
    memoryLiveRecall: "Asistent si spomienky vyhľadá znovu aj počas práce, podľa toho, čím sa práve zaoberá — otvorených súborov, spustených nástrojov alebo chýb. Bez toho sa pamäť riadi len vašou úvodnou správou, ktorá o ďalšom priebehu práce nemusí vypovedať.",
    memorySave: "Po odpovedi asistenta sa z konverzácie na pozadí uložia nové trvalé poznatky do vašej pamäte.",
    skillLearning: "Chetty sa občas na pozadí pozrie na poslednú výmenu a uloží opakovane použiteľný postup ako váš osobný skill, dostupný rovnako ako skilly, ktoré si uložíte sami. Neskôr smie vylepšovať iba skilly, ktoré sám napísal; keď skill upravíte, zostane váš. V predvolenom stave je vypnuté.",
    cliAutoCompact: "Keď sa konverzácia blíži k limitu kontextu modelu, zhrnie ju a uvoľní miesto.",
    cliPrimaryModel: "Každá vaša nová konverzácia začína na tomto modeli. Ponechané na dedenie sa riadi predvoleným modelom inštancie.",
    cliProjectModels: "Prepnutie modelu vnútri Git projektu si tento projekt zapamätá a pripnutý model sa potom použije pre každú ďalšiu konverzáciu v ňom. Zrušením sa projekt vráti k vášmu hlavnému modelu.",
    cliInstanceModels: 'Roly platné pre celú inštanciu, teda pomocný model, denný prehľad a embedding, sa nastavujú v Nastaveniach → Modely. Len pre administrátorov.',
    cliThinking: "Koľko úsilia model venuje premýšľaniu, než odpovie. Vyššia úroveň znamená dôkladnejšie, ale pomalšie odpovede; Predvolené ponechá voľbu na modeli. Platí pre hlavný model vyššie.",
    cliVisionModel: "Použije sa pre správy s obrázkami, keď ich hlavný model prečítať nevie. Ponechané na dedenie si obrázky spracuje hlavný model sám — a ak to nevie, riadok to povie.",
    cliCompactModel: "Model, ktorý vykonáva zhrnutie konverzácie — automatické aj ručné príkazom /compact. Môže bežať aj u iného poskytovateľa než model konverzácie (napr. lacnejšieho). Prázdne = zhrnutie vykoná model konverzácie.",
    cliFastMode: 'Vyberte modely, ktoré používajú rýchly režim, vo všetkých konverzáciách aj sub-agentoch. Príkaz /fast ho zapne alebo vypne pre model aktuálnej konverzácie.',
    cliCompactByModel: "Každý model má inak veľký kontext, takže rovnaké percento padne pri každom inde. Nastavte prah zhustenia zvlášť pre vybrané modely; ostatné použijú predvolenú hodnotu nastavenú vyššie.",
    cliUnattendedAsks: 'Výzvy na schválenie sa zobrazujú len v interaktívnom chate (na webe alebo v CLI). Pri behoch bez dozoru, napríklad pri plánovaných úlohách, v kanáloch platforiem a pri sub-agentoch, na ne nikto nemôže odpovedať. Pravidlá „ask“ sa preto buď automaticky povolia (predvolené nastavenie), alebo zablokujú (prísny režim). Výslovné pravidlá allow/deny platia aj naďalej. YOLO prísne blokovanie neprebije.',
    cliPermissions: "Pravidlá pre shellové príkazy, ktoré asistent spúšťa; * zastupuje čokoľvek. Príklady: „git status*“ → Povoliť sa spustí bez otázky, „rm *“ → Zakázať sa vždy zablokuje. Neskoršie pravidlá majú prednosť pred skoršími (vyhráva posledná zhoda) — nové pravidlo sa pridá na koniec a opätovné pridanie existujúceho vzoru ho tam presunie. Shellový príkaz, ktorý nezachytí žiadne pravidlo, sa spustí bez otázky. Objavia sa tu aj príkazy schválené v chate voľbou „Povoliť vždy“.",
    pushEnable: 'Upozorníme vás, keď je odpoveď hotová alebo niečo potrebuje vašu pozornosť, aj keď je aplikácia zatvorená.',
    tokenTtl: "Po koľkých dňoch vyprší prihlasovací token (vynúti nové prihlásenie)",
    pushContact: "Adresa na podpis push notifikácií, aby sa na vás push služba mohla obrátiť kvôli tejto inštancii. Musí byť skutočná a dostupná, inak Apple notifikáciu odmietne. Prázdne pole použije verejnú adresu inštancie.",
    pluginsManage: 'Vstavané pluginy sú súčasťou aplikácie, používateľské sa inštalujú z obchodu. Zapnutie, vypnutie a odstránenie pluginu reštartuje Chettyho. Odstránený vstavaný plugin sa skryje a prestane načítavať; kedykoľvek ho môžete obnoviť v časti Dostupné. Odinštalovaním používateľského pluginu sa odstránia aj jeho súbory.',
    pluginEnable: 'Zapnutie alebo vypnutie sa spojí s ďalšími zmenami v krátkom pokojnom okne a potom reštartuje Chettyho. Rozpracovaná práca sa uloží a po reštarte pokračuje. Čaká sa iba na prácu, v ktorej nemožno pokračovať. Nezodpovedané otázky sa stratia.',
  },
} as const;
